/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Tasks4Staff API
 * Multi-tenant operations platform for cleaning companies. This document is generated from the route definitions and their Zod schemas — the same schemas that validate requests at runtime — so it cannot drift from the behaviour it describes. It is the contract QA verifies against.
 *
 * `info.version` identifies the **deployment that served this document**, not the contract: `<release>+<short commit>` when a release named the build, `0.0.0+<short commit>` when none did — which is every build on pre-prod, where each merge to `main` is deployed and no release names it. A bare `0.0.0` means no deploy pipeline stamped it. `GET /health` reports the same identity in full, with the release tag and the deploy time.
 *
 * **A fact that differs between estates is named per estate, never asserted as one value.** This document is a single artifact, and what every estate serves of it is the same prose — the per-request fields are `servers` and `info.version`, never a description. So where it states something that depends on which estate answered — where a tenant’s web app is published is the case that exists today — it names each estate’s value with the estate attached rather than picking one. The estates are disjoint, with their own databases: a tenant created on one does not exist on the other, so the same label in the other estate is either nothing at all or a different company. The estate answering you is named in `servers` in the document you fetched and in `GET /health`’s `environment`, and any link a deployment mints carries the hostname it actually publishes.
 *
 * **Unknown request-body properties are accepted and ignored.** No request schema here sets `additionalProperties: false`, so a property this document does not define is dropped in silence rather than refused. Do not rely on it: a misspelled property name gets you a 2xx for a request that did not do what you meant, nothing in the response says so, and a later release may refuse the request instead. Send what the schema names, and read a 2xx as "the properties I named were applied" rather than as "everything I sent was understood".
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccessRequest,
  AccessRequestPage,
  AccessRequestSubmitted,
  ActivateAccountRequest,
  ApiError,
  ApproveAccessRequestRequest,
  AssignableRoles,
  Assignment,
  AssignmentBatch,
  AssignmentGroupDeleteResult,
  AssignmentGroupSummary,
  AssignmentPage,
  AssignmentWithNames,
  AssignmentWithNamesPage,
  ChangeOwnPasswordRequest,
  CreateAssignmentBatchRequest,
  CreateAssignmentRequest,
  CreateHintRequest,
  CreateInventoryItemRequest,
  CreateInventoryItemsRequest,
  CreateLinksRequest,
  CreateLocationRequest,
  CreateLocationsRequest,
  CreateRoomRequest,
  CreateRoomsRequest,
  CreateSuperadminRequest,
  CreateTaskRequest,
  CreateTasksRequest,
  CreateTenantRequest,
  CreateTenantResponse,
  CreateUserLinkRequest,
  CreateUserRequest,
  CreatedInventoryItems,
  CreatedLinks,
  CreatedLocations,
  CreatedRooms,
  CreatedTasks,
  CreatedUser,
  CurrentAssignment,
  ExportJob,
  ExportPage,
  ExportProgressTicket,
  ExportsLiveParams,
  FeatureFlagCatalogueEntry,
  GetMyDayParams,
  Hint,
  HintPage,
  HintUsage,
  InventoryItem,
  InventoryItemPage,
  InventoryItemUsage,
  ListAccessRequestsParams,
  ListAssignmentsParams,
  ListExportsParams,
  ListHintsParams,
  ListInventoryItemsParams,
  ListLocationsParams,
  ListMyAssignmentsParams,
  ListMyWorkDatesParams,
  ListReportsParams,
  ListRoomTasksParams,
  ListRoomsParams,
  ListTaskRoomsParams,
  ListTasksParams,
  ListTenantsParams,
  ListUsersParams,
  Location,
  LocationPage,
  LocationUsage,
  LoginRequest,
  Media,
  MintedAccountLinkResponse,
  NewExport,
  PlatformAdmin,
  PlatformBootstrapRequest,
  PlatformLoginRequest,
  PlatformRefreshRequest,
  PlatformSession,
  RefreshRequest,
  Report,
  ReportPage,
  ResetPasswordRequest,
  ResolvedFeatures,
  RetireTenantResponse,
  Room,
  RoomPage,
  RoomTask,
  RoomTaskPage,
  RoomUsage,
  ServiceHealth,
  ServiceInfo,
  Session,
  SetFeatureFlagRequest,
  StartAssignmentRequest,
  StoredWhiteLabelConfig,
  SubmitAccessRequestRequest,
  SubmitReportRequest,
  Task,
  TaskPage,
  TaskRoomPage,
  TaskUsage,
  Tenant,
  TenantBuildKey,
  TenantConfig,
  TenantFeatureFlags,
  TenantPage,
  TenantSuperadmin,
  TokenPair,
  UpdateAssignmentRequest,
  UpdateBrandingRequest,
  UpdateHintRequest,
  UpdateInventoryItemRequest,
  UpdateLocationRequest,
  UpdateOwnProfileRequest,
  UpdateRoomRequest,
  UpdateTaskRequest,
  UpdateTenantRequest,
  UpdateUserRequest,
  User,
  UserPage,
  UserUsage,
  UserWithMintedLink,
  WhiteLabelConfig,
  WorkerDay,
  WorkerJob,
  WorkerWorkDates,
  Worksheet
} from './model';

import { apiFetch } from '../src/fetch.ts';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getServiceInfoResponse200 = {
  data: ServiceInfo
  status: 200
}

export type getServiceInfoResponse500 = {
  data: ApiError
  status: 500
}

export type getServiceInfoResponseSuccess = (getServiceInfoResponse200) & {
  headers: Headers;
};
export type getServiceInfoResponseError = (getServiceInfoResponse500) & {
  headers: Headers;
};

export type getServiceInfoResponse = (getServiceInfoResponseSuccess | getServiceInfoResponseError)

export const getGetServiceInfoUrl = () => {




  return `/`
}

/**
 * Identifies the service and points at its OpenAPI document and Swagger UI.
 * @summary Root greeting
 */
export const getServiceInfo = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getServiceInfoResponse> => {

  return apiFetch<getServiceInfoResponse>(getGetServiceInfoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetServiceInfoQueryKey = () => {
    return [
    `/`
    ] as const;
    }


export const getGetServiceInfoQueryOptions = <TData = Awaited<ReturnType<typeof getServiceInfo>>, TError = ApiError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceInfo>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceInfoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceInfo>>> = ({ signal }) => getServiceInfo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceInfo>>>
export type GetServiceInfoQueryError = ApiError


export function useGetServiceInfo<TData = Awaited<ReturnType<typeof getServiceInfo>>, TError = ApiError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceInfo>>,
          TError,
          Awaited<ReturnType<typeof getServiceInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceInfo<TData = Awaited<ReturnType<typeof getServiceInfo>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceInfo>>,
          TError,
          Awaited<ReturnType<typeof getServiceInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceInfo<TData = Awaited<ReturnType<typeof getServiceInfo>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceInfo>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Root greeting
 */

export function useGetServiceInfo<TData = Awaited<ReturnType<typeof getServiceInfo>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceInfo>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getServiceHealthResponse200 = {
  data: ServiceHealth
  status: 200
}

export type getServiceHealthResponse500 = {
  data: ApiError
  status: 500
}

export type getServiceHealthResponseSuccess = (getServiceHealthResponse200) & {
  headers: Headers;
};
export type getServiceHealthResponseError = (getServiceHealthResponse500) & {
  headers: Headers;
};

export type getServiceHealthResponse = (getServiceHealthResponseSuccess | getServiceHealthResponseError)

export const getGetServiceHealthUrl = () => {




  return `/health`
}

/**
 * Answers 200 whenever the Worker is running. It reports which environment answered and **which build**, and does not touch the database — it is liveness, not readiness.
 *
 * The `build` object is how a verifier confirms *what is deployed* without reading the repository: `build.commit` is the git commit the running code was made from, stamped by the deploy pipeline rather than compiled in. Read it first, and record it in the report — if it disagrees with the commit under test, everything else measured here is measuring something else. The same value abbreviated is the served OpenAPI document’s `info.version`.
 * @summary Liveness probe
 */
export const getServiceHealth = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getServiceHealthResponse> => {

  return apiFetch<getServiceHealthResponse>(getGetServiceHealthUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetServiceHealthQueryKey = () => {
    return [
    `/health`
    ] as const;
    }


export const getGetServiceHealthQueryOptions = <TData = Awaited<ReturnType<typeof getServiceHealth>>, TError = ApiError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceHealthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceHealth>>> = ({ signal }) => getServiceHealth({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceHealth>>>
export type GetServiceHealthQueryError = ApiError


export function useGetServiceHealth<TData = Awaited<ReturnType<typeof getServiceHealth>>, TError = ApiError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceHealth>>,
          TError,
          Awaited<ReturnType<typeof getServiceHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceHealth<TData = Awaited<ReturnType<typeof getServiceHealth>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceHealth>>,
          TError,
          Awaited<ReturnType<typeof getServiceHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceHealth<TData = Awaited<ReturnType<typeof getServiceHealth>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Liveness probe
 */

export function useGetServiceHealth<TData = Awaited<ReturnType<typeof getServiceHealth>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceHealthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type loginResponse200 = {
  data: TokenPair
  status: 200
}

export type loginResponse400 = {
  data: ApiError
  status: 400
}

export type loginResponse401 = {
  data: ApiError
  status: 401
}

export type loginResponse500 = {
  data: ApiError
  status: 500
}

export type loginResponseSuccess = (loginResponse200) & {
  headers: Headers;
};
export type loginResponseError = (loginResponse400 | loginResponse401 | loginResponse500) & {
  headers: Headers;
};

export type loginResponse = (loginResponseSuccess | loginResponseError)

export const getLoginUrl = () => {




  return `/auth/login`
}

/**
 * Exchanges a nickname and password for a token pair. The tenant comes from the `X-Build-Identifier` header — the signed identifier baked into this build — and never from the request body: nicknames are unique per tenant, so the lookup is (this tenant, this nickname). A user of another tenant is simply not found here, whatever their password is.
 * @summary Sign in, inside this build’s tenant
 */
export const login = async (loginRequest: LoginRequest, options?: Parameters<typeof apiFetch>[1]): Promise<loginResponse> => {

  return apiFetch<loginResponse>(getLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loginRequest)
  }
);}





export const getLoginMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: LoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  login(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = LoginRequest
    export type LoginMutationError = ApiError

    /**
 * @summary Sign in, inside this build’s tenant
 */
export const useLogin = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: LoginRequest},
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options), queryClient);
    }

export type refreshTokenPairResponse200 = {
  data: TokenPair
  status: 200
}

export type refreshTokenPairResponse400 = {
  data: ApiError
  status: 400
}

export type refreshTokenPairResponse401 = {
  data: ApiError
  status: 401
}

export type refreshTokenPairResponse500 = {
  data: ApiError
  status: 500
}

export type refreshTokenPairResponseSuccess = (refreshTokenPairResponse200) & {
  headers: Headers;
};
export type refreshTokenPairResponseError = (refreshTokenPairResponse400 | refreshTokenPairResponse401 | refreshTokenPairResponse500) & {
  headers: Headers;
};

export type refreshTokenPairResponse = (refreshTokenPairResponseSuccess | refreshTokenPairResponseError)

export const getRefreshTokenPairUrl = () => {




  return `/auth/refresh`
}

/**
 * Exchanges a refresh token for a **new pair**, and retires the one presented. A refresh token works exactly once: presenting a token that has already been used is treated as a stolen token and ends the whole session, so both halves of the chain stop working. Requires no Authorization header — the refresh token is the credential.
 * @summary Rotate the token pair
 */
export const refreshTokenPair = async (refreshRequest: RefreshRequest, options?: Parameters<typeof apiFetch>[1]): Promise<refreshTokenPairResponse> => {

  return apiFetch<refreshTokenPairResponse>(getRefreshTokenPairUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(refreshRequest)
  }
);}





export const getRefreshTokenPairMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshTokenPair>>, TError,{data: RefreshRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshTokenPair>>, TError,{data: RefreshRequest}, TContext> => {

const mutationKey = ['refreshTokenPair'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshTokenPair>>, {data: RefreshRequest}> = (props) => {
          const {data} = props ?? {};

          return  refreshTokenPair(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshTokenPairMutationResult = NonNullable<Awaited<ReturnType<typeof refreshTokenPair>>>
    export type RefreshTokenPairMutationBody = RefreshRequest
    export type RefreshTokenPairMutationError = ApiError

    /**
 * @summary Rotate the token pair
 */
export const useRefreshTokenPair = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshTokenPair>>, TError,{data: RefreshRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshTokenPair>>,
        TError,
        {data: RefreshRequest},
        TContext
      > => {
      return useMutation(getRefreshTokenPairMutationOptions(options), queryClient);
    }

export type logoutResponse204 = {
  data: void
  status: 204
}

export type logoutResponse400 = {
  data: ApiError
  status: 400
}

export type logoutResponse401 = {
  data: ApiError
  status: 401
}

export type logoutResponse500 = {
  data: ApiError
  status: 500
}

export type logoutResponseSuccess = (logoutResponse204) & {
  headers: Headers;
};
export type logoutResponseError = (logoutResponse400 | logoutResponse401 | logoutResponse500) & {
  headers: Headers;
};

export type logoutResponse = (logoutResponseSuccess | logoutResponseError)

export const getLogoutUrl = () => {




  return `/auth/logout`
}

/**
 * Revokes the session the access token belongs to, **server-side**. Both tokens stop working immediately — this is not a client-side discard. Other sign-ins of the same user are untouched. Calling it twice is not an error.
 * @summary End this session
 */
export const logout = async ( options?: Parameters<typeof apiFetch>[1]): Promise<logoutResponse> => {

  return apiFetch<logoutResponse>(getLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLogoutMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = ['logout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {


          return  logout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

    export type LogoutMutationError = ApiError

    /**
 * @summary End this session
 */
export const useLogout = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options), queryClient);
    }

export type getSessionResponse200 = {
  data: Session
  status: 200
}

export type getSessionResponse400 = {
  data: ApiError
  status: 400
}

export type getSessionResponse401 = {
  data: ApiError
  status: 401
}

export type getSessionResponse500 = {
  data: ApiError
  status: 500
}

export type getSessionResponseSuccess = (getSessionResponse200) & {
  headers: Headers;
};
export type getSessionResponseError = (getSessionResponse400 | getSessionResponse401 | getSessionResponse500) & {
  headers: Headers;
};

export type getSessionResponse = (getSessionResponseSuccess | getSessionResponseError)

export const getGetSessionUrl = () => {




  return `/auth/session`
}

/**
 * Who this access token authenticates, as the database sees it **right now**. The role is re-read on every request, so a change made by an administrator is visible here on the next call without waiting for a token to expire.
 * @summary Describe the current session
 */
export const getSession = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getSessionResponse> => {

  return apiFetch<getSessionResponse>(getGetSessionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSessionQueryKey = () => {
    return [
    `/auth/session`
    ] as const;
    }


export const getGetSessionQueryOptions = <TData = Awaited<ReturnType<typeof getSession>>, TError = ApiError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSession>>> = ({ signal }) => getSession({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getSession>>>
export type GetSessionQueryError = ApiError


export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = ApiError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSession>>,
          TError,
          Awaited<ReturnType<typeof getSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSession>>,
          TError,
          Awaited<ReturnType<typeof getSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Describe the current session
 */

export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSessionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type activateAccountResponse200 = {
  data: TokenPair
  status: 200
}

export type activateAccountResponse400 = {
  data: ApiError
  status: 400
}

export type activateAccountResponse401 = {
  data: ApiError
  status: 401
}

export type activateAccountResponse409 = {
  data: ApiError
  status: 409
}

export type activateAccountResponse500 = {
  data: ApiError
  status: 500
}

export type activateAccountResponseSuccess = (activateAccountResponse200) & {
  headers: Headers;
};
export type activateAccountResponseError = (activateAccountResponse400 | activateAccountResponse401 | activateAccountResponse409 | activateAccountResponse500) & {
  headers: Headers;
};

export type activateAccountResponse = (activateAccountResponseSuccess | activateAccountResponseError)

export const getActivateAccountUrl = () => {




  return `/auth/activate`
}

/**
 * Turns an invite into an account: the person chooses a password — and a nickname if the account has none yet — the account becomes `active`, and the response is a token pair, so there is no separate "now sign in" step. The link works **once** and stops working at its expiry; redeeming it also retires anything else outstanding for the account. The tenant comes from `X-Build-Identifier`, so a link minted for another company is not found here. Omitting `nickname` for an account that has none is a `validation_failed`, because the result would be an active account nobody can name at the sign-in screen.
 * @summary Redeem an invite link and sign in
 */
export const activateAccount = async (activateAccountRequest: ActivateAccountRequest, options?: Parameters<typeof apiFetch>[1]): Promise<activateAccountResponse> => {

  return apiFetch<activateAccountResponse>(getActivateAccountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(activateAccountRequest)
  }
);}





export const getActivateAccountMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateAccount>>, TError,{data: ActivateAccountRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activateAccount>>, TError,{data: ActivateAccountRequest}, TContext> => {

const mutationKey = ['activateAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateAccount>>, {data: ActivateAccountRequest}> = (props) => {
          const {data} = props ?? {};

          return  activateAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof activateAccount>>>
    export type ActivateAccountMutationBody = ActivateAccountRequest
    export type ActivateAccountMutationError = ApiError

    /**
 * @summary Redeem an invite link and sign in
 */
export const useActivateAccount = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateAccount>>, TError,{data: ActivateAccountRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activateAccount>>,
        TError,
        {data: ActivateAccountRequest},
        TContext
      > => {
      return useMutation(getActivateAccountMutationOptions(options), queryClient);
    }

export type resetPasswordResponse200 = {
  data: TokenPair
  status: 200
}

export type resetPasswordResponse400 = {
  data: ApiError
  status: 400
}

export type resetPasswordResponse401 = {
  data: ApiError
  status: 401
}

export type resetPasswordResponse409 = {
  data: ApiError
  status: 409
}

export type resetPasswordResponse500 = {
  data: ApiError
  status: 500
}

export type resetPasswordResponseSuccess = (resetPasswordResponse200) & {
  headers: Headers;
};
export type resetPasswordResponseError = (resetPasswordResponse400 | resetPasswordResponse401 | resetPasswordResponse409 | resetPasswordResponse500) & {
  headers: Headers;
};

export type resetPasswordResponse = (resetPasswordResponseSuccess | resetPasswordResponseError)

export const getResetPasswordUrl = () => {




  return `/auth/reset-password`
}

/**
 * Sets a new password from an administrator-minted link and signs the person in. Every session the account already had ends — the credential they were established with no longer exists. The link works **once** and stops working at its expiry. There is no self-service "forgot password" route in this API: an administrator mints the link.
 * @summary Redeem a password-reset link and sign in
 */
export const resetPassword = async (resetPasswordRequest: ResetPasswordRequest, options?: Parameters<typeof apiFetch>[1]): Promise<resetPasswordResponse> => {

  return apiFetch<resetPasswordResponse>(getResetPasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resetPasswordRequest)
  }
);}





export const getResetPasswordMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequest}, TContext> => {

const mutationKey = ['resetPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, {data: ResetPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  resetPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = ResetPasswordRequest
    export type ResetPasswordMutationError = ApiError

    /**
 * @summary Redeem a password-reset link and sign in
 */
export const useResetPassword = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        {data: ResetPasswordRequest},
        TContext
      > => {
      return useMutation(getResetPasswordMutationOptions(options), queryClient);
    }

export type getTenantConfigResponse200 = {
  data: TenantConfig
  status: 200
}

export type getTenantConfigResponse400 = {
  data: ApiError
  status: 400
}

export type getTenantConfigResponse500 = {
  data: ApiError
  status: 500
}

export type getTenantConfigResponseSuccess = (getTenantConfigResponse200) & {
  headers: Headers;
};
export type getTenantConfigResponseError = (getTenantConfigResponse400 | getTenantConfigResponse500) & {
  headers: Headers;
};

export type getTenantConfigResponse = (getTenantConfigResponseSuccess | getTenantConfigResponseError)

export const getGetTenantConfigUrl = () => {




  return `/tenant/config`
}

/**
 * Everything a branded build needs before anyone signs in: the company name, the runtime branding document, the languages it offers, its business timezone and its resolved feature flags. The tenant is taken from the build key — there is no way to ask for another tenant’s configuration, and the response says nothing about any other tenant, about how many tenants exist, or about which features exist in general.
 * @summary The branding and configuration of this build’s tenant
 */
export const getTenantConfig = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getTenantConfigResponse> => {

  return apiFetch<getTenantConfigResponse>(getGetTenantConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTenantConfigQueryKey = () => {
    return [
    `/tenant/config`
    ] as const;
    }


export const getGetTenantConfigQueryOptions = <TData = Awaited<ReturnType<typeof getTenantConfig>>, TError = ApiError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantConfig>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantConfig>>> = ({ signal }) => getTenantConfig({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenantConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantConfig>>>
export type GetTenantConfigQueryError = ApiError


export function useGetTenantConfig<TData = Awaited<ReturnType<typeof getTenantConfig>>, TError = ApiError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantConfig>>,
          TError,
          Awaited<ReturnType<typeof getTenantConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantConfig<TData = Awaited<ReturnType<typeof getTenantConfig>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantConfig>>,
          TError,
          Awaited<ReturnType<typeof getTenantConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantConfig<TData = Awaited<ReturnType<typeof getTenantConfig>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantConfig>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The branding and configuration of this build’s tenant
 */

export function useGetTenantConfig<TData = Awaited<ReturnType<typeof getTenantConfig>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantConfig>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getBrandingConfigResponse200 = {
  data: WhiteLabelConfig
  status: 200
}

export type getBrandingConfigResponse400 = {
  data: ApiError
  status: 400
}

export type getBrandingConfigResponse429 = {
  data: ApiError
  status: 429
}

export type getBrandingConfigResponse500 = {
  data: ApiError
  status: 500
}

export type getBrandingConfigResponseSuccess = (getBrandingConfigResponse200) & {
  headers: Headers;
};
export type getBrandingConfigResponseError = (getBrandingConfigResponse400 | getBrandingConfigResponse429 | getBrandingConfigResponse500) & {
  headers: Headers;
};

export type getBrandingConfigResponse = (getBrandingConfigResponseSuccess | getBrandingConfigResponseError)

export const getGetBrandingConfigUrl = (slug: string,) => {




  return `/branding/${slug}`
}

/**
 * Public and unauthenticated: this is what a shared, per-tenant-unaware web bundle fetches by hostname before anyone signs in, and what a mobile build's config plugin fetches at build time. **An unknown slug and a retired tenant’s slug answer identically** — 200, with the neutral, unbranded default config — because wildcard DNS makes every possible slug resolve, and a 404 here would let anyone enumerate which slugs are live tenants (`docs/DECISIONS.md`, "The branding config file …"). A live tenant gets its real branding plus its current build key, copied verbatim from the tenant row — nothing is minted, so the same request made twice in a row returns byte-identical bytes unless a rotation happened in between, which is what makes the day-long `Cache-Control` below genuinely honest rather than merely declared. **Never contains a feature flag**: the schema this response validates against has no field for one (`docs/ux/PLATFORM-ADMIN.md` §6.2). The success response is cacheable for a day; every other response is not (see the 500 description).
 *
 * **A stored value this file cannot carry never fails the request.** It is replaced by that field’s fallback and the response is still 200: a brand colour over 64 characters becomes the platform default brand colour `#0B5FFF` (the same as no colour set); a logo URL that is not https://, or is over 2048 characters, becomes `null`; a name over 200 characters is cut to 200; a time zone that is not an IANA name becomes `Europe/Berlin`; unknown or duplicate languages are dropped, and a default language not among the rest becomes the first of them. Every other field is served as stored. The platform console’s `GET /platform/tenants/{tenantId}/branding-config` shows the stored brand colour and logo as they are (`docs/DECISIONS.md`, "A stored branding value outside the config file’s contract is replaced on the public route, and shown verbatim to the console").
 * @summary The white-label branding config file for a tenant slug
 */
export const getBrandingConfig = async (slug: string, options?: Parameters<typeof apiFetch>[1]): Promise<getBrandingConfigResponse> => {

  return apiFetch<getBrandingConfigResponse>(getGetBrandingConfigUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBrandingConfigQueryKey = (slug: string,) => {
    return [
    `/branding/${slug}`
    ] as const;
    }


export const getGetBrandingConfigQueryOptions = <TData = Awaited<ReturnType<typeof getBrandingConfig>>, TError = ApiError>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandingConfig>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrandingConfigQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrandingConfig>>> = ({ signal }) => getBrandingConfig(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrandingConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrandingConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getBrandingConfig>>>
export type GetBrandingConfigQueryError = ApiError


export function useGetBrandingConfig<TData = Awaited<ReturnType<typeof getBrandingConfig>>, TError = ApiError>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandingConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrandingConfig>>,
          TError,
          Awaited<ReturnType<typeof getBrandingConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrandingConfig<TData = Awaited<ReturnType<typeof getBrandingConfig>>, TError = ApiError>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandingConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrandingConfig>>,
          TError,
          Awaited<ReturnType<typeof getBrandingConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrandingConfig<TData = Awaited<ReturnType<typeof getBrandingConfig>>, TError = ApiError>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandingConfig>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The white-label branding config file for a tenant slug
 */

export function useGetBrandingConfig<TData = Awaited<ReturnType<typeof getBrandingConfig>>, TError = ApiError>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandingConfig>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrandingConfigQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getResolvedFeaturesResponse200 = {
  data: ResolvedFeatures
  status: 200
}

export type getResolvedFeaturesResponse400 = {
  data: ApiError
  status: 400
}

export type getResolvedFeaturesResponse401 = {
  data: ApiError
  status: 401
}

export type getResolvedFeaturesResponse500 = {
  data: ApiError
  status: 500
}

export type getResolvedFeaturesResponseSuccess = (getResolvedFeaturesResponse200) & {
  headers: Headers;
};
export type getResolvedFeaturesResponseError = (getResolvedFeaturesResponse400 | getResolvedFeaturesResponse401 | getResolvedFeaturesResponse500) & {
  headers: Headers;
};

export type getResolvedFeaturesResponse = (getResolvedFeaturesResponseSuccess | getResolvedFeaturesResponseError)

export const getGetResolvedFeaturesUrl = () => {




  return `/access/features`
}

/**
 * The calling tenant’s resolved feature map, read from the tenant record on this request — so a flag the platform switched a moment ago is already in effect here. Available to every authenticated role: flags describe the tenant, not the account. The response contains only this tenant’s keys; there is no list of every flag the platform defines, and a key this tenant does not have is absent rather than false. Feature gating is enforced on the routes themselves as well, so switching a flag off is not merely a matter of a client hiding a button.
 * @summary The feature flags resolved for this session’s tenant
 */
export const getResolvedFeatures = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getResolvedFeaturesResponse> => {

  return apiFetch<getResolvedFeaturesResponse>(getGetResolvedFeaturesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetResolvedFeaturesQueryKey = () => {
    return [
    `/access/features`
    ] as const;
    }


export const getGetResolvedFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof getResolvedFeatures>>, TError = ApiError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResolvedFeatures>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResolvedFeaturesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResolvedFeatures>>> = ({ signal }) => getResolvedFeatures({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResolvedFeatures>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResolvedFeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof getResolvedFeatures>>>
export type GetResolvedFeaturesQueryError = ApiError


export function useGetResolvedFeatures<TData = Awaited<ReturnType<typeof getResolvedFeatures>>, TError = ApiError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResolvedFeatures>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResolvedFeatures>>,
          TError,
          Awaited<ReturnType<typeof getResolvedFeatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResolvedFeatures<TData = Awaited<ReturnType<typeof getResolvedFeatures>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResolvedFeatures>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResolvedFeatures>>,
          TError,
          Awaited<ReturnType<typeof getResolvedFeatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResolvedFeatures<TData = Awaited<ReturnType<typeof getResolvedFeatures>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResolvedFeatures>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The feature flags resolved for this session’s tenant
 */

export function useGetResolvedFeatures<TData = Awaited<ReturnType<typeof getResolvedFeatures>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResolvedFeatures>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResolvedFeaturesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listAssignableRolesResponse200 = {
  data: AssignableRoles
  status: 200
}

export type listAssignableRolesResponse400 = {
  data: ApiError
  status: 400
}

export type listAssignableRolesResponse401 = {
  data: ApiError
  status: 401
}

export type listAssignableRolesResponse403 = {
  data: ApiError
  status: 403
}

export type listAssignableRolesResponse500 = {
  data: ApiError
  status: 500
}

export type listAssignableRolesResponseSuccess = (listAssignableRolesResponse200) & {
  headers: Headers;
};
export type listAssignableRolesResponseError = (listAssignableRolesResponse400 | listAssignableRolesResponse401 | listAssignableRolesResponse403 | listAssignableRolesResponse500) & {
  headers: Headers;
};

export type listAssignableRolesResponse = (listAssignableRolesResponseSuccess | listAssignableRolesResponseError)

export const getListAssignableRolesUrl = () => {




  return `/access/assignable-roles`
}

/**
 * The roles this account may assign when it creates or edits a user, lowest first. Requires the `admin` role or higher — an employee administers nobody, so the question does not arise for one. Nobody may assign `superadmin`, and an `admin` may not assign `admin`, so an admin’s list is `["employee"]` and a superadmin’s is `["employee", "admin"]`. Being able to assign a role is **not** the same as being able to act on a particular user: an admin may assign `employee` and still be refused on an employee row it does not own the right to touch — the account being acted upon is checked separately, and answers `target_user_not_permitted`.
 * @summary The roles this account may grant
 */
export const listAssignableRoles = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listAssignableRolesResponse> => {

  return apiFetch<listAssignableRolesResponse>(getListAssignableRolesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAssignableRolesQueryKey = () => {
    return [
    `/access/assignable-roles`
    ] as const;
    }


export const getListAssignableRolesQueryOptions = <TData = Awaited<ReturnType<typeof listAssignableRoles>>, TError = ApiError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssignableRoles>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssignableRolesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssignableRoles>>> = ({ signal }) => listAssignableRoles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssignableRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAssignableRolesQueryResult = NonNullable<Awaited<ReturnType<typeof listAssignableRoles>>>
export type ListAssignableRolesQueryError = ApiError


export function useListAssignableRoles<TData = Awaited<ReturnType<typeof listAssignableRoles>>, TError = ApiError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssignableRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssignableRoles>>,
          TError,
          Awaited<ReturnType<typeof listAssignableRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssignableRoles<TData = Awaited<ReturnType<typeof listAssignableRoles>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssignableRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssignableRoles>>,
          TError,
          Awaited<ReturnType<typeof listAssignableRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssignableRoles<TData = Awaited<ReturnType<typeof listAssignableRoles>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssignableRoles>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The roles this account may grant
 */

export function useListAssignableRoles<TData = Awaited<ReturnType<typeof listAssignableRoles>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssignableRoles>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAssignableRolesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type submitAccessRequestResponse200 = {
  data: AccessRequestSubmitted
  status: 200
}

export type submitAccessRequestResponse400 = {
  data: ApiError
  status: 400
}

export type submitAccessRequestResponse413 = {
  data: ApiError
  status: 413
}

export type submitAccessRequestResponse429 = {
  data: ApiError
  status: 429
}

export type submitAccessRequestResponse500 = {
  data: ApiError
  status: 500
}

export type submitAccessRequestResponse503 = {
  data: ApiError
  status: 503
}

export type submitAccessRequestResponseSuccess = (submitAccessRequestResponse200) & {
  headers: Headers;
};
export type submitAccessRequestResponseError = (submitAccessRequestResponse400 | submitAccessRequestResponse413 | submitAccessRequestResponse429 | submitAccessRequestResponse500 | submitAccessRequestResponse503) & {
  headers: Headers;
};

export type submitAccessRequestResponse = (submitAccessRequestResponseSuccess | submitAccessRequestResponseError)

export const getSubmitAccessRequestUrl = () => {




  return `/auth/request-access`
}

/**
 * The one unauthenticated write in this API. Records an ask to join the tenant this build belongs to, for that tenant’s admins to work off their pending queue. The 200 body never varies with what was found: a brand-new email, a repeat of one already pending, and one belonging to somebody already on staff all answer the same. Checks run in this order, and the first to refuse answers: (1) body size — over 32768 bytes is `413 payload_too_large`; (2) the `X-Build-Identifier` header — `400 build_identifier_required` / `build_identifier_invalid`; (3) the per-address rate limit, 5 per 10 minutes — `429 rate_limited`; (4) the per-tenant rate limit, 20 per 60 minutes — `429 rate_limited`; (5) the body schema — `400 validation_failed`; (6) the Turnstile token — `400 bot_check_failed`, `503 unavailable`, or `500 server_misconfigured`; then the write. **A submission a rate limit lets through consumes a slot in it, whatever happens to it next** — refused by the per-tenant limit, by the schema (malformed), by the bot check, or accepted. A submission refused at (1) or (2) consumes nothing; one refused at (3) consumes nothing; one refused at (4) has spent its per-address slot but no per-tenant one. So malformed and bot-check-failing submissions exhaust both limits exactly as fast as good ones.
 * @summary Ask this tenant for an account
 */
export const submitAccessRequest = async (submitAccessRequestRequest: SubmitAccessRequestRequest, options?: Parameters<typeof apiFetch>[1]): Promise<submitAccessRequestResponse> => {

  return apiFetch<submitAccessRequestResponse>(getSubmitAccessRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submitAccessRequestRequest)
  }
);}





export const getSubmitAccessRequestMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAccessRequest>>, TError,{data: SubmitAccessRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitAccessRequest>>, TError,{data: SubmitAccessRequestRequest}, TContext> => {

const mutationKey = ['submitAccessRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitAccessRequest>>, {data: SubmitAccessRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  submitAccessRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitAccessRequestMutationResult = NonNullable<Awaited<ReturnType<typeof submitAccessRequest>>>
    export type SubmitAccessRequestMutationBody = SubmitAccessRequestRequest
    export type SubmitAccessRequestMutationError = ApiError

    /**
 * @summary Ask this tenant for an account
 */
export const useSubmitAccessRequest = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAccessRequest>>, TError,{data: SubmitAccessRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitAccessRequest>>,
        TError,
        {data: SubmitAccessRequestRequest},
        TContext
      > => {
      return useMutation(getSubmitAccessRequestMutationOptions(options), queryClient);
    }

export type listAccessRequestsResponse200 = {
  data: AccessRequestPage
  status: 200
}

export type listAccessRequestsResponse400 = {
  data: ApiError
  status: 400
}

export type listAccessRequestsResponse401 = {
  data: ApiError
  status: 401
}

export type listAccessRequestsResponse403 = {
  data: ApiError
  status: 403
}

export type listAccessRequestsResponse500 = {
  data: ApiError
  status: 500
}

export type listAccessRequestsResponseSuccess = (listAccessRequestsResponse200) & {
  headers: Headers;
};
export type listAccessRequestsResponseError = (listAccessRequestsResponse400 | listAccessRequestsResponse401 | listAccessRequestsResponse403 | listAccessRequestsResponse500) & {
  headers: Headers;
};

export type listAccessRequestsResponse = (listAccessRequestsResponseSuccess | listAccessRequestsResponseError)

export const getListAccessRequestsUrl = (params?: ListAccessRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["status"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/access-requests?${stringifiedParams}` : `/access-requests`
}

/**
 * A page of this tenant’s requests, filtered by status and sorted oldest-pending-first by default. Nothing here is soft-deletable and nothing is ever removed from it: a reviewed request is the record of who asked and who decided.
 * @summary This tenant’s access-request queue
 */
export const listAccessRequests = async (params?: ListAccessRequestsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listAccessRequestsResponse> => {

  return apiFetch<listAccessRequestsResponse>(getListAccessRequestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccessRequestsQueryKey = (params?: ListAccessRequestsParams,) => {
    return [
    `/access-requests`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAccessRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listAccessRequests>>, TError = ApiError>(params?: ListAccessRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessRequests>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccessRequestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccessRequests>>> = ({ signal }) => listAccessRequests(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccessRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAccessRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccessRequests>>>
export type ListAccessRequestsQueryError = ApiError


export function useListAccessRequests<TData = Awaited<ReturnType<typeof listAccessRequests>>, TError = ApiError>(
 params: undefined |  ListAccessRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccessRequests>>,
          TError,
          Awaited<ReturnType<typeof listAccessRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAccessRequests<TData = Awaited<ReturnType<typeof listAccessRequests>>, TError = ApiError>(
 params?: ListAccessRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccessRequests>>,
          TError,
          Awaited<ReturnType<typeof listAccessRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAccessRequests<TData = Awaited<ReturnType<typeof listAccessRequests>>, TError = ApiError>(
 params?: ListAccessRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessRequests>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary This tenant’s access-request queue
 */

export function useListAccessRequests<TData = Awaited<ReturnType<typeof listAccessRequests>>, TError = ApiError>(
 params?: ListAccessRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessRequests>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAccessRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getAccessRequestResponse200 = {
  data: AccessRequest
  status: 200
}

export type getAccessRequestResponse400 = {
  data: ApiError
  status: 400
}

export type getAccessRequestResponse401 = {
  data: ApiError
  status: 401
}

export type getAccessRequestResponse403 = {
  data: ApiError
  status: 403
}

export type getAccessRequestResponse404 = {
  data: ApiError
  status: 404
}

export type getAccessRequestResponse500 = {
  data: ApiError
  status: 500
}

export type getAccessRequestResponseSuccess = (getAccessRequestResponse200) & {
  headers: Headers;
};
export type getAccessRequestResponseError = (getAccessRequestResponse400 | getAccessRequestResponse401 | getAccessRequestResponse403 | getAccessRequestResponse404 | getAccessRequestResponse500) & {
  headers: Headers;
};

export type getAccessRequestResponse = (getAccessRequestResponseSuccess | getAccessRequestResponseError)

export const getGetAccessRequestUrl = (id: string,) => {




  return `/access-requests/${id}`
}

/**
 * @summary One access request
 */
export const getAccessRequest = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getAccessRequestResponse> => {

  return apiFetch<getAccessRequestResponse>(getGetAccessRequestUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccessRequestQueryKey = (id: string,) => {
    return [
    `/access-requests/${id}`
    ] as const;
    }


export const getGetAccessRequestQueryOptions = <TData = Awaited<ReturnType<typeof getAccessRequest>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessRequest>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccessRequestQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessRequest>>> = ({ signal }) => getAccessRequest(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccessRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccessRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessRequest>>>
export type GetAccessRequestQueryError = ApiError


export function useGetAccessRequest<TData = Awaited<ReturnType<typeof getAccessRequest>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessRequest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessRequest>>,
          TError,
          Awaited<ReturnType<typeof getAccessRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessRequest<TData = Awaited<ReturnType<typeof getAccessRequest>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessRequest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessRequest>>,
          TError,
          Awaited<ReturnType<typeof getAccessRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessRequest<TData = Awaited<ReturnType<typeof getAccessRequest>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessRequest>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One access request
 */

export function useGetAccessRequest<TData = Awaited<ReturnType<typeof getAccessRequest>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessRequest>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccessRequestQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type approveAccessRequestResponse200 = {
  data: CreatedUser
  status: 200
}

export type approveAccessRequestResponse400 = {
  data: ApiError
  status: 400
}

export type approveAccessRequestResponse401 = {
  data: ApiError
  status: 401
}

export type approveAccessRequestResponse403 = {
  data: ApiError
  status: 403
}

export type approveAccessRequestResponse404 = {
  data: ApiError
  status: 404
}

export type approveAccessRequestResponse409 = {
  data: ApiError
  status: 409
}

export type approveAccessRequestResponse500 = {
  data: ApiError
  status: 500
}

export type approveAccessRequestResponseSuccess = (approveAccessRequestResponse200) & {
  headers: Headers;
};
export type approveAccessRequestResponseError = (approveAccessRequestResponse400 | approveAccessRequestResponse401 | approveAccessRequestResponse403 | approveAccessRequestResponse404 | approveAccessRequestResponse409 | approveAccessRequestResponse500) & {
  headers: Headers;
};

export type approveAccessRequestResponse = (approveAccessRequestResponseSuccess | approveAccessRequestResponseError)

export const getApproveAccessRequestUrl = (id: string,) => {




  return `/access-requests/${id}/approve`
}

/**
 * Creates a `pending` account and mints its invite in the same operation `POST /users` does — this **is** that operation, called on the requester’s behalf — and marks the request `approved`. Every guard `POST /users` enforces applies unchanged: nobody may grant `superadmin`, and an `admin` may not grant `admin`. Only a `pending` request may be approved.
 * @summary Convert a request into an invite
 */
export const approveAccessRequest = async (id: string,
    approveAccessRequestRequest: ApproveAccessRequestRequest, options?: Parameters<typeof apiFetch>[1]): Promise<approveAccessRequestResponse> => {

  return apiFetch<approveAccessRequestResponse>(getApproveAccessRequestUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(approveAccessRequestRequest)
  }
);}





export const getApproveAccessRequestMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAccessRequest>>, TError,{id: string;data: ApproveAccessRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveAccessRequest>>, TError,{id: string;data: ApproveAccessRequestRequest}, TContext> => {

const mutationKey = ['approveAccessRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAccessRequest>>, {id: string;data: ApproveAccessRequestRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  approveAccessRequest(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveAccessRequestMutationResult = NonNullable<Awaited<ReturnType<typeof approveAccessRequest>>>
    export type ApproveAccessRequestMutationBody = ApproveAccessRequestRequest
    export type ApproveAccessRequestMutationError = ApiError

    /**
 * @summary Convert a request into an invite
 */
export const useApproveAccessRequest = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAccessRequest>>, TError,{id: string;data: ApproveAccessRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveAccessRequest>>,
        TError,
        {id: string;data: ApproveAccessRequestRequest},
        TContext
      > => {
      return useMutation(getApproveAccessRequestMutationOptions(options), queryClient);
    }

export type rejectAccessRequestResponse200 = {
  data: AccessRequest
  status: 200
}

export type rejectAccessRequestResponse400 = {
  data: ApiError
  status: 400
}

export type rejectAccessRequestResponse401 = {
  data: ApiError
  status: 401
}

export type rejectAccessRequestResponse403 = {
  data: ApiError
  status: 403
}

export type rejectAccessRequestResponse404 = {
  data: ApiError
  status: 404
}

export type rejectAccessRequestResponse409 = {
  data: ApiError
  status: 409
}

export type rejectAccessRequestResponse500 = {
  data: ApiError
  status: 500
}

export type rejectAccessRequestResponseSuccess = (rejectAccessRequestResponse200) & {
  headers: Headers;
};
export type rejectAccessRequestResponseError = (rejectAccessRequestResponse400 | rejectAccessRequestResponse401 | rejectAccessRequestResponse403 | rejectAccessRequestResponse404 | rejectAccessRequestResponse409 | rejectAccessRequestResponse500) & {
  headers: Headers;
};

export type rejectAccessRequestResponse = (rejectAccessRequestResponseSuccess | rejectAccessRequestResponseError)

export const getRejectAccessRequestUrl = (id: string,) => {




  return `/access-requests/${id}/reject`
}

/**
 * Marks a `pending` request `rejected`. Nothing is deleted and nobody is notified — there is no email in this system (`docs/DECISIONS.md`, "Email — none") — the requester’s own contact details stay on the row for an admin who wants to reach them directly. Only a `pending` request may be rejected.
 * @summary Decline a request
 */
export const rejectAccessRequest = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<rejectAccessRequestResponse> => {

  return apiFetch<rejectAccessRequestResponse>(getRejectAccessRequestUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRejectAccessRequestMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAccessRequest>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectAccessRequest>>, TError,{id: string}, TContext> => {

const mutationKey = ['rejectAccessRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectAccessRequest>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  rejectAccessRequest(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectAccessRequestMutationResult = NonNullable<Awaited<ReturnType<typeof rejectAccessRequest>>>

    export type RejectAccessRequestMutationError = ApiError

    /**
 * @summary Decline a request
 */
export const useRejectAccessRequest = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAccessRequest>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectAccessRequest>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRejectAccessRequestMutationOptions(options), queryClient);
    }

export type listUsersResponse200 = {
  data: UserPage
  status: 200
}

export type listUsersResponse400 = {
  data: ApiError
  status: 400
}

export type listUsersResponse401 = {
  data: ApiError
  status: 401
}

export type listUsersResponse403 = {
  data: ApiError
  status: 403
}

export type listUsersResponse500 = {
  data: ApiError
  status: 500
}

export type listUsersResponseSuccess = (listUsersResponse200) & {
  headers: Headers;
};
export type listUsersResponseError = (listUsersResponse400 | listUsersResponse401 | listUsersResponse403 | listUsersResponse500) & {
  headers: Headers;
};

export type listUsersResponse = (listUsersResponseSuccess | listUsersResponseError)

export const getListUsersUrl = (params?: ListUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["role","status"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/users?${stringifiedParams}` : `/users`
}

/**
 * A page of the people in the calling session’s tenant, filtered, searched and sorted. Soft-deleted accounts are absent. **Every** row is listed to any administrator, including the ones they may not administer — a list that hid colleagues would lie about who exists, and an administrator who cannot see a superadmin cannot understand why a nickname is taken. What an administrator may *do* to a row is answered per operation, not by omitting the row.
 * @summary List this tenant’s people
 */
export const listUsers = async (params?: ListUsersParams, options?: Parameters<typeof apiFetch>[1]): Promise<listUsersResponse> => {

  return apiFetch<listUsersResponse>(getListUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUsersQueryKey = (params?: ListUsersParams,) => {
    return [
    `/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = ApiError>(params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = ApiError


export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ApiError>(
 params: undefined |  ListUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ApiError>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ApiError>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List this tenant’s people
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ApiError>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createUserResponse201 = {
  data: CreatedUser
  status: 201
}

export type createUserResponse400 = {
  data: ApiError
  status: 400
}

export type createUserResponse401 = {
  data: ApiError
  status: 401
}

export type createUserResponse403 = {
  data: ApiError
  status: 403
}

export type createUserResponse500 = {
  data: ApiError
  status: 500
}

export type createUserResponseSuccess = (createUserResponse201) & {
  headers: Headers;
};
export type createUserResponseError = (createUserResponse400 | createUserResponse401 | createUserResponse403 | createUserResponse500) & {
  headers: Headers;
};

export type createUserResponse = (createUserResponseSuccess | createUserResponseError)

export const getCreateUserUrl = () => {




  return `/users`
}

/**
 * Creates a `pending` account with no nickname and no password, and returns the invite link in the same response. The two are one operation because there is no email in this system: an account nobody can be handed a link to is an account nobody can use. The token is in the response **once** — store it or hand it over now.
 * @summary Create an account and mint its invite
 */
export const createUser = async (createUserRequest: CreateUserRequest, options?: Parameters<typeof apiFetch>[1]): Promise<createUserResponse> => {

  return apiFetch<createUserResponse>(getCreateUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createUserRequest)
  }
);}





export const getCreateUserMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserRequest}, TContext> => {

const mutationKey = ['createUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUser>>, {data: CreateUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  createUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
    export type CreateUserMutationBody = CreateUserRequest
    export type CreateUserMutationError = ApiError

    /**
 * @summary Create an account and mint its invite
 */
export const useCreateUser = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUser>>,
        TError,
        {data: CreateUserRequest},
        TContext
      > => {
      return useMutation(getCreateUserMutationOptions(options), queryClient);
    }

export type getUserResponse200 = {
  data: User
  status: 200
}

export type getUserResponse400 = {
  data: ApiError
  status: 400
}

export type getUserResponse401 = {
  data: ApiError
  status: 401
}

export type getUserResponse403 = {
  data: ApiError
  status: 403
}

export type getUserResponse404 = {
  data: ApiError
  status: 404
}

export type getUserResponse500 = {
  data: ApiError
  status: 500
}

export type getUserResponseSuccess = (getUserResponse200) & {
  headers: Headers;
};
export type getUserResponseError = (getUserResponse400 | getUserResponse401 | getUserResponse403 | getUserResponse404 | getUserResponse500) & {
  headers: Headers;
};

export type getUserResponse = (getUserResponseSuccess | getUserResponseError)

export const getGetUserUrl = (id: string,) => {




  return `/users/${id}`
}

/**
 * Everything an administrator may know about one account, including the state of its most recent invite and reset links — and never their tokens.
 * @summary One person’s record
 */
export const getUser = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getUserResponse> => {

  return apiFetch<getUserResponse>(getGetUserUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserQueryKey = (id: string,) => {
    return [
    `/users/${id}`
    ] as const;
    }


export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = ApiError


export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One person’s record
 */

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type updateUserResponse200 = {
  data: User
  status: 200
}

export type updateUserResponse400 = {
  data: ApiError
  status: 400
}

export type updateUserResponse401 = {
  data: ApiError
  status: 401
}

export type updateUserResponse403 = {
  data: ApiError
  status: 403
}

export type updateUserResponse404 = {
  data: ApiError
  status: 404
}

export type updateUserResponse409 = {
  data: ApiError
  status: 409
}

export type updateUserResponse500 = {
  data: ApiError
  status: 500
}

export type updateUserResponseSuccess = (updateUserResponse200) & {
  headers: Headers;
};
export type updateUserResponseError = (updateUserResponse400 | updateUserResponse401 | updateUserResponse403 | updateUserResponse404 | updateUserResponse409 | updateUserResponse500) & {
  headers: Headers;
};

export type updateUserResponse = (updateUserResponseSuccess | updateUserResponseError)

export const getUpdateUserUrl = (id: string,) => {




  return `/users/${id}`
}

/**
 * Changes the fields you send and leaves the rest, and a body that sends none of them changes nothing rather than failing. Changing the **role** is checked twice: that you may administer that person at all, and that you may assign the role you asked for. There is no password field on this operation, and there will not be one.
 * @summary Edit a person’s name, nickname, role or note
 */
export const updateUser = async (id: string,
    updateUserRequest: UpdateUserRequest, options?: Parameters<typeof apiFetch>[1]): Promise<updateUserResponse> => {

  return apiFetch<updateUserResponse>(getUpdateUserUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateUserRequest)
  }
);}





export const getUpdateUserMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: string;data: UpdateUserRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: string;data: UpdateUserRequest}, TContext> => {

const mutationKey = ['updateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, {id: string;data: UpdateUserRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUser(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = UpdateUserRequest
    export type UpdateUserMutationError = ApiError

    /**
 * @summary Edit a person’s name, nickname, role or note
 */
export const useUpdateUser = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: string;data: UpdateUserRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        {id: string;data: UpdateUserRequest},
        TContext
      > => {
      return useMutation(getUpdateUserMutationOptions(options), queryClient);
    }

export type deleteUserResponse204 = {
  data: void
  status: 204
}

export type deleteUserResponse400 = {
  data: ApiError
  status: 400
}

export type deleteUserResponse401 = {
  data: ApiError
  status: 401
}

export type deleteUserResponse403 = {
  data: ApiError
  status: 403
}

export type deleteUserResponse404 = {
  data: ApiError
  status: 404
}

export type deleteUserResponse500 = {
  data: ApiError
  status: 500
}

export type deleteUserResponseSuccess = (deleteUserResponse204) & {
  headers: Headers;
};
export type deleteUserResponseError = (deleteUserResponse400 | deleteUserResponse401 | deleteUserResponse403 | deleteUserResponse404 | deleteUserResponse500) & {
  headers: Headers;
};

export type deleteUserResponse = (deleteUserResponseSuccess | deleteUserResponseError)

export const getDeleteUserUrl = (id: string,) => {




  return `/users/${id}`
}

/**
 * A soft delete, and there is no undo. Their reports and past assignments **stay**, with their name on them: a report is the record of work somebody was paid for. Their future assignments also stay, and become work nobody is going to do — ask `GET /users/{id}/usage` before confirming. Their outstanding links stop working, and a link that somehow survives is refused on redemption anyway. Their nickname becomes available to somebody else.
 * @summary Delete a person’s account
 */
export const deleteUser = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<deleteUserResponse> => {

  return apiFetch<deleteUserResponse>(getDeleteUserUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteUserMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>

    export type DeleteUserMutationError = ApiError

    /**
 * @summary Delete a person’s account
 */
export const useDeleteUser = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteUserMutationOptions(options), queryClient);
    }

export type disableUserResponse200 = {
  data: User
  status: 200
}

export type disableUserResponse400 = {
  data: ApiError
  status: 400
}

export type disableUserResponse401 = {
  data: ApiError
  status: 401
}

export type disableUserResponse403 = {
  data: ApiError
  status: 403
}

export type disableUserResponse404 = {
  data: ApiError
  status: 404
}

export type disableUserResponse500 = {
  data: ApiError
  status: 500
}

export type disableUserResponseSuccess = (disableUserResponse200) & {
  headers: Headers;
};
export type disableUserResponseError = (disableUserResponse400 | disableUserResponse401 | disableUserResponse403 | disableUserResponse404 | disableUserResponse500) & {
  headers: Headers;
};

export type disableUserResponse = (disableUserResponseSuccess | disableUserResponseError)

export const getDisableUserUrl = (id: string,) => {




  return `/users/${id}/disable`
}

/**
 * Four things happen, and a confirmation should name all of them. They cannot sign in. Their existing sessions end **now** — on their next request, not when a token happens to expire. Their outstanding invite or reset link stops working. Their past work is untouched, and so is their future work: `GET /users/{id}/usage` says how much of it has just been left to somebody who can no longer open the app.
 * @summary Stop somebody signing in, reversibly
 */
export const disableUser = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<disableUserResponse> => {

  return apiFetch<disableUserResponse>(getDisableUserUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDisableUserMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disableUser>>, TError,{id: string}, TContext> => {

const mutationKey = ['disableUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  disableUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableUserMutationResult = NonNullable<Awaited<ReturnType<typeof disableUser>>>

    export type DisableUserMutationError = ApiError

    /**
 * @summary Stop somebody signing in, reversibly
 */
export const useDisableUser = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableUser>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDisableUserMutationOptions(options), queryClient);
    }

export type enableUserResponse200 = {
  data: User
  status: 200
}

export type enableUserResponse400 = {
  data: ApiError
  status: 400
}

export type enableUserResponse401 = {
  data: ApiError
  status: 401
}

export type enableUserResponse403 = {
  data: ApiError
  status: 403
}

export type enableUserResponse404 = {
  data: ApiError
  status: 404
}

export type enableUserResponse500 = {
  data: ApiError
  status: 500
}

export type enableUserResponseSuccess = (enableUserResponse200) & {
  headers: Headers;
};
export type enableUserResponseError = (enableUserResponse400 | enableUserResponse401 | enableUserResponse403 | enableUserResponse404 | enableUserResponse500) & {
  headers: Headers;
};

export type enableUserResponse = (enableUserResponseSuccess | enableUserResponseError)

export const getEnableUserUrl = (id: string,) => {




  return `/users/${id}/enable`
}

/**
 * Restores sign-in and nothing else: it mints no link and resurrects no revoked one. The status it restores is the account’s own — somebody who never redeemed their invite has no password, so they go back to `pending` and need a fresh invite, while somebody who has one goes back to `active`.
 * @summary Let somebody sign in again
 */
export const enableUser = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<enableUserResponse> => {

  return apiFetch<enableUserResponse>(getEnableUserUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getEnableUserMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof enableUser>>, TError,{id: string}, TContext> => {

const mutationKey = ['enableUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  enableUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableUserMutationResult = NonNullable<Awaited<ReturnType<typeof enableUser>>>

    export type EnableUserMutationError = ApiError

    /**
 * @summary Let somebody sign in again
 */
export const useEnableUser = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableUser>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getEnableUserMutationOptions(options), queryClient);
    }

export type getUserUsageResponse200 = {
  data: UserUsage
  status: 200
}

export type getUserUsageResponse400 = {
  data: ApiError
  status: 400
}

export type getUserUsageResponse401 = {
  data: ApiError
  status: 401
}

export type getUserUsageResponse403 = {
  data: ApiError
  status: 403
}

export type getUserUsageResponse404 = {
  data: ApiError
  status: 404
}

export type getUserUsageResponse500 = {
  data: ApiError
  status: 500
}

export type getUserUsageResponseSuccess = (getUserUsageResponse200) & {
  headers: Headers;
};
export type getUserUsageResponseError = (getUserUsageResponse400 | getUserUsageResponse401 | getUserUsageResponse403 | getUserUsageResponse404 | getUserUsageResponse500) & {
  headers: Headers;
};

export type getUserUsageResponse = (getUserUsageResponseSuccess | getUserUsageResponseError)

export const getGetUserUsageUrl = (id: string,) => {




  return `/users/${id}/usage`
}

/**
 * Read this before a destructive confirmation, so the sentence can name a number rather than guess one. "Future" means dated today or later **in the tenant’s timezone**, and the date used is in the response so a client can say what it counted.
 * @summary What disabling or deleting this person would strand
 */
export const getUserUsage = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getUserUsageResponse> => {

  return apiFetch<getUserUsageResponse>(getGetUserUsageUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserUsageQueryKey = (id: string,) => {
    return [
    `/users/${id}/usage`
    ] as const;
    }


export const getGetUserUsageQueryOptions = <TData = Awaited<ReturnType<typeof getUserUsage>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserUsageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserUsage>>> = ({ signal }) => getUserUsage(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getUserUsage>>>
export type GetUserUsageQueryError = ApiError


export function useGetUserUsage<TData = Awaited<ReturnType<typeof getUserUsage>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserUsage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserUsage>>,
          TError,
          Awaited<ReturnType<typeof getUserUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserUsage<TData = Awaited<ReturnType<typeof getUserUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserUsage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserUsage>>,
          TError,
          Awaited<ReturnType<typeof getUserUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserUsage<TData = Awaited<ReturnType<typeof getUserUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What disabling or deleting this person would strand
 */

export function useGetUserUsage<TData = Awaited<ReturnType<typeof getUserUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserUsageQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createUserLinkResponse201 = {
  data: UserWithMintedLink
  status: 201
}

export type createUserLinkResponse400 = {
  data: ApiError
  status: 400
}

export type createUserLinkResponse401 = {
  data: ApiError
  status: 401
}

export type createUserLinkResponse403 = {
  data: ApiError
  status: 403
}

export type createUserLinkResponse404 = {
  data: ApiError
  status: 404
}

export type createUserLinkResponse409 = {
  data: ApiError
  status: 409
}

export type createUserLinkResponse500 = {
  data: ApiError
  status: 500
}

export type createUserLinkResponseSuccess = (createUserLinkResponse201) & {
  headers: Headers;
};
export type createUserLinkResponseError = (createUserLinkResponse400 | createUserLinkResponse401 | createUserLinkResponse403 | createUserLinkResponse404 | createUserLinkResponse409 | createUserLinkResponse500) & {
  headers: Headers;
};

export type createUserLinkResponse = (createUserLinkResponseSuccess | createUserLinkResponseError)

export const getCreateUserLinkUrl = (id: string,) => {




  return `/users/${id}/links`
}

/**
 * Returns the link’s token **once**. Minting revokes whatever link of the same purpose was outstanding, so one account never has two valid invites circulating — that is what makes revoking one mean something. Which purpose is available follows the account’s status: `invite` for one that has never been activated, `password_reset` for an active one, and neither for a disabled one.
 * @summary Mint an invite or a password-reset link
 */
export const createUserLink = async (id: string,
    createUserLinkRequest: CreateUserLinkRequest, options?: Parameters<typeof apiFetch>[1]): Promise<createUserLinkResponse> => {

  return apiFetch<createUserLinkResponse>(getCreateUserLinkUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createUserLinkRequest)
  }
);}





export const getCreateUserLinkMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserLink>>, TError,{id: string;data: CreateUserLinkRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUserLink>>, TError,{id: string;data: CreateUserLinkRequest}, TContext> => {

const mutationKey = ['createUserLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserLink>>, {id: string;data: CreateUserLinkRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  createUserLink(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserLinkMutationResult = NonNullable<Awaited<ReturnType<typeof createUserLink>>>
    export type CreateUserLinkMutationBody = CreateUserLinkRequest
    export type CreateUserLinkMutationError = ApiError

    /**
 * @summary Mint an invite or a password-reset link
 */
export const useCreateUserLink = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserLink>>, TError,{id: string;data: CreateUserLinkRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUserLink>>,
        TError,
        {id: string;data: CreateUserLinkRequest},
        TContext
      > => {
      return useMutation(getCreateUserLinkMutationOptions(options), queryClient);
    }

export type revokeUserLinkResponse200 = {
  data: User
  status: 200
}

export type revokeUserLinkResponse400 = {
  data: ApiError
  status: 400
}

export type revokeUserLinkResponse401 = {
  data: ApiError
  status: 401
}

export type revokeUserLinkResponse403 = {
  data: ApiError
  status: 403
}

export type revokeUserLinkResponse404 = {
  data: ApiError
  status: 404
}

export type revokeUserLinkResponse409 = {
  data: ApiError
  status: 409
}

export type revokeUserLinkResponse500 = {
  data: ApiError
  status: 500
}

export type revokeUserLinkResponseSuccess = (revokeUserLinkResponse200) & {
  headers: Headers;
};
export type revokeUserLinkResponseError = (revokeUserLinkResponse400 | revokeUserLinkResponse401 | revokeUserLinkResponse403 | revokeUserLinkResponse404 | revokeUserLinkResponse409 | revokeUserLinkResponse500) & {
  headers: Headers;
};

export type revokeUserLinkResponse = (revokeUserLinkResponseSuccess | revokeUserLinkResponseError)

export const getRevokeUserLinkUrl = (id: string,
    purpose: 'invite' | 'password_reset',) => {




  return `/users/${id}/links/${purpose}`
}

/**
 * Anyone holding that link can no longer use it, and the person will need a new one. A link that has already **expired** or already been revoked is not an error — the outcome you asked for is the outcome that holds. A link that has already been **redeemed** answers `link_already_used`: nothing is outstanding, and the row has simply moved on.
 * @summary Withdraw an outstanding link
 */
export const revokeUserLink = async (id: string,
    purpose: 'invite' | 'password_reset', options?: Parameters<typeof apiFetch>[1]): Promise<revokeUserLinkResponse> => {

  return apiFetch<revokeUserLinkResponse>(getRevokeUserLinkUrl(id,purpose),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeUserLinkMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeUserLink>>, TError,{id: string;purpose: 'invite' | 'password_reset'}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeUserLink>>, TError,{id: string;purpose: 'invite' | 'password_reset'}, TContext> => {

const mutationKey = ['revokeUserLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeUserLink>>, {id: string;purpose: 'invite' | 'password_reset'}> = (props) => {
          const {id,purpose} = props ?? {};

          return  revokeUserLink(id,purpose,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeUserLinkMutationResult = NonNullable<Awaited<ReturnType<typeof revokeUserLink>>>

    export type RevokeUserLinkMutationError = ApiError

    /**
 * @summary Withdraw an outstanding link
 */
export const useRevokeUserLink = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeUserLink>>, TError,{id: string;purpose: 'invite' | 'password_reset'}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeUserLink>>,
        TError,
        {id: string;purpose: 'invite' | 'password_reset'},
        TContext
      > => {
      return useMutation(getRevokeUserLinkMutationOptions(options), queryClient);
    }

export type updateOwnProfileResponse200 = {
  data: User
  status: 200
}

export type updateOwnProfileResponse400 = {
  data: ApiError
  status: 400
}

export type updateOwnProfileResponse401 = {
  data: ApiError
  status: 401
}

export type updateOwnProfileResponse404 = {
  data: ApiError
  status: 404
}

export type updateOwnProfileResponse409 = {
  data: ApiError
  status: 409
}

export type updateOwnProfileResponse500 = {
  data: ApiError
  status: 500
}

export type updateOwnProfileResponseSuccess = (updateOwnProfileResponse200) & {
  headers: Headers;
};
export type updateOwnProfileResponseError = (updateOwnProfileResponse400 | updateOwnProfileResponse401 | updateOwnProfileResponse404 | updateOwnProfileResponse409 | updateOwnProfileResponse500) & {
  headers: Headers;
};

export type updateOwnProfileResponse = (updateOwnProfileResponseSuccess | updateOwnProfileResponseError)

export const getUpdateOwnProfileUrl = () => {




  return `/me`
}

/**
 * Changes the fields you send on **your own** account, and changes nothing — 200, with your record unchanged — if you send neither. There is no id: the account is the session’s. Available to every authenticated role — an employee may correct their own name without an administrator.
 * @summary Edit your own name and nickname
 */
export const updateOwnProfile = async (updateOwnProfileRequest: UpdateOwnProfileRequest, options?: Parameters<typeof apiFetch>[1]): Promise<updateOwnProfileResponse> => {

  return apiFetch<updateOwnProfileResponse>(getUpdateOwnProfileUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateOwnProfileRequest)
  }
);}





export const getUpdateOwnProfileMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwnProfile>>, TError,{data: UpdateOwnProfileRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOwnProfile>>, TError,{data: UpdateOwnProfileRequest}, TContext> => {

const mutationKey = ['updateOwnProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOwnProfile>>, {data: UpdateOwnProfileRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateOwnProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOwnProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateOwnProfile>>>
    export type UpdateOwnProfileMutationBody = UpdateOwnProfileRequest
    export type UpdateOwnProfileMutationError = ApiError

    /**
 * @summary Edit your own name and nickname
 */
export const useUpdateOwnProfile = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwnProfile>>, TError,{data: UpdateOwnProfileRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOwnProfile>>,
        TError,
        {data: UpdateOwnProfileRequest},
        TContext
      > => {
      return useMutation(getUpdateOwnProfileMutationOptions(options), queryClient);
    }

export type changeOwnPasswordResponse204 = {
  data: void
  status: 204
}

export type changeOwnPasswordResponse400 = {
  data: ApiError
  status: 400
}

export type changeOwnPasswordResponse401 = {
  data: ApiError
  status: 401
}

export type changeOwnPasswordResponse404 = {
  data: ApiError
  status: 404
}

export type changeOwnPasswordResponse500 = {
  data: ApiError
  status: 500
}

export type changeOwnPasswordResponseSuccess = (changeOwnPasswordResponse204) & {
  headers: Headers;
};
export type changeOwnPasswordResponseError = (changeOwnPasswordResponse400 | changeOwnPasswordResponse401 | changeOwnPasswordResponse404 | changeOwnPasswordResponse500) & {
  headers: Headers;
};

export type changeOwnPasswordResponse = (changeOwnPasswordResponseSuccess | changeOwnPasswordResponseError)

export const getChangeOwnPasswordUrl = () => {




  return `/me/password`
}

/**
 * Verifies the current password and replaces it. **Every other session for this account ends**, on its next request — the device that made the change stays signed in and its tokens keep working. On a shared phone that is the difference between changing your password and signing a colleague out, so say so before the person confirms. There is no endpoint anywhere in this API by which one person sets another person’s password; an administrator mints a reset link instead. Any **password-reset link** outstanding for the account is withdrawn by this call: it was minted to replace the password you have just replaced yourself, and it is a credential somebody is carrying around.
 * @summary Change your own password
 */
export const changeOwnPassword = async (changeOwnPasswordRequest: ChangeOwnPasswordRequest, options?: Parameters<typeof apiFetch>[1]): Promise<changeOwnPasswordResponse> => {

  return apiFetch<changeOwnPasswordResponse>(getChangeOwnPasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changeOwnPasswordRequest)
  }
);}





export const getChangeOwnPasswordMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeOwnPassword>>, TError,{data: ChangeOwnPasswordRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changeOwnPassword>>, TError,{data: ChangeOwnPasswordRequest}, TContext> => {

const mutationKey = ['changeOwnPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeOwnPassword>>, {data: ChangeOwnPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  changeOwnPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeOwnPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changeOwnPassword>>>
    export type ChangeOwnPasswordMutationBody = ChangeOwnPasswordRequest
    export type ChangeOwnPasswordMutationError = ApiError

    /**
 * @summary Change your own password
 */
export const useChangeOwnPassword = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeOwnPassword>>, TError,{data: ChangeOwnPasswordRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeOwnPassword>>,
        TError,
        {data: ChangeOwnPasswordRequest},
        TContext
      > => {
      return useMutation(getChangeOwnPasswordMutationOptions(options), queryClient);
    }

export type listLocationsResponse200 = {
  data: LocationPage
  status: 200
}

export type listLocationsResponse400 = {
  data: ApiError
  status: 400
}

export type listLocationsResponse401 = {
  data: ApiError
  status: 401
}

export type listLocationsResponse403 = {
  data: ApiError
  status: 403
}

export type listLocationsResponse500 = {
  data: ApiError
  status: 500
}

export type listLocationsResponseSuccess = (listLocationsResponse200) & {
  headers: Headers;
};
export type listLocationsResponseError = (listLocationsResponse400 | listLocationsResponse401 | listLocationsResponse403 | listLocationsResponse500) & {
  headers: Headers;
};

export type listLocationsResponse = (listLocationsResponseSuccess | listLocationsResponseError)

export const getListLocationsUrl = (params?: ListLocationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/locations?${stringifiedParams}` : `/locations`
}

/**
 * A page of the calling session’s tenant’s locations, searched and sorted, each carrying the number of rooms it holds. Deleted locations are absent.
 * @summary List the places this company cleans
 */
export const listLocations = async (params?: ListLocationsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listLocationsResponse> => {

  return apiFetch<listLocationsResponse>(getListLocationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLocationsQueryKey = (params?: ListLocationsParams,) => {
    return [
    `/locations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLocationsQueryOptions = <TData = Awaited<ReturnType<typeof listLocations>>, TError = ApiError>(params?: ListLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLocations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLocationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLocations>>> = ({ signal }) => listLocations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof listLocations>>>
export type ListLocationsQueryError = ApiError


export function useListLocations<TData = Awaited<ReturnType<typeof listLocations>>, TError = ApiError>(
 params: undefined |  ListLocationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLocations>>,
          TError,
          Awaited<ReturnType<typeof listLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLocations<TData = Awaited<ReturnType<typeof listLocations>>, TError = ApiError>(
 params?: ListLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLocations>>,
          TError,
          Awaited<ReturnType<typeof listLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLocations<TData = Awaited<ReturnType<typeof listLocations>>, TError = ApiError>(
 params?: ListLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLocations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the places this company cleans
 */

export function useListLocations<TData = Awaited<ReturnType<typeof listLocations>>, TError = ApiError>(
 params?: ListLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLocations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLocationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createLocationResponse201 = {
  data: Location
  status: 201
}

export type createLocationResponse400 = {
  data: ApiError
  status: 400
}

export type createLocationResponse401 = {
  data: ApiError
  status: 401
}

export type createLocationResponse403 = {
  data: ApiError
  status: 403
}

export type createLocationResponse500 = {
  data: ApiError
  status: 500
}

export type createLocationResponseSuccess = (createLocationResponse201) & {
  headers: Headers;
};
export type createLocationResponseError = (createLocationResponse400 | createLocationResponse401 | createLocationResponse403 | createLocationResponse500) & {
  headers: Headers;
};

export type createLocationResponse = (createLocationResponseSuccess | createLocationResponseError)

export const getCreateLocationUrl = () => {




  return `/locations`
}

/**
 * Creates one location. The address is optional and stays optional — a location with no address is an ordinary location, and every read says so by returning `null`.
 * @summary Add a place
 */
export const createLocation = async (createLocationRequest: CreateLocationRequest, options?: Parameters<typeof apiFetch>[1]): Promise<createLocationResponse> => {

  return apiFetch<createLocationResponse>(getCreateLocationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createLocationRequest)
  }
);}





export const getCreateLocationMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{data: CreateLocationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{data: CreateLocationRequest}, TContext> => {

const mutationKey = ['createLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLocation>>, {data: CreateLocationRequest}> = (props) => {
          const {data} = props ?? {};

          return  createLocation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof createLocation>>>
    export type CreateLocationMutationBody = CreateLocationRequest
    export type CreateLocationMutationError = ApiError

    /**
 * @summary Add a place
 */
export const useCreateLocation = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{data: CreateLocationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLocation>>,
        TError,
        {data: CreateLocationRequest},
        TContext
      > => {
      return useMutation(getCreateLocationMutationOptions(options), queryClient);
    }

export type createLocationsResponse200 = {
  data: CreatedLocations
  status: 200
}

export type createLocationsResponse400 = {
  data: ApiError
  status: 400
}

export type createLocationsResponse401 = {
  data: ApiError
  status: 401
}

export type createLocationsResponse403 = {
  data: ApiError
  status: 403
}

export type createLocationsResponse500 = {
  data: ApiError
  status: 500
}

export type createLocationsResponseSuccess = (createLocationsResponse200) & {
  headers: Headers;
};
export type createLocationsResponseError = (createLocationsResponse400 | createLocationsResponse401 | createLocationsResponse403 | createLocationsResponse500) & {
  headers: Headers;
};

export type createLocationsResponse = (createLocationsResponseSuccess | createLocationsResponseError)

export const getCreateLocationsUrl = () => {




  return `/locations/batch`
}

/**
 * The write behind "Add many": one result per item, in the order you sent them. A line that breaks a field rule fails **by itself** and the rest are still created, so an admin fixes the lines that failed rather than working out which of forty did not land.
 * @summary Add many places at once
 */
export const createLocations = async (createLocationsRequest: CreateLocationsRequest, options?: Parameters<typeof apiFetch>[1]): Promise<createLocationsResponse> => {

  return apiFetch<createLocationsResponse>(getCreateLocationsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createLocationsRequest)
  }
);}





export const getCreateLocationsMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocations>>, TError,{data: CreateLocationsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLocations>>, TError,{data: CreateLocationsRequest}, TContext> => {

const mutationKey = ['createLocations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLocations>>, {data: CreateLocationsRequest}> = (props) => {
          const {data} = props ?? {};

          return  createLocations(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLocationsMutationResult = NonNullable<Awaited<ReturnType<typeof createLocations>>>
    export type CreateLocationsMutationBody = CreateLocationsRequest
    export type CreateLocationsMutationError = ApiError

    /**
 * @summary Add many places at once
 */
export const useCreateLocations = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocations>>, TError,{data: CreateLocationsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLocations>>,
        TError,
        {data: CreateLocationsRequest},
        TContext
      > => {
      return useMutation(getCreateLocationsMutationOptions(options), queryClient);
    }

export type getLocationResponse200 = {
  data: Location
  status: 200
}

export type getLocationResponse400 = {
  data: ApiError
  status: 400
}

export type getLocationResponse401 = {
  data: ApiError
  status: 401
}

export type getLocationResponse403 = {
  data: ApiError
  status: 403
}

export type getLocationResponse404 = {
  data: ApiError
  status: 404
}

export type getLocationResponse500 = {
  data: ApiError
  status: 500
}

export type getLocationResponseSuccess = (getLocationResponse200) & {
  headers: Headers;
};
export type getLocationResponseError = (getLocationResponse400 | getLocationResponse401 | getLocationResponse403 | getLocationResponse404 | getLocationResponse500) & {
  headers: Headers;
};

export type getLocationResponse = (getLocationResponseSuccess | getLocationResponseError)

export const getGetLocationUrl = (id: string,) => {




  return `/locations/${id}`
}

/**
 * @summary One place
 */
export const getLocation = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getLocationResponse> => {

  return apiFetch<getLocationResponse>(getGetLocationUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLocationQueryKey = (id: string,) => {
    return [
    `/locations/${id}`
    ] as const;
    }


export const getGetLocationQueryOptions = <TData = Awaited<ReturnType<typeof getLocation>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocation>>> = ({ signal }) => getLocation(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLocationQueryResult = NonNullable<Awaited<ReturnType<typeof getLocation>>>
export type GetLocationQueryError = ApiError


export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocation>>,
          TError,
          Awaited<ReturnType<typeof getLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocation>>,
          TError,
          Awaited<ReturnType<typeof getLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One place
 */

export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type updateLocationResponse200 = {
  data: Location
  status: 200
}

export type updateLocationResponse400 = {
  data: ApiError
  status: 400
}

export type updateLocationResponse401 = {
  data: ApiError
  status: 401
}

export type updateLocationResponse403 = {
  data: ApiError
  status: 403
}

export type updateLocationResponse404 = {
  data: ApiError
  status: 404
}

export type updateLocationResponse500 = {
  data: ApiError
  status: 500
}

export type updateLocationResponseSuccess = (updateLocationResponse200) & {
  headers: Headers;
};
export type updateLocationResponseError = (updateLocationResponse400 | updateLocationResponse401 | updateLocationResponse403 | updateLocationResponse404 | updateLocationResponse500) & {
  headers: Headers;
};

export type updateLocationResponse = (updateLocationResponseSuccess | updateLocationResponseError)

export const getUpdateLocationUrl = (id: string,) => {




  return `/locations/${id}`
}

/**
 * @summary Rename a place, or change its address
 */
export const updateLocation = async (id: string,
    updateLocationRequest: UpdateLocationRequest, options?: Parameters<typeof apiFetch>[1]): Promise<updateLocationResponse> => {

  return apiFetch<updateLocationResponse>(getUpdateLocationUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateLocationRequest)
  }
);}





export const getUpdateLocationMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{id: string;data: UpdateLocationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{id: string;data: UpdateLocationRequest}, TContext> => {

const mutationKey = ['updateLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLocation>>, {id: string;data: UpdateLocationRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLocation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof updateLocation>>>
    export type UpdateLocationMutationBody = UpdateLocationRequest
    export type UpdateLocationMutationError = ApiError

    /**
 * @summary Rename a place, or change its address
 */
export const useUpdateLocation = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{id: string;data: UpdateLocationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLocation>>,
        TError,
        {id: string;data: UpdateLocationRequest},
        TContext
      > => {
      return useMutation(getUpdateLocationMutationOptions(options), queryClient);
    }

export type deleteLocationResponse204 = {
  data: void
  status: 204
}

export type deleteLocationResponse400 = {
  data: ApiError
  status: 400
}

export type deleteLocationResponse401 = {
  data: ApiError
  status: 401
}

export type deleteLocationResponse403 = {
  data: ApiError
  status: 403
}

export type deleteLocationResponse404 = {
  data: ApiError
  status: 404
}

export type deleteLocationResponse500 = {
  data: ApiError
  status: 500
}

export type deleteLocationResponseSuccess = (deleteLocationResponse204) & {
  headers: Headers;
};
export type deleteLocationResponseError = (deleteLocationResponse400 | deleteLocationResponse401 | deleteLocationResponse403 | deleteLocationResponse404 | deleteLocationResponse500) & {
  headers: Headers;
};

export type deleteLocationResponse = (deleteLocationResponseSuccess | deleteLocationResponseError)

export const getDeleteLocationUrl = (id: string,) => {




  return `/locations/${id}`
}

/**
 * A soft delete, and there is no undo. **Nothing cascades.** Its rooms survive, and its assignments survive and keep working — they keep this location’s name on every read. What the rooms lose is a way in: they are no longer listed under a location that is gone. Call `GET /locations/{id}/usage` before confirming, so the sentence can name numbers rather than guess them.
 * @summary Delete a place
 */
export const deleteLocation = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<deleteLocationResponse> => {

  return apiFetch<deleteLocationResponse>(getDeleteLocationUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteLocationMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLocation>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLocation>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLocation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteLocation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLocationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLocation>>>

    export type DeleteLocationMutationError = ApiError

    /**
 * @summary Delete a place
 */
export const useDeleteLocation = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLocation>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLocation>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteLocationMutationOptions(options), queryClient);
    }

export type getLocationUsageResponse200 = {
  data: LocationUsage
  status: 200
}

export type getLocationUsageResponse400 = {
  data: ApiError
  status: 400
}

export type getLocationUsageResponse401 = {
  data: ApiError
  status: 401
}

export type getLocationUsageResponse403 = {
  data: ApiError
  status: 403
}

export type getLocationUsageResponse404 = {
  data: ApiError
  status: 404
}

export type getLocationUsageResponse500 = {
  data: ApiError
  status: 500
}

export type getLocationUsageResponseSuccess = (getLocationUsageResponse200) & {
  headers: Headers;
};
export type getLocationUsageResponseError = (getLocationUsageResponse400 | getLocationUsageResponse401 | getLocationUsageResponse403 | getLocationUsageResponse404 | getLocationUsageResponse500) & {
  headers: Headers;
};

export type getLocationUsageResponse = (getLocationUsageResponseSuccess | getLocationUsageResponseError)

export const getGetLocationUsageUrl = (id: string,) => {




  return `/locations/${id}/usage`
}

/**
 * "Future" means dated today or later **in the tenant’s timezone**, and the date used is in the response so a client can say what it counted.
 * @summary What deleting this place would leave behind
 */
export const getLocationUsage = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getLocationUsageResponse> => {

  return apiFetch<getLocationUsageResponse>(getGetLocationUsageUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLocationUsageQueryKey = (id: string,) => {
    return [
    `/locations/${id}/usage`
    ] as const;
    }


export const getGetLocationUsageQueryOptions = <TData = Awaited<ReturnType<typeof getLocationUsage>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationUsageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationUsage>>> = ({ signal }) => getLocationUsage(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLocationUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationUsage>>>
export type GetLocationUsageQueryError = ApiError


export function useGetLocationUsage<TData = Awaited<ReturnType<typeof getLocationUsage>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationUsage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationUsage>>,
          TError,
          Awaited<ReturnType<typeof getLocationUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocationUsage<TData = Awaited<ReturnType<typeof getLocationUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationUsage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationUsage>>,
          TError,
          Awaited<ReturnType<typeof getLocationUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocationUsage<TData = Awaited<ReturnType<typeof getLocationUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What deleting this place would leave behind
 */

export function useGetLocationUsage<TData = Awaited<ReturnType<typeof getLocationUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationUsageQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listRoomsResponse200 = {
  data: RoomPage
  status: 200
}

export type listRoomsResponse400 = {
  data: ApiError
  status: 400
}

export type listRoomsResponse401 = {
  data: ApiError
  status: 401
}

export type listRoomsResponse403 = {
  data: ApiError
  status: 403
}

export type listRoomsResponse404 = {
  data: ApiError
  status: 404
}

export type listRoomsResponse500 = {
  data: ApiError
  status: 500
}

export type listRoomsResponseSuccess = (listRoomsResponse200) & {
  headers: Headers;
};
export type listRoomsResponseError = (listRoomsResponse400 | listRoomsResponse401 | listRoomsResponse403 | listRoomsResponse404 | listRoomsResponse500) & {
  headers: Headers;
};

export type listRoomsResponse = (listRoomsResponseSuccess | listRoomsResponseError)

export const getListRoomsUrl = (id: string,
    params?: ListRoomsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/locations/${id}/rooms?${stringifiedParams}` : `/locations/${id}/rooms`
}

/**
 * Rooms are only ever listed inside their location, and that is the whole API: "Küche" means nothing without its building. Each row carries how many live tasks are linked to it — the same number as that room’s own `tasks` and as the `total` of `GET /rooms/{id}/tasks`.
 * @summary The rooms in one place
 */
export const listRooms = async (id: string,
    params?: ListRoomsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listRoomsResponse> => {

  return apiFetch<listRoomsResponse>(getListRoomsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRoomsQueryKey = (id: string,
    params?: ListRoomsParams,) => {
    return [
    `/locations/${id}/rooms`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRoomsQueryOptions = <TData = Awaited<ReturnType<typeof listRooms>>, TError = ApiError>(id: string,
    params?: ListRoomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRooms>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRoomsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRooms>>> = ({ signal }) => listRooms(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRooms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRoomsQueryResult = NonNullable<Awaited<ReturnType<typeof listRooms>>>
export type ListRoomsQueryError = ApiError


export function useListRooms<TData = Awaited<ReturnType<typeof listRooms>>, TError = ApiError>(
 id: string,
    params: undefined |  ListRoomsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRooms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRooms>>,
          TError,
          Awaited<ReturnType<typeof listRooms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRooms<TData = Awaited<ReturnType<typeof listRooms>>, TError = ApiError>(
 id: string,
    params?: ListRoomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRooms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRooms>>,
          TError,
          Awaited<ReturnType<typeof listRooms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRooms<TData = Awaited<ReturnType<typeof listRooms>>, TError = ApiError>(
 id: string,
    params?: ListRoomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRooms>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The rooms in one place
 */

export function useListRooms<TData = Awaited<ReturnType<typeof listRooms>>, TError = ApiError>(
 id: string,
    params?: ListRoomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRooms>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRoomsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createRoomResponse201 = {
  data: Room
  status: 201
}

export type createRoomResponse400 = {
  data: ApiError
  status: 400
}

export type createRoomResponse401 = {
  data: ApiError
  status: 401
}

export type createRoomResponse403 = {
  data: ApiError
  status: 403
}

export type createRoomResponse404 = {
  data: ApiError
  status: 404
}

export type createRoomResponse500 = {
  data: ApiError
  status: 500
}

export type createRoomResponseSuccess = (createRoomResponse201) & {
  headers: Headers;
};
export type createRoomResponseError = (createRoomResponse400 | createRoomResponse401 | createRoomResponse403 | createRoomResponse404 | createRoomResponse500) & {
  headers: Headers;
};

export type createRoomResponse = (createRoomResponseSuccess | createRoomResponseError)

export const getCreateRoomUrl = (id: string,) => {




  return `/locations/${id}/rooms`
}

/**
 * @summary Add a room to a place
 */
export const createRoom = async (id: string,
    createRoomRequest: CreateRoomRequest, options?: Parameters<typeof apiFetch>[1]): Promise<createRoomResponse> => {

  return apiFetch<createRoomResponse>(getCreateRoomUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createRoomRequest)
  }
);}





export const getCreateRoomMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRoom>>, TError,{id: string;data: CreateRoomRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRoom>>, TError,{id: string;data: CreateRoomRequest}, TContext> => {

const mutationKey = ['createRoom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRoom>>, {id: string;data: CreateRoomRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  createRoom(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRoomMutationResult = NonNullable<Awaited<ReturnType<typeof createRoom>>>
    export type CreateRoomMutationBody = CreateRoomRequest
    export type CreateRoomMutationError = ApiError

    /**
 * @summary Add a room to a place
 */
export const useCreateRoom = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRoom>>, TError,{id: string;data: CreateRoomRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRoom>>,
        TError,
        {id: string;data: CreateRoomRequest},
        TContext
      > => {
      return useMutation(getCreateRoomMutationOptions(options), queryClient);
    }

export type createRoomsResponse200 = {
  data: CreatedRooms
  status: 200
}

export type createRoomsResponse400 = {
  data: ApiError
  status: 400
}

export type createRoomsResponse401 = {
  data: ApiError
  status: 401
}

export type createRoomsResponse403 = {
  data: ApiError
  status: 403
}

export type createRoomsResponse404 = {
  data: ApiError
  status: 404
}

export type createRoomsResponse500 = {
  data: ApiError
  status: 500
}

export type createRoomsResponseSuccess = (createRoomsResponse200) & {
  headers: Headers;
};
export type createRoomsResponseError = (createRoomsResponse400 | createRoomsResponse401 | createRoomsResponse403 | createRoomsResponse404 | createRoomsResponse500) & {
  headers: Headers;
};

export type createRoomsResponse = (createRoomsResponseSuccess | createRoomsResponseError)

export const getCreateRoomsUrl = (id: string,) => {




  return `/locations/${id}/rooms/batch`
}

/**
 * The write behind "Add many" for rooms, and behind "Duplicate this location" — that feature is this call with the source location’s room names, followed by `POST /room-tasks` with its links. One result per item; a failure does not stop the rest.
 * @summary Add many rooms at once
 */
export const createRooms = async (id: string,
    createRoomsRequest: CreateRoomsRequest, options?: Parameters<typeof apiFetch>[1]): Promise<createRoomsResponse> => {

  return apiFetch<createRoomsResponse>(getCreateRoomsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createRoomsRequest)
  }
);}





export const getCreateRoomsMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRooms>>, TError,{id: string;data: CreateRoomsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRooms>>, TError,{id: string;data: CreateRoomsRequest}, TContext> => {

const mutationKey = ['createRooms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRooms>>, {id: string;data: CreateRoomsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  createRooms(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRoomsMutationResult = NonNullable<Awaited<ReturnType<typeof createRooms>>>
    export type CreateRoomsMutationBody = CreateRoomsRequest
    export type CreateRoomsMutationError = ApiError

    /**
 * @summary Add many rooms at once
 */
export const useCreateRooms = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRooms>>, TError,{id: string;data: CreateRoomsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRooms>>,
        TError,
        {id: string;data: CreateRoomsRequest},
        TContext
      > => {
      return useMutation(getCreateRoomsMutationOptions(options), queryClient);
    }

export type getRoomResponse200 = {
  data: Room
  status: 200
}

export type getRoomResponse400 = {
  data: ApiError
  status: 400
}

export type getRoomResponse401 = {
  data: ApiError
  status: 401
}

export type getRoomResponse403 = {
  data: ApiError
  status: 403
}

export type getRoomResponse404 = {
  data: ApiError
  status: 404
}

export type getRoomResponse500 = {
  data: ApiError
  status: 500
}

export type getRoomResponseSuccess = (getRoomResponse200) & {
  headers: Headers;
};
export type getRoomResponseError = (getRoomResponse400 | getRoomResponse401 | getRoomResponse403 | getRoomResponse404 | getRoomResponse500) & {
  headers: Headers;
};

export type getRoomResponse = (getRoomResponseSuccess | getRoomResponseError)

export const getGetRoomUrl = (id: string,) => {




  return `/rooms/${id}`
}

/**
 * @summary One room
 */
export const getRoom = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getRoomResponse> => {

  return apiFetch<getRoomResponse>(getGetRoomUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRoomQueryKey = (id: string,) => {
    return [
    `/rooms/${id}`
    ] as const;
    }


export const getGetRoomQueryOptions = <TData = Awaited<ReturnType<typeof getRoom>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoom>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoomQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoom>>> = ({ signal }) => getRoom(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRoomQueryResult = NonNullable<Awaited<ReturnType<typeof getRoom>>>
export type GetRoomQueryError = ApiError


export function useGetRoom<TData = Awaited<ReturnType<typeof getRoom>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoom>>,
          TError,
          Awaited<ReturnType<typeof getRoom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoom<TData = Awaited<ReturnType<typeof getRoom>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoom>>,
          TError,
          Awaited<ReturnType<typeof getRoom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoom<TData = Awaited<ReturnType<typeof getRoom>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoom>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One room
 */

export function useGetRoom<TData = Awaited<ReturnType<typeof getRoom>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoom>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRoomQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type updateRoomResponse200 = {
  data: Room
  status: 200
}

export type updateRoomResponse400 = {
  data: ApiError
  status: 400
}

export type updateRoomResponse401 = {
  data: ApiError
  status: 401
}

export type updateRoomResponse403 = {
  data: ApiError
  status: 403
}

export type updateRoomResponse404 = {
  data: ApiError
  status: 404
}

export type updateRoomResponse500 = {
  data: ApiError
  status: 500
}

export type updateRoomResponseSuccess = (updateRoomResponse200) & {
  headers: Headers;
};
export type updateRoomResponseError = (updateRoomResponse400 | updateRoomResponse401 | updateRoomResponse403 | updateRoomResponse404 | updateRoomResponse500) & {
  headers: Headers;
};

export type updateRoomResponse = (updateRoomResponseSuccess | updateRoomResponseError)

export const getUpdateRoomUrl = (id: string,) => {




  return `/rooms/${id}`
}

/**
 * @summary Rename a room, or move it to another place
 */
export const updateRoom = async (id: string,
    updateRoomRequest: UpdateRoomRequest, options?: Parameters<typeof apiFetch>[1]): Promise<updateRoomResponse> => {

  return apiFetch<updateRoomResponse>(getUpdateRoomUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateRoomRequest)
  }
);}





export const getUpdateRoomMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRoom>>, TError,{id: string;data: UpdateRoomRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRoom>>, TError,{id: string;data: UpdateRoomRequest}, TContext> => {

const mutationKey = ['updateRoom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRoom>>, {id: string;data: UpdateRoomRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateRoom(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRoomMutationResult = NonNullable<Awaited<ReturnType<typeof updateRoom>>>
    export type UpdateRoomMutationBody = UpdateRoomRequest
    export type UpdateRoomMutationError = ApiError

    /**
 * @summary Rename a room, or move it to another place
 */
export const useUpdateRoom = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRoom>>, TError,{id: string;data: UpdateRoomRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRoom>>,
        TError,
        {id: string;data: UpdateRoomRequest},
        TContext
      > => {
      return useMutation(getUpdateRoomMutationOptions(options), queryClient);
    }

export type deleteRoomResponse204 = {
  data: void
  status: 204
}

export type deleteRoomResponse400 = {
  data: ApiError
  status: 400
}

export type deleteRoomResponse401 = {
  data: ApiError
  status: 401
}

export type deleteRoomResponse403 = {
  data: ApiError
  status: 403
}

export type deleteRoomResponse404 = {
  data: ApiError
  status: 404
}

export type deleteRoomResponse500 = {
  data: ApiError
  status: 500
}

export type deleteRoomResponseSuccess = (deleteRoomResponse204) & {
  headers: Headers;
};
export type deleteRoomResponseError = (deleteRoomResponse400 | deleteRoomResponse401 | deleteRoomResponse403 | deleteRoomResponse404 | deleteRoomResponse500) & {
  headers: Headers;
};

export type deleteRoomResponse = (deleteRoomResponseSuccess | deleteRoomResponseError)

export const getDeleteRoomUrl = (id: string,) => {




  return `/rooms/${id}`
}

/**
 * A soft delete, and there is no undo. **Nothing cascades**: its task links survive, and reports that already refer to this room keep their record of it. Call `GET /rooms/{id}/usage` before confirming.
 * @summary Delete a room
 */
export const deleteRoom = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<deleteRoomResponse> => {

  return apiFetch<deleteRoomResponse>(getDeleteRoomUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteRoomMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRoom>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRoom>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteRoom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRoom>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteRoom(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteRoomMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRoom>>>

    export type DeleteRoomMutationError = ApiError

    /**
 * @summary Delete a room
 */
export const useDeleteRoom = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRoom>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRoom>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteRoomMutationOptions(options), queryClient);
    }

export type getRoomUsageResponse200 = {
  data: RoomUsage
  status: 200
}

export type getRoomUsageResponse400 = {
  data: ApiError
  status: 400
}

export type getRoomUsageResponse401 = {
  data: ApiError
  status: 401
}

export type getRoomUsageResponse403 = {
  data: ApiError
  status: 403
}

export type getRoomUsageResponse404 = {
  data: ApiError
  status: 404
}

export type getRoomUsageResponse500 = {
  data: ApiError
  status: 500
}

export type getRoomUsageResponseSuccess = (getRoomUsageResponse200) & {
  headers: Headers;
};
export type getRoomUsageResponseError = (getRoomUsageResponse400 | getRoomUsageResponse401 | getRoomUsageResponse403 | getRoomUsageResponse404 | getRoomUsageResponse500) & {
  headers: Headers;
};

export type getRoomUsageResponse = (getRoomUsageResponseSuccess | getRoomUsageResponseError)

export const getGetRoomUsageUrl = (id: string,) => {




  return `/rooms/${id}/usage`
}

/**
 * @summary What deleting this room would leave behind
 */
export const getRoomUsage = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getRoomUsageResponse> => {

  return apiFetch<getRoomUsageResponse>(getGetRoomUsageUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRoomUsageQueryKey = (id: string,) => {
    return [
    `/rooms/${id}/usage`
    ] as const;
    }


export const getGetRoomUsageQueryOptions = <TData = Awaited<ReturnType<typeof getRoomUsage>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoomUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoomUsageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoomUsage>>> = ({ signal }) => getRoomUsage(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoomUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRoomUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getRoomUsage>>>
export type GetRoomUsageQueryError = ApiError


export function useGetRoomUsage<TData = Awaited<ReturnType<typeof getRoomUsage>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoomUsage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoomUsage>>,
          TError,
          Awaited<ReturnType<typeof getRoomUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoomUsage<TData = Awaited<ReturnType<typeof getRoomUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoomUsage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoomUsage>>,
          TError,
          Awaited<ReturnType<typeof getRoomUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoomUsage<TData = Awaited<ReturnType<typeof getRoomUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoomUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What deleting this room would leave behind
 */

export function useGetRoomUsage<TData = Awaited<ReturnType<typeof getRoomUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoomUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRoomUsageQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listRoomTasksResponse200 = {
  data: RoomTaskPage
  status: 200
}

export type listRoomTasksResponse400 = {
  data: ApiError
  status: 400
}

export type listRoomTasksResponse401 = {
  data: ApiError
  status: 401
}

export type listRoomTasksResponse403 = {
  data: ApiError
  status: 403
}

export type listRoomTasksResponse404 = {
  data: ApiError
  status: 404
}

export type listRoomTasksResponse500 = {
  data: ApiError
  status: 500
}

export type listRoomTasksResponseSuccess = (listRoomTasksResponse200) & {
  headers: Headers;
};
export type listRoomTasksResponseError = (listRoomTasksResponse400 | listRoomTasksResponse401 | listRoomTasksResponse403 | listRoomTasksResponse404 | listRoomTasksResponse500) & {
  headers: Headers;
};

export type listRoomTasksResponse = (listRoomTasksResponseSuccess | listRoomTasksResponseError)

export const getListRoomTasksUrl = (id: string,
    params?: ListRoomTasksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/rooms/${id}/tasks?${stringifiedParams}` : `/rooms/${id}/tasks`
}

/**
 * The room’s task links, each carrying **both** the link’s counter and the task’s frequency — everything needed to say when the task is next due, computed by the client with the same rule the server schedules by. A link to a task that has been deleted is absent from this list, and the link itself is not removed.
 * @summary What gets done in this room, and how often
 */
export const listRoomTasks = async (id: string,
    params?: ListRoomTasksParams, options?: Parameters<typeof apiFetch>[1]): Promise<listRoomTasksResponse> => {

  return apiFetch<listRoomTasksResponse>(getListRoomTasksUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRoomTasksQueryKey = (id: string,
    params?: ListRoomTasksParams,) => {
    return [
    `/rooms/${id}/tasks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRoomTasksQueryOptions = <TData = Awaited<ReturnType<typeof listRoomTasks>>, TError = ApiError>(id: string,
    params?: ListRoomTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoomTasks>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRoomTasksQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRoomTasks>>> = ({ signal }) => listRoomTasks(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRoomTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRoomTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listRoomTasks>>>
export type ListRoomTasksQueryError = ApiError


export function useListRoomTasks<TData = Awaited<ReturnType<typeof listRoomTasks>>, TError = ApiError>(
 id: string,
    params: undefined |  ListRoomTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoomTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRoomTasks>>,
          TError,
          Awaited<ReturnType<typeof listRoomTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRoomTasks<TData = Awaited<ReturnType<typeof listRoomTasks>>, TError = ApiError>(
 id: string,
    params?: ListRoomTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoomTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRoomTasks>>,
          TError,
          Awaited<ReturnType<typeof listRoomTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRoomTasks<TData = Awaited<ReturnType<typeof listRoomTasks>>, TError = ApiError>(
 id: string,
    params?: ListRoomTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoomTasks>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What gets done in this room, and how often
 */

export function useListRoomTasks<TData = Awaited<ReturnType<typeof listRoomTasks>>, TError = ApiError>(
 id: string,
    params?: ListRoomTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoomTasks>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRoomTasksQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listTasksResponse200 = {
  data: TaskPage
  status: 200
}

export type listTasksResponse400 = {
  data: ApiError
  status: 400
}

export type listTasksResponse401 = {
  data: ApiError
  status: 401
}

export type listTasksResponse403 = {
  data: ApiError
  status: 403
}

export type listTasksResponse500 = {
  data: ApiError
  status: 500
}

export type listTasksResponseSuccess = (listTasksResponse200) & {
  headers: Headers;
};
export type listTasksResponseError = (listTasksResponse400 | listTasksResponse401 | listTasksResponse403 | listTasksResponse500) & {
  headers: Headers;
};

export type listTasksResponse = (listTasksResponseSuccess | listTasksResponseError)

export const getListTasksUrl = (params?: ListTasksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tasks?${stringifiedParams}` : `/tasks`
}

/**
 * A page of the tenant’s tasks, searched and sorted, each carrying how many rooms it is linked to and how many hints and supplies it has. A task is tenant-wide, not per room.
 * @summary The things this company does
 */
export const listTasks = async (params?: ListTasksParams, options?: Parameters<typeof apiFetch>[1]): Promise<listTasksResponse> => {

  return apiFetch<listTasksResponse>(getListTasksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTasksQueryKey = (params?: ListTasksParams,) => {
    return [
    `/tasks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTasksQueryOptions = <TData = Awaited<ReturnType<typeof listTasks>>, TError = ApiError>(params?: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTasks>>> = ({ signal }) => listTasks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listTasks>>>
export type ListTasksQueryError = ApiError


export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = ApiError>(
 params: undefined |  ListTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTasks>>,
          TError,
          Awaited<ReturnType<typeof listTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = ApiError>(
 params?: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTasks>>,
          TError,
          Awaited<ReturnType<typeof listTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = ApiError>(
 params?: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The things this company does
 */

export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = ApiError>(
 params?: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTasksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createTaskResponse201 = {
  data: Task
  status: 201
}

export type createTaskResponse400 = {
  data: ApiError
  status: 400
}

export type createTaskResponse401 = {
  data: ApiError
  status: 401
}

export type createTaskResponse403 = {
  data: ApiError
  status: 403
}

export type createTaskResponse500 = {
  data: ApiError
  status: 500
}

export type createTaskResponseSuccess = (createTaskResponse201) & {
  headers: Headers;
};
export type createTaskResponseError = (createTaskResponse400 | createTaskResponse401 | createTaskResponse403 | createTaskResponse500) & {
  headers: Headers;
};

export type createTaskResponse = (createTaskResponseSuccess | createTaskResponseError)

export const getCreateTaskUrl = () => {




  return `/tasks`
}

/**
 * @summary Add a task
 */
export const createTask = async (createTaskRequest: CreateTaskRequest, options?: Parameters<typeof apiFetch>[1]): Promise<createTaskResponse> => {

  return apiFetch<createTaskResponse>(getCreateTaskUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTaskRequest)
  }
);}





export const getCreateTaskMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: CreateTaskRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: CreateTaskRequest}, TContext> => {

const mutationKey = ['createTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTask>>, {data: CreateTaskRequest}> = (props) => {
          const {data} = props ?? {};

          return  createTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createTask>>>
    export type CreateTaskMutationBody = CreateTaskRequest
    export type CreateTaskMutationError = ApiError

    /**
 * @summary Add a task
 */
export const useCreateTask = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: CreateTaskRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTask>>,
        TError,
        {data: CreateTaskRequest},
        TContext
      > => {
      return useMutation(getCreateTaskMutationOptions(options), queryClient);
    }

export type createTasksResponse200 = {
  data: CreatedTasks
  status: 200
}

export type createTasksResponse400 = {
  data: ApiError
  status: 400
}

export type createTasksResponse401 = {
  data: ApiError
  status: 401
}

export type createTasksResponse403 = {
  data: ApiError
  status: 403
}

export type createTasksResponse500 = {
  data: ApiError
  status: 500
}

export type createTasksResponseSuccess = (createTasksResponse200) & {
  headers: Headers;
};
export type createTasksResponseError = (createTasksResponse400 | createTasksResponse401 | createTasksResponse403 | createTasksResponse500) & {
  headers: Headers;
};

export type createTasksResponse = (createTasksResponseSuccess | createTasksResponseError)

export const getCreateTasksUrl = () => {




  return `/tasks/batch`
}

/**
 * One result per item; a line whose `frequency` is zero, negative or fractional fails by itself and says so, and the rest are still created.
 * @summary Add many tasks at once
 */
export const createTasks = async (createTasksRequest: CreateTasksRequest, options?: Parameters<typeof apiFetch>[1]): Promise<createTasksResponse> => {

  return apiFetch<createTasksResponse>(getCreateTasksUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTasksRequest)
  }
);}





export const getCreateTasksMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTasks>>, TError,{data: CreateTasksRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTasks>>, TError,{data: CreateTasksRequest}, TContext> => {

const mutationKey = ['createTasks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTasks>>, {data: CreateTasksRequest}> = (props) => {
          const {data} = props ?? {};

          return  createTasks(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTasksMutationResult = NonNullable<Awaited<ReturnType<typeof createTasks>>>
    export type CreateTasksMutationBody = CreateTasksRequest
    export type CreateTasksMutationError = ApiError

    /**
 * @summary Add many tasks at once
 */
export const useCreateTasks = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTasks>>, TError,{data: CreateTasksRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTasks>>,
        TError,
        {data: CreateTasksRequest},
        TContext
      > => {
      return useMutation(getCreateTasksMutationOptions(options), queryClient);
    }

export type getTaskResponse200 = {
  data: Task
  status: 200
}

export type getTaskResponse400 = {
  data: ApiError
  status: 400
}

export type getTaskResponse401 = {
  data: ApiError
  status: 401
}

export type getTaskResponse403 = {
  data: ApiError
  status: 403
}

export type getTaskResponse404 = {
  data: ApiError
  status: 404
}

export type getTaskResponse500 = {
  data: ApiError
  status: 500
}

export type getTaskResponseSuccess = (getTaskResponse200) & {
  headers: Headers;
};
export type getTaskResponseError = (getTaskResponse400 | getTaskResponse401 | getTaskResponse403 | getTaskResponse404 | getTaskResponse500) & {
  headers: Headers;
};

export type getTaskResponse = (getTaskResponseSuccess | getTaskResponseError)

export const getGetTaskUrl = (id: string,) => {




  return `/tasks/${id}`
}

/**
 * @summary One task
 */
export const getTask = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getTaskResponse> => {

  return apiFetch<getTaskResponse>(getGetTaskUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskQueryKey = (id: string,) => {
    return [
    `/tasks/${id}`
    ] as const;
    }


export const getGetTaskQueryOptions = <TData = Awaited<ReturnType<typeof getTask>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTask>>> = ({ signal }) => getTask(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskQueryResult = NonNullable<Awaited<ReturnType<typeof getTask>>>
export type GetTaskQueryError = ApiError


export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTask>>,
          TError,
          Awaited<ReturnType<typeof getTask>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTask>>,
          TError,
          Awaited<ReturnType<typeof getTask>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One task
 */

export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type updateTaskResponse200 = {
  data: Task
  status: 200
}

export type updateTaskResponse400 = {
  data: ApiError
  status: 400
}

export type updateTaskResponse401 = {
  data: ApiError
  status: 401
}

export type updateTaskResponse403 = {
  data: ApiError
  status: 403
}

export type updateTaskResponse404 = {
  data: ApiError
  status: 404
}

export type updateTaskResponse500 = {
  data: ApiError
  status: 500
}

export type updateTaskResponseSuccess = (updateTaskResponse200) & {
  headers: Headers;
};
export type updateTaskResponseError = (updateTaskResponse400 | updateTaskResponse401 | updateTaskResponse403 | updateTaskResponse404 | updateTaskResponse500) & {
  headers: Headers;
};

export type updateTaskResponse = (updateTaskResponseSuccess | updateTaskResponseError)

export const getUpdateTaskUrl = (id: string,) => {




  return `/tasks/${id}`
}

/**
 * @summary Edit a task, including how often it is done
 */
export const updateTask = async (id: string,
    updateTaskRequest: UpdateTaskRequest, options?: Parameters<typeof apiFetch>[1]): Promise<updateTaskResponse> => {

  return apiFetch<updateTaskResponse>(getUpdateTaskUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTaskRequest)
  }
);}





export const getUpdateTaskMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{id: string;data: UpdateTaskRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{id: string;data: UpdateTaskRequest}, TContext> => {

const mutationKey = ['updateTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTask>>, {id: string;data: UpdateTaskRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTask(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof updateTask>>>
    export type UpdateTaskMutationBody = UpdateTaskRequest
    export type UpdateTaskMutationError = ApiError

    /**
 * @summary Edit a task, including how often it is done
 */
export const useUpdateTask = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{id: string;data: UpdateTaskRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTask>>,
        TError,
        {id: string;data: UpdateTaskRequest},
        TContext
      > => {
      return useMutation(getUpdateTaskMutationOptions(options), queryClient);
    }

export type deleteTaskResponse204 = {
  data: void
  status: 204
}

export type deleteTaskResponse400 = {
  data: ApiError
  status: 400
}

export type deleteTaskResponse401 = {
  data: ApiError
  status: 401
}

export type deleteTaskResponse403 = {
  data: ApiError
  status: 403
}

export type deleteTaskResponse404 = {
  data: ApiError
  status: 404
}

export type deleteTaskResponse500 = {
  data: ApiError
  status: 500
}

export type deleteTaskResponseSuccess = (deleteTaskResponse204) & {
  headers: Headers;
};
export type deleteTaskResponseError = (deleteTaskResponse400 | deleteTaskResponse401 | deleteTaskResponse403 | deleteTaskResponse404 | deleteTaskResponse500) & {
  headers: Headers;
};

export type deleteTaskResponse = (deleteTaskResponseSuccess | deleteTaskResponseError)

export const getDeleteTaskUrl = (id: string,) => {




  return `/tasks/${id}`
}

/**
 * A soft delete, and there is no undo. **Nothing cascades**: its room links, its hints and its supplies all survive, and tasks already materialised onto existing assignments are not removed — a worker mid-week keeps the job they were given. What changes is that the task stops appearing in any room’s task list. Call `GET /tasks/{id}/usage` first.
 * @summary Delete a task
 */
export const deleteTask = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<deleteTaskResponse> => {

  return apiFetch<deleteTaskResponse>(getDeleteTaskUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTaskMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTask>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTask>>>

    export type DeleteTaskMutationError = ApiError

    /**
 * @summary Delete a task
 */
export const useDeleteTask = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTask>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteTaskMutationOptions(options), queryClient);
    }

export type getTaskUsageResponse200 = {
  data: TaskUsage
  status: 200
}

export type getTaskUsageResponse400 = {
  data: ApiError
  status: 400
}

export type getTaskUsageResponse401 = {
  data: ApiError
  status: 401
}

export type getTaskUsageResponse403 = {
  data: ApiError
  status: 403
}

export type getTaskUsageResponse404 = {
  data: ApiError
  status: 404
}

export type getTaskUsageResponse500 = {
  data: ApiError
  status: 500
}

export type getTaskUsageResponseSuccess = (getTaskUsageResponse200) & {
  headers: Headers;
};
export type getTaskUsageResponseError = (getTaskUsageResponse400 | getTaskUsageResponse401 | getTaskUsageResponse403 | getTaskUsageResponse404 | getTaskUsageResponse500) & {
  headers: Headers;
};

export type getTaskUsageResponse = (getTaskUsageResponseSuccess | getTaskUsageResponseError)

export const getGetTaskUsageUrl = (id: string,) => {




  return `/tasks/${id}/usage`
}

/**
 * @summary What deleting this task would leave behind
 */
export const getTaskUsage = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getTaskUsageResponse> => {

  return apiFetch<getTaskUsageResponse>(getGetTaskUsageUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskUsageQueryKey = (id: string,) => {
    return [
    `/tasks/${id}/usage`
    ] as const;
    }


export const getGetTaskUsageQueryOptions = <TData = Awaited<ReturnType<typeof getTaskUsage>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskUsageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskUsage>>> = ({ signal }) => getTaskUsage(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskUsage>>>
export type GetTaskUsageQueryError = ApiError


export function useGetTaskUsage<TData = Awaited<ReturnType<typeof getTaskUsage>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskUsage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskUsage>>,
          TError,
          Awaited<ReturnType<typeof getTaskUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskUsage<TData = Awaited<ReturnType<typeof getTaskUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskUsage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskUsage>>,
          TError,
          Awaited<ReturnType<typeof getTaskUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskUsage<TData = Awaited<ReturnType<typeof getTaskUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What deleting this task would leave behind
 */

export function useGetTaskUsage<TData = Awaited<ReturnType<typeof getTaskUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskUsageQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listTaskRoomsResponse200 = {
  data: TaskRoomPage
  status: 200
}

export type listTaskRoomsResponse400 = {
  data: ApiError
  status: 400
}

export type listTaskRoomsResponse401 = {
  data: ApiError
  status: 401
}

export type listTaskRoomsResponse403 = {
  data: ApiError
  status: 403
}

export type listTaskRoomsResponse404 = {
  data: ApiError
  status: 404
}

export type listTaskRoomsResponse500 = {
  data: ApiError
  status: 500
}

export type listTaskRoomsResponseSuccess = (listTaskRoomsResponse200) & {
  headers: Headers;
};
export type listTaskRoomsResponseError = (listTaskRoomsResponse400 | listTaskRoomsResponse401 | listTaskRoomsResponse403 | listTaskRoomsResponse404 | listTaskRoomsResponse500) & {
  headers: Headers;
};

export type listTaskRoomsResponse = (listTaskRoomsResponseSuccess | listTaskRoomsResponseError)

export const getListTaskRoomsUrl = (id: string,
    params?: ListTaskRoomsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tasks/${id}/rooms?${stringifiedParams}` : `/tasks/${id}/rooms`
}

/**
 * The task’s links, each with the room it points at and that room’s location, ordered by location and then by room so a client can group them without sorting. A link whose **room** has been deleted is absent — that room is somewhere this company no longer cleans. A link whose room is live but whose **location** has been deleted is still listed, and still names that location: a location’s name survives its deletion, because nothing here cascades and retiring a building must not silently take live rooms out of the tasks they are used in.
 * @summary Where this task is used
 */
export const listTaskRooms = async (id: string,
    params?: ListTaskRoomsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listTaskRoomsResponse> => {

  return apiFetch<listTaskRoomsResponse>(getListTaskRoomsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTaskRoomsQueryKey = (id: string,
    params?: ListTaskRoomsParams,) => {
    return [
    `/tasks/${id}/rooms`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTaskRoomsQueryOptions = <TData = Awaited<ReturnType<typeof listTaskRooms>>, TError = ApiError>(id: string,
    params?: ListTaskRoomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTaskRooms>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTaskRoomsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTaskRooms>>> = ({ signal }) => listTaskRooms(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTaskRooms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTaskRoomsQueryResult = NonNullable<Awaited<ReturnType<typeof listTaskRooms>>>
export type ListTaskRoomsQueryError = ApiError


export function useListTaskRooms<TData = Awaited<ReturnType<typeof listTaskRooms>>, TError = ApiError>(
 id: string,
    params: undefined |  ListTaskRoomsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTaskRooms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTaskRooms>>,
          TError,
          Awaited<ReturnType<typeof listTaskRooms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTaskRooms<TData = Awaited<ReturnType<typeof listTaskRooms>>, TError = ApiError>(
 id: string,
    params?: ListTaskRoomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTaskRooms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTaskRooms>>,
          TError,
          Awaited<ReturnType<typeof listTaskRooms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTaskRooms<TData = Awaited<ReturnType<typeof listTaskRooms>>, TError = ApiError>(
 id: string,
    params?: ListTaskRoomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTaskRooms>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Where this task is used
 */

export function useListTaskRooms<TData = Awaited<ReturnType<typeof listTaskRooms>>, TError = ApiError>(
 id: string,
    params?: ListTaskRoomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTaskRooms>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTaskRoomsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type linkRoomTasksResponse200 = {
  data: CreatedLinks
  status: 200
}

export type linkRoomTasksResponse400 = {
  data: ApiError
  status: 400
}

export type linkRoomTasksResponse401 = {
  data: ApiError
  status: 401
}

export type linkRoomTasksResponse403 = {
  data: ApiError
  status: 403
}

export type linkRoomTasksResponse500 = {
  data: ApiError
  status: 500
}

export type linkRoomTasksResponseSuccess = (linkRoomTasksResponse200) & {
  headers: Headers;
};
export type linkRoomTasksResponseError = (linkRoomTasksResponse400 | linkRoomTasksResponse401 | linkRoomTasksResponse403 | linkRoomTasksResponse500) & {
  headers: Headers;
};

export type linkRoomTasksResponse = (linkRoomTasksResponseSuccess | linkRoomTasksResponseError)

export const getLinkRoomTasksUrl = () => {




  return `/room-tasks`
}

/**
 * Links one or many (room, task) pairs in a single action, from either side of the sheet: many tasks into one room, or one task into many rooms. **Every pair gets its own outcome** — a room or task that has been deleted, or belongs to another tenant, answers `not_found` for that pair; a pair that is already linked answers `conflict`; and a pair repeated inside the same request answers `conflict` on its second appearance. A pair linked by somebody else’s request in the same moment answers `conflict` too — the database refuses the duplicate and it is reported as the same thing, not as an `internal_error`. Pairs are applied in order and a failure never discards the ones that worked.
 *
 * A new link is due **on the next visit or later, never retroactively**: its counter starts at 1, so a task done every visit fires on the next assignment and a task done every third visit fires on the third.
 *
 * This operation answers **200 and never 409**, even when every pair it was given was already linked: a conflict is one item’s outcome, not the request’s, and reporting it as a status would throw away the results of the pairs that worked.
 * @summary Link tasks into rooms
 */
export const linkRoomTasks = async (createLinksRequest: CreateLinksRequest, options?: Parameters<typeof apiFetch>[1]): Promise<linkRoomTasksResponse> => {

  return apiFetch<linkRoomTasksResponse>(getLinkRoomTasksUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createLinksRequest)
  }
);}





export const getLinkRoomTasksMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkRoomTasks>>, TError,{data: CreateLinksRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof linkRoomTasks>>, TError,{data: CreateLinksRequest}, TContext> => {

const mutationKey = ['linkRoomTasks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkRoomTasks>>, {data: CreateLinksRequest}> = (props) => {
          const {data} = props ?? {};

          return  linkRoomTasks(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkRoomTasksMutationResult = NonNullable<Awaited<ReturnType<typeof linkRoomTasks>>>
    export type LinkRoomTasksMutationBody = CreateLinksRequest
    export type LinkRoomTasksMutationError = ApiError

    /**
 * @summary Link tasks into rooms
 */
export const useLinkRoomTasks = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkRoomTasks>>, TError,{data: CreateLinksRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkRoomTasks>>,
        TError,
        {data: CreateLinksRequest},
        TContext
      > => {
      return useMutation(getLinkRoomTasksMutationOptions(options), queryClient);
    }

export type unlinkRoomTaskResponse204 = {
  data: void
  status: 204
}

export type unlinkRoomTaskResponse400 = {
  data: ApiError
  status: 400
}

export type unlinkRoomTaskResponse401 = {
  data: ApiError
  status: 401
}

export type unlinkRoomTaskResponse403 = {
  data: ApiError
  status: 403
}

export type unlinkRoomTaskResponse404 = {
  data: ApiError
  status: 404
}

export type unlinkRoomTaskResponse500 = {
  data: ApiError
  status: 500
}

export type unlinkRoomTaskResponseSuccess = (unlinkRoomTaskResponse204) & {
  headers: Headers;
};
export type unlinkRoomTaskResponseError = (unlinkRoomTaskResponse400 | unlinkRoomTaskResponse401 | unlinkRoomTaskResponse403 | unlinkRoomTaskResponse404 | unlinkRoomTaskResponse500) & {
  headers: Headers;
};

export type unlinkRoomTaskResponse = (unlinkRoomTaskResponseSuccess | unlinkRoomTaskResponseError)

export const getUnlinkRoomTaskUrl = (id: string,) => {




  return `/room-tasks/${id}`
}

/**
 * Removes the link, from the next assignment onwards. Work already created keeps the tasks that were materialised onto it, and every report keeps its record. Linking the same task into the same room again afterwards is allowed, and starts a fresh counter.
 *
 * This works on a link whose room or whose task has been deleted, unlike `schedule-next-visit`: such a link is invisible to every list here, and tidying it away must never be the thing that is blocked.
 * @summary Stop doing a task in a room
 */
export const unlinkRoomTask = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<unlinkRoomTaskResponse> => {

  return apiFetch<unlinkRoomTaskResponse>(getUnlinkRoomTaskUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnlinkRoomTaskMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkRoomTask>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unlinkRoomTask>>, TError,{id: string}, TContext> => {

const mutationKey = ['unlinkRoomTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlinkRoomTask>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  unlinkRoomTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlinkRoomTaskMutationResult = NonNullable<Awaited<ReturnType<typeof unlinkRoomTask>>>

    export type UnlinkRoomTaskMutationError = ApiError

    /**
 * @summary Stop doing a task in a room
 */
export const useUnlinkRoomTask = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkRoomTask>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unlinkRoomTask>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getUnlinkRoomTaskMutationOptions(options), queryClient);
    }

export type scheduleRoomTaskNextVisitResponse200 = {
  data: RoomTask
  status: 200
}

export type scheduleRoomTaskNextVisitResponse400 = {
  data: ApiError
  status: 400
}

export type scheduleRoomTaskNextVisitResponse401 = {
  data: ApiError
  status: 401
}

export type scheduleRoomTaskNextVisitResponse403 = {
  data: ApiError
  status: 403
}

export type scheduleRoomTaskNextVisitResponse404 = {
  data: ApiError
  status: 404
}

export type scheduleRoomTaskNextVisitResponse500 = {
  data: ApiError
  status: 500
}

export type scheduleRoomTaskNextVisitResponseSuccess = (scheduleRoomTaskNextVisitResponse200) & {
  headers: Headers;
};
export type scheduleRoomTaskNextVisitResponseError = (scheduleRoomTaskNextVisitResponse400 | scheduleRoomTaskNextVisitResponse401 | scheduleRoomTaskNextVisitResponse403 | scheduleRoomTaskNextVisitResponse404 | scheduleRoomTaskNextVisitResponse500) & {
  headers: Headers;
};

export type scheduleRoomTaskNextVisitResponse = (scheduleRoomTaskNextVisitResponseSuccess | scheduleRoomTaskNextVisitResponseError)

export const getScheduleRoomTaskNextVisitUrl = (id: string,) => {




  return `/room-tasks/${id}/schedule-next-visit`
}

/**
 * The one operation that moves a cadence counter, and it takes no value. It sets the link so that the **next** assignment created for its location produces this task, and no earlier one would have. There is deliberately no way to write `timesSinceDone` directly: a raw counter is the field nobody understands, and every screen that needs to move it needs exactly this.
 *
 * Calling it twice leaves the counter where it was — the second call writes the same value, so only `updatedAt` moves — and it changes nothing about the task itself or about any other room the task is linked into.
 *
 * A link whose room **or** whose task has been deleted answers 404: the row it would write is one no read returns, and "due next visit" means nothing for work nobody will be given. Unlinking such a link is still allowed — tidying up is never blocked.
 * @summary Make this due on the next visit
 */
export const scheduleRoomTaskNextVisit = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<scheduleRoomTaskNextVisitResponse> => {

  return apiFetch<scheduleRoomTaskNextVisitResponse>(getScheduleRoomTaskNextVisitUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getScheduleRoomTaskNextVisitMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleRoomTaskNextVisit>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof scheduleRoomTaskNextVisit>>, TError,{id: string}, TContext> => {

const mutationKey = ['scheduleRoomTaskNextVisit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleRoomTaskNextVisit>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  scheduleRoomTaskNextVisit(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScheduleRoomTaskNextVisitMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleRoomTaskNextVisit>>>

    export type ScheduleRoomTaskNextVisitMutationError = ApiError

    /**
 * @summary Make this due on the next visit
 */
export const useScheduleRoomTaskNextVisit = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleRoomTaskNextVisit>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scheduleRoomTaskNextVisit>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getScheduleRoomTaskNextVisitMutationOptions(options), queryClient);
    }

export type listHintsResponse200 = {
  data: HintPage
  status: 200
}

export type listHintsResponse400 = {
  data: ApiError
  status: 400
}

export type listHintsResponse401 = {
  data: ApiError
  status: 401
}

export type listHintsResponse403 = {
  data: ApiError
  status: 403
}

export type listHintsResponse404 = {
  data: ApiError
  status: 404
}

export type listHintsResponse500 = {
  data: ApiError
  status: 500
}

export type listHintsResponseSuccess = (listHintsResponse200) & {
  headers: Headers;
};
export type listHintsResponseError = (listHintsResponse400 | listHintsResponse401 | listHintsResponse403 | listHintsResponse404 | listHintsResponse500) & {
  headers: Headers;
};

export type listHintsResponse = (listHintsResponseSuccess | listHintsResponseError)

export const getListHintsUrl = (id: string,
    params?: ListHintsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tasks/${id}/hints?${stringifiedParams}` : `/tasks/${id}/hints`
}

/**
 * @summary List a task’s hints
 */
export const listHints = async (id: string,
    params?: ListHintsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listHintsResponse> => {

  return apiFetch<listHintsResponse>(getListHintsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHintsQueryKey = (id: string,
    params?: ListHintsParams,) => {
    return [
    `/tasks/${id}/hints`, ...(params ? [params] : [])
    ] as const;
    }


export const getListHintsQueryOptions = <TData = Awaited<ReturnType<typeof listHints>>, TError = ApiError>(id: string,
    params?: ListHintsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHints>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHintsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHints>>> = ({ signal }) => listHints(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHints>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListHintsQueryResult = NonNullable<Awaited<ReturnType<typeof listHints>>>
export type ListHintsQueryError = ApiError


export function useListHints<TData = Awaited<ReturnType<typeof listHints>>, TError = ApiError>(
 id: string,
    params: undefined |  ListHintsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHints>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHints>>,
          TError,
          Awaited<ReturnType<typeof listHints>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListHints<TData = Awaited<ReturnType<typeof listHints>>, TError = ApiError>(
 id: string,
    params?: ListHintsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHints>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHints>>,
          TError,
          Awaited<ReturnType<typeof listHints>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListHints<TData = Awaited<ReturnType<typeof listHints>>, TError = ApiError>(
 id: string,
    params?: ListHintsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHints>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a task’s hints
 */

export function useListHints<TData = Awaited<ReturnType<typeof listHints>>, TError = ApiError>(
 id: string,
    params?: ListHintsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHints>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListHintsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createHintResponse201 = {
  data: Hint
  status: 201
}

export type createHintResponse400 = {
  data: ApiError
  status: 400
}

export type createHintResponse401 = {
  data: ApiError
  status: 401
}

export type createHintResponse403 = {
  data: ApiError
  status: 403
}

export type createHintResponse404 = {
  data: ApiError
  status: 404
}

export type createHintResponse500 = {
  data: ApiError
  status: 500
}

export type createHintResponseSuccess = (createHintResponse201) & {
  headers: Headers;
};
export type createHintResponseError = (createHintResponse400 | createHintResponse401 | createHintResponse403 | createHintResponse404 | createHintResponse500) & {
  headers: Headers;
};

export type createHintResponse = (createHintResponseSuccess | createHintResponseError)

export const getCreateHintUrl = (id: string,) => {




  return `/tasks/${id}/hints`
}

/**
 * @summary Add a hint to a task
 */
export const createHint = async (id: string,
    createHintRequest: CreateHintRequest, options?: Parameters<typeof apiFetch>[1]): Promise<createHintResponse> => {

  return apiFetch<createHintResponse>(getCreateHintUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createHintRequest)
  }
);}





export const getCreateHintMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHint>>, TError,{id: string;data: CreateHintRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHint>>, TError,{id: string;data: CreateHintRequest}, TContext> => {

const mutationKey = ['createHint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHint>>, {id: string;data: CreateHintRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  createHint(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHintMutationResult = NonNullable<Awaited<ReturnType<typeof createHint>>>
    export type CreateHintMutationBody = CreateHintRequest
    export type CreateHintMutationError = ApiError

    /**
 * @summary Add a hint to a task
 */
export const useCreateHint = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHint>>, TError,{id: string;data: CreateHintRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createHint>>,
        TError,
        {id: string;data: CreateHintRequest},
        TContext
      > => {
      return useMutation(getCreateHintMutationOptions(options), queryClient);
    }

export type getHintResponse200 = {
  data: Hint
  status: 200
}

export type getHintResponse400 = {
  data: ApiError
  status: 400
}

export type getHintResponse401 = {
  data: ApiError
  status: 401
}

export type getHintResponse403 = {
  data: ApiError
  status: 403
}

export type getHintResponse404 = {
  data: ApiError
  status: 404
}

export type getHintResponse500 = {
  data: ApiError
  status: 500
}

export type getHintResponseSuccess = (getHintResponse200) & {
  headers: Headers;
};
export type getHintResponseError = (getHintResponse400 | getHintResponse401 | getHintResponse403 | getHintResponse404 | getHintResponse500) & {
  headers: Headers;
};

export type getHintResponse = (getHintResponseSuccess | getHintResponseError)

export const getGetHintUrl = (id: string,) => {




  return `/hints/${id}`
}

/**
 * @summary One hint
 */
export const getHint = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getHintResponse> => {

  return apiFetch<getHintResponse>(getGetHintUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHintQueryKey = (id: string,) => {
    return [
    `/hints/${id}`
    ] as const;
    }


export const getGetHintQueryOptions = <TData = Awaited<ReturnType<typeof getHint>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHint>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHintQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHint>>> = ({ signal }) => getHint(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHint>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHintQueryResult = NonNullable<Awaited<ReturnType<typeof getHint>>>
export type GetHintQueryError = ApiError


export function useGetHint<TData = Awaited<ReturnType<typeof getHint>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHint>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHint>>,
          TError,
          Awaited<ReturnType<typeof getHint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHint<TData = Awaited<ReturnType<typeof getHint>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHint>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHint>>,
          TError,
          Awaited<ReturnType<typeof getHint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHint<TData = Awaited<ReturnType<typeof getHint>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHint>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One hint
 */

export function useGetHint<TData = Awaited<ReturnType<typeof getHint>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHint>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHintQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type updateHintResponse200 = {
  data: Hint
  status: 200
}

export type updateHintResponse400 = {
  data: ApiError
  status: 400
}

export type updateHintResponse401 = {
  data: ApiError
  status: 401
}

export type updateHintResponse403 = {
  data: ApiError
  status: 403
}

export type updateHintResponse404 = {
  data: ApiError
  status: 404
}

export type updateHintResponse500 = {
  data: ApiError
  status: 500
}

export type updateHintResponseSuccess = (updateHintResponse200) & {
  headers: Headers;
};
export type updateHintResponseError = (updateHintResponse400 | updateHintResponse401 | updateHintResponse403 | updateHintResponse404 | updateHintResponse500) & {
  headers: Headers;
};

export type updateHintResponse = (updateHintResponseSuccess | updateHintResponseError)

export const getUpdateHintUrl = (id: string,) => {




  return `/hints/${id}`
}

/**
 * @summary Edit a hint’s title or text
 */
export const updateHint = async (id: string,
    updateHintRequest: UpdateHintRequest, options?: Parameters<typeof apiFetch>[1]): Promise<updateHintResponse> => {

  return apiFetch<updateHintResponse>(getUpdateHintUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateHintRequest)
  }
);}





export const getUpdateHintMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHint>>, TError,{id: string;data: UpdateHintRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHint>>, TError,{id: string;data: UpdateHintRequest}, TContext> => {

const mutationKey = ['updateHint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHint>>, {id: string;data: UpdateHintRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateHint(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHintMutationResult = NonNullable<Awaited<ReturnType<typeof updateHint>>>
    export type UpdateHintMutationBody = UpdateHintRequest
    export type UpdateHintMutationError = ApiError

    /**
 * @summary Edit a hint’s title or text
 */
export const useUpdateHint = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHint>>, TError,{id: string;data: UpdateHintRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateHint>>,
        TError,
        {id: string;data: UpdateHintRequest},
        TContext
      > => {
      return useMutation(getUpdateHintMutationOptions(options), queryClient);
    }

export type deleteHintResponse204 = {
  data: void
  status: 204
}

export type deleteHintResponse400 = {
  data: ApiError
  status: 400
}

export type deleteHintResponse401 = {
  data: ApiError
  status: 401
}

export type deleteHintResponse403 = {
  data: ApiError
  status: 403
}

export type deleteHintResponse404 = {
  data: ApiError
  status: 404
}

export type deleteHintResponse500 = {
  data: ApiError
  status: 500
}

export type deleteHintResponseSuccess = (deleteHintResponse204) & {
  headers: Headers;
};
export type deleteHintResponseError = (deleteHintResponse400 | deleteHintResponse401 | deleteHintResponse403 | deleteHintResponse404 | deleteHintResponse500) & {
  headers: Headers;
};

export type deleteHintResponse = (deleteHintResponseSuccess | deleteHintResponseError)

export const getDeleteHintUrl = (id: string,) => {




  return `/hints/${id}`
}

/**
 * A soft delete, and there is no undo. Its photos are not deleted — they become unreachable through this hint, and stay individually fetchable by id. Call `GET /hints/{id}/usage` before confirming.
 * @summary Delete a hint
 */
export const deleteHint = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<deleteHintResponse> => {

  return apiFetch<deleteHintResponse>(getDeleteHintUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteHintMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHint>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHint>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteHint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHint>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteHint(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHintMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHint>>>

    export type DeleteHintMutationError = ApiError

    /**
 * @summary Delete a hint
 */
export const useDeleteHint = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHint>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteHint>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteHintMutationOptions(options), queryClient);
    }

export type getHintUsageResponse200 = {
  data: HintUsage
  status: 200
}

export type getHintUsageResponse400 = {
  data: ApiError
  status: 400
}

export type getHintUsageResponse401 = {
  data: ApiError
  status: 401
}

export type getHintUsageResponse403 = {
  data: ApiError
  status: 403
}

export type getHintUsageResponse404 = {
  data: ApiError
  status: 404
}

export type getHintUsageResponse500 = {
  data: ApiError
  status: 500
}

export type getHintUsageResponseSuccess = (getHintUsageResponse200) & {
  headers: Headers;
};
export type getHintUsageResponseError = (getHintUsageResponse400 | getHintUsageResponse401 | getHintUsageResponse403 | getHintUsageResponse404 | getHintUsageResponse500) & {
  headers: Headers;
};

export type getHintUsageResponse = (getHintUsageResponseSuccess | getHintUsageResponseError)

export const getGetHintUsageUrl = (id: string,) => {




  return `/hints/${id}/usage`
}

/**
 * @summary What deleting this hint would leave behind
 */
export const getHintUsage = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getHintUsageResponse> => {

  return apiFetch<getHintUsageResponse>(getGetHintUsageUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHintUsageQueryKey = (id: string,) => {
    return [
    `/hints/${id}/usage`
    ] as const;
    }


export const getGetHintUsageQueryOptions = <TData = Awaited<ReturnType<typeof getHintUsage>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHintUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHintUsageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHintUsage>>> = ({ signal }) => getHintUsage(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHintUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHintUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getHintUsage>>>
export type GetHintUsageQueryError = ApiError


export function useGetHintUsage<TData = Awaited<ReturnType<typeof getHintUsage>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHintUsage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHintUsage>>,
          TError,
          Awaited<ReturnType<typeof getHintUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHintUsage<TData = Awaited<ReturnType<typeof getHintUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHintUsage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHintUsage>>,
          TError,
          Awaited<ReturnType<typeof getHintUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHintUsage<TData = Awaited<ReturnType<typeof getHintUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHintUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What deleting this hint would leave behind
 */

export function useGetHintUsage<TData = Awaited<ReturnType<typeof getHintUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHintUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHintUsageQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type uploadHintPhotoResponse201 = {
  data: Media
  status: 201
}

export type uploadHintPhotoResponse400 = {
  data: ApiError
  status: 400
}

export type uploadHintPhotoResponse401 = {
  data: ApiError
  status: 401
}

export type uploadHintPhotoResponse403 = {
  data: ApiError
  status: 403
}

export type uploadHintPhotoResponse404 = {
  data: ApiError
  status: 404
}

export type uploadHintPhotoResponse413 = {
  data: ApiError
  status: 413
}

export type uploadHintPhotoResponse500 = {
  data: ApiError
  status: 500
}

export type uploadHintPhotoResponseSuccess = (uploadHintPhotoResponse201) & {
  headers: Headers;
};
export type uploadHintPhotoResponseError = (uploadHintPhotoResponse400 | uploadHintPhotoResponse401 | uploadHintPhotoResponse403 | uploadHintPhotoResponse404 | uploadHintPhotoResponse413 | uploadHintPhotoResponse500) & {
  headers: Headers;
};

export type uploadHintPhotoResponse = (uploadHintPhotoResponseSuccess | uploadHintPhotoResponseError)

export const getUploadHintPhotoUrl = (id: string,) => {




  return `/hints/${id}/photos`
}

/**
 * The request body **is** the photo — raw bytes, not JSON or a multipart form — sent with a `Content-Type` of one of: image/jpeg, image/png, image/webp. At most 10 MiB. One request per photo.
 * @summary Attach a photo to a hint
 */
export const uploadHintPhoto = async (id: string,
    uploadHintPhotoBody: Blob, options?: Parameters<typeof apiFetch>[1]): Promise<uploadHintPhotoResponse> => {

  return apiFetch<uploadHintPhotoResponse>(getUploadHintPhotoUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'image/jpeg', ...options?.headers },
    body: uploadHintPhotoBody
  }
);}





export const getUploadHintPhotoMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadHintPhoto>>, TError,{id: string;data: Blob}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadHintPhoto>>, TError,{id: string;data: Blob}, TContext> => {

const mutationKey = ['uploadHintPhoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadHintPhoto>>, {id: string;data: Blob}> = (props) => {
          const {id,data} = props ?? {};

          return  uploadHintPhoto(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadHintPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof uploadHintPhoto>>>
    export type UploadHintPhotoMutationBody = Blob
    export type UploadHintPhotoMutationError = ApiError

    /**
 * @summary Attach a photo to a hint
 */
export const useUploadHintPhoto = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadHintPhoto>>, TError,{id: string;data: Blob}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadHintPhoto>>,
        TError,
        {id: string;data: Blob},
        TContext
      > => {
      return useMutation(getUploadHintPhotoMutationOptions(options), queryClient);
    }

export type deleteHintPhotoResponse204 = {
  data: void
  status: 204
}

export type deleteHintPhotoResponse400 = {
  data: ApiError
  status: 400
}

export type deleteHintPhotoResponse401 = {
  data: ApiError
  status: 401
}

export type deleteHintPhotoResponse403 = {
  data: ApiError
  status: 403
}

export type deleteHintPhotoResponse404 = {
  data: ApiError
  status: 404
}

export type deleteHintPhotoResponse500 = {
  data: ApiError
  status: 500
}

export type deleteHintPhotoResponseSuccess = (deleteHintPhotoResponse204) & {
  headers: Headers;
};
export type deleteHintPhotoResponseError = (deleteHintPhotoResponse400 | deleteHintPhotoResponse401 | deleteHintPhotoResponse403 | deleteHintPhotoResponse404 | deleteHintPhotoResponse500) & {
  headers: Headers;
};

export type deleteHintPhotoResponse = (deleteHintPhotoResponseSuccess | deleteHintPhotoResponseError)

export const getDeleteHintPhotoUrl = (id: string,
    mediaId: string,) => {




  return `/hints/${id}/photos/${mediaId}`
}

/**
 * @summary Remove a photo from a hint
 */
export const deleteHintPhoto = async (id: string,
    mediaId: string, options?: Parameters<typeof apiFetch>[1]): Promise<deleteHintPhotoResponse> => {

  return apiFetch<deleteHintPhotoResponse>(getDeleteHintPhotoUrl(id,mediaId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteHintPhotoMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHintPhoto>>, TError,{id: string;mediaId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHintPhoto>>, TError,{id: string;mediaId: string}, TContext> => {

const mutationKey = ['deleteHintPhoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHintPhoto>>, {id: string;mediaId: string}> = (props) => {
          const {id,mediaId} = props ?? {};

          return  deleteHintPhoto(id,mediaId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHintPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHintPhoto>>>

    export type DeleteHintPhotoMutationError = ApiError

    /**
 * @summary Remove a photo from a hint
 */
export const useDeleteHintPhoto = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHintPhoto>>, TError,{id: string;mediaId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteHintPhoto>>,
        TError,
        {id: string;mediaId: string},
        TContext
      > => {
      return useMutation(getDeleteHintPhotoMutationOptions(options), queryClient);
    }

export type listInventoryItemsResponse200 = {
  data: InventoryItemPage
  status: 200
}

export type listInventoryItemsResponse400 = {
  data: ApiError
  status: 400
}

export type listInventoryItemsResponse401 = {
  data: ApiError
  status: 401
}

export type listInventoryItemsResponse403 = {
  data: ApiError
  status: 403
}

export type listInventoryItemsResponse404 = {
  data: ApiError
  status: 404
}

export type listInventoryItemsResponse500 = {
  data: ApiError
  status: 500
}

export type listInventoryItemsResponseSuccess = (listInventoryItemsResponse200) & {
  headers: Headers;
};
export type listInventoryItemsResponseError = (listInventoryItemsResponse400 | listInventoryItemsResponse401 | listInventoryItemsResponse403 | listInventoryItemsResponse404 | listInventoryItemsResponse500) & {
  headers: Headers;
};

export type listInventoryItemsResponse = (listInventoryItemsResponseSuccess | listInventoryItemsResponseError)

export const getListInventoryItemsUrl = (id: string,
    params?: ListInventoryItemsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tasks/${id}/inventory-items?${stringifiedParams}` : `/tasks/${id}/inventory-items`
}

/**
 * @summary List a task’s supplies
 */
export const listInventoryItems = async (id: string,
    params?: ListInventoryItemsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listInventoryItemsResponse> => {

  return apiFetch<listInventoryItemsResponse>(getListInventoryItemsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInventoryItemsQueryKey = (id: string,
    params?: ListInventoryItemsParams,) => {
    return [
    `/tasks/${id}/inventory-items`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInventoryItemsQueryOptions = <TData = Awaited<ReturnType<typeof listInventoryItems>>, TError = ApiError>(id: string,
    params?: ListInventoryItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInventoryItems>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInventoryItemsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInventoryItems>>> = ({ signal }) => listInventoryItems(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInventoryItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInventoryItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listInventoryItems>>>
export type ListInventoryItemsQueryError = ApiError


export function useListInventoryItems<TData = Awaited<ReturnType<typeof listInventoryItems>>, TError = ApiError>(
 id: string,
    params: undefined |  ListInventoryItemsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInventoryItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInventoryItems>>,
          TError,
          Awaited<ReturnType<typeof listInventoryItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInventoryItems<TData = Awaited<ReturnType<typeof listInventoryItems>>, TError = ApiError>(
 id: string,
    params?: ListInventoryItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInventoryItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInventoryItems>>,
          TError,
          Awaited<ReturnType<typeof listInventoryItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInventoryItems<TData = Awaited<ReturnType<typeof listInventoryItems>>, TError = ApiError>(
 id: string,
    params?: ListInventoryItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInventoryItems>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a task’s supplies
 */

export function useListInventoryItems<TData = Awaited<ReturnType<typeof listInventoryItems>>, TError = ApiError>(
 id: string,
    params?: ListInventoryItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInventoryItems>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInventoryItemsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createInventoryItemResponse201 = {
  data: InventoryItem
  status: 201
}

export type createInventoryItemResponse400 = {
  data: ApiError
  status: 400
}

export type createInventoryItemResponse401 = {
  data: ApiError
  status: 401
}

export type createInventoryItemResponse403 = {
  data: ApiError
  status: 403
}

export type createInventoryItemResponse404 = {
  data: ApiError
  status: 404
}

export type createInventoryItemResponse500 = {
  data: ApiError
  status: 500
}

export type createInventoryItemResponseSuccess = (createInventoryItemResponse201) & {
  headers: Headers;
};
export type createInventoryItemResponseError = (createInventoryItemResponse400 | createInventoryItemResponse401 | createInventoryItemResponse403 | createInventoryItemResponse404 | createInventoryItemResponse500) & {
  headers: Headers;
};

export type createInventoryItemResponse = (createInventoryItemResponseSuccess | createInventoryItemResponseError)

export const getCreateInventoryItemUrl = (id: string,) => {




  return `/tasks/${id}/inventory-items`
}

/**
 * @summary Add a supply to a task
 */
export const createInventoryItem = async (id: string,
    createInventoryItemRequest: CreateInventoryItemRequest, options?: Parameters<typeof apiFetch>[1]): Promise<createInventoryItemResponse> => {

  return apiFetch<createInventoryItemResponse>(getCreateInventoryItemUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createInventoryItemRequest)
  }
);}





export const getCreateInventoryItemMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInventoryItem>>, TError,{id: string;data: CreateInventoryItemRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInventoryItem>>, TError,{id: string;data: CreateInventoryItemRequest}, TContext> => {

const mutationKey = ['createInventoryItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInventoryItem>>, {id: string;data: CreateInventoryItemRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  createInventoryItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof createInventoryItem>>>
    export type CreateInventoryItemMutationBody = CreateInventoryItemRequest
    export type CreateInventoryItemMutationError = ApiError

    /**
 * @summary Add a supply to a task
 */
export const useCreateInventoryItem = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInventoryItem>>, TError,{id: string;data: CreateInventoryItemRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInventoryItem>>,
        TError,
        {id: string;data: CreateInventoryItemRequest},
        TContext
      > => {
      return useMutation(getCreateInventoryItemMutationOptions(options), queryClient);
    }

export type createInventoryItemsResponse200 = {
  data: CreatedInventoryItems
  status: 200
}

export type createInventoryItemsResponse400 = {
  data: ApiError
  status: 400
}

export type createInventoryItemsResponse401 = {
  data: ApiError
  status: 401
}

export type createInventoryItemsResponse403 = {
  data: ApiError
  status: 403
}

export type createInventoryItemsResponse404 = {
  data: ApiError
  status: 404
}

export type createInventoryItemsResponse500 = {
  data: ApiError
  status: 500
}

export type createInventoryItemsResponseSuccess = (createInventoryItemsResponse200) & {
  headers: Headers;
};
export type createInventoryItemsResponseError = (createInventoryItemsResponse400 | createInventoryItemsResponse401 | createInventoryItemsResponse403 | createInventoryItemsResponse404 | createInventoryItemsResponse500) & {
  headers: Headers;
};

export type createInventoryItemsResponse = (createInventoryItemsResponseSuccess | createInventoryItemsResponseError)

export const getCreateInventoryItemsUrl = (id: string,) => {




  return `/tasks/${id}/inventory-items/batch`
}

/**
 * @summary Add many supplies at once
 */
export const createInventoryItems = async (id: string,
    createInventoryItemsRequest: CreateInventoryItemsRequest, options?: Parameters<typeof apiFetch>[1]): Promise<createInventoryItemsResponse> => {

  return apiFetch<createInventoryItemsResponse>(getCreateInventoryItemsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createInventoryItemsRequest)
  }
);}





export const getCreateInventoryItemsMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInventoryItems>>, TError,{id: string;data: CreateInventoryItemsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInventoryItems>>, TError,{id: string;data: CreateInventoryItemsRequest}, TContext> => {

const mutationKey = ['createInventoryItems'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInventoryItems>>, {id: string;data: CreateInventoryItemsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  createInventoryItems(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInventoryItemsMutationResult = NonNullable<Awaited<ReturnType<typeof createInventoryItems>>>
    export type CreateInventoryItemsMutationBody = CreateInventoryItemsRequest
    export type CreateInventoryItemsMutationError = ApiError

    /**
 * @summary Add many supplies at once
 */
export const useCreateInventoryItems = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInventoryItems>>, TError,{id: string;data: CreateInventoryItemsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInventoryItems>>,
        TError,
        {id: string;data: CreateInventoryItemsRequest},
        TContext
      > => {
      return useMutation(getCreateInventoryItemsMutationOptions(options), queryClient);
    }

export type getInventoryItemResponse200 = {
  data: InventoryItem
  status: 200
}

export type getInventoryItemResponse400 = {
  data: ApiError
  status: 400
}

export type getInventoryItemResponse401 = {
  data: ApiError
  status: 401
}

export type getInventoryItemResponse403 = {
  data: ApiError
  status: 403
}

export type getInventoryItemResponse404 = {
  data: ApiError
  status: 404
}

export type getInventoryItemResponse500 = {
  data: ApiError
  status: 500
}

export type getInventoryItemResponseSuccess = (getInventoryItemResponse200) & {
  headers: Headers;
};
export type getInventoryItemResponseError = (getInventoryItemResponse400 | getInventoryItemResponse401 | getInventoryItemResponse403 | getInventoryItemResponse404 | getInventoryItemResponse500) & {
  headers: Headers;
};

export type getInventoryItemResponse = (getInventoryItemResponseSuccess | getInventoryItemResponseError)

export const getGetInventoryItemUrl = (id: string,) => {




  return `/inventory-items/${id}`
}

/**
 * @summary One supply
 */
export const getInventoryItem = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getInventoryItemResponse> => {

  return apiFetch<getInventoryItemResponse>(getGetInventoryItemUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryItemQueryKey = (id: string,) => {
    return [
    `/inventory-items/${id}`
    ] as const;
    }


export const getGetInventoryItemQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryItem>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryItem>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryItemQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryItem>>> = ({ signal }) => getInventoryItem(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryItem>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInventoryItemQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryItem>>>
export type GetInventoryItemQueryError = ApiError


export function useGetInventoryItem<TData = Awaited<ReturnType<typeof getInventoryItem>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryItem>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryItem>>,
          TError,
          Awaited<ReturnType<typeof getInventoryItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInventoryItem<TData = Awaited<ReturnType<typeof getInventoryItem>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryItem>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryItem>>,
          TError,
          Awaited<ReturnType<typeof getInventoryItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInventoryItem<TData = Awaited<ReturnType<typeof getInventoryItem>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryItem>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One supply
 */

export function useGetInventoryItem<TData = Awaited<ReturnType<typeof getInventoryItem>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryItem>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInventoryItemQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type updateInventoryItemResponse200 = {
  data: InventoryItem
  status: 200
}

export type updateInventoryItemResponse400 = {
  data: ApiError
  status: 400
}

export type updateInventoryItemResponse401 = {
  data: ApiError
  status: 401
}

export type updateInventoryItemResponse403 = {
  data: ApiError
  status: 403
}

export type updateInventoryItemResponse404 = {
  data: ApiError
  status: 404
}

export type updateInventoryItemResponse500 = {
  data: ApiError
  status: 500
}

export type updateInventoryItemResponseSuccess = (updateInventoryItemResponse200) & {
  headers: Headers;
};
export type updateInventoryItemResponseError = (updateInventoryItemResponse400 | updateInventoryItemResponse401 | updateInventoryItemResponse403 | updateInventoryItemResponse404 | updateInventoryItemResponse500) & {
  headers: Headers;
};

export type updateInventoryItemResponse = (updateInventoryItemResponseSuccess | updateInventoryItemResponseError)

export const getUpdateInventoryItemUrl = (id: string,) => {




  return `/inventory-items/${id}`
}

/**
 * @summary Edit a supply’s title or description
 */
export const updateInventoryItem = async (id: string,
    updateInventoryItemRequest: UpdateInventoryItemRequest, options?: Parameters<typeof apiFetch>[1]): Promise<updateInventoryItemResponse> => {

  return apiFetch<updateInventoryItemResponse>(getUpdateInventoryItemUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateInventoryItemRequest)
  }
);}





export const getUpdateInventoryItemMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventoryItem>>, TError,{id: string;data: UpdateInventoryItemRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInventoryItem>>, TError,{id: string;data: UpdateInventoryItemRequest}, TContext> => {

const mutationKey = ['updateInventoryItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInventoryItem>>, {id: string;data: UpdateInventoryItemRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateInventoryItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateInventoryItem>>>
    export type UpdateInventoryItemMutationBody = UpdateInventoryItemRequest
    export type UpdateInventoryItemMutationError = ApiError

    /**
 * @summary Edit a supply’s title or description
 */
export const useUpdateInventoryItem = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventoryItem>>, TError,{id: string;data: UpdateInventoryItemRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateInventoryItem>>,
        TError,
        {id: string;data: UpdateInventoryItemRequest},
        TContext
      > => {
      return useMutation(getUpdateInventoryItemMutationOptions(options), queryClient);
    }

export type deleteInventoryItemResponse204 = {
  data: void
  status: 204
}

export type deleteInventoryItemResponse400 = {
  data: ApiError
  status: 400
}

export type deleteInventoryItemResponse401 = {
  data: ApiError
  status: 401
}

export type deleteInventoryItemResponse403 = {
  data: ApiError
  status: 403
}

export type deleteInventoryItemResponse404 = {
  data: ApiError
  status: 404
}

export type deleteInventoryItemResponse500 = {
  data: ApiError
  status: 500
}

export type deleteInventoryItemResponseSuccess = (deleteInventoryItemResponse204) & {
  headers: Headers;
};
export type deleteInventoryItemResponseError = (deleteInventoryItemResponse400 | deleteInventoryItemResponse401 | deleteInventoryItemResponse403 | deleteInventoryItemResponse404 | deleteInventoryItemResponse500) & {
  headers: Headers;
};

export type deleteInventoryItemResponse = (deleteInventoryItemResponseSuccess | deleteInventoryItemResponseError)

export const getDeleteInventoryItemUrl = (id: string,) => {




  return `/inventory-items/${id}`
}

/**
 * A soft delete, and there is no undo. Its photos are not deleted, and reports already naming it as running low keep their marks. Call `GET /inventory-items/{id}/usage` before confirming.
 * @summary Delete a supply
 */
export const deleteInventoryItem = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<deleteInventoryItemResponse> => {

  return apiFetch<deleteInventoryItemResponse>(getDeleteInventoryItemUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteInventoryItemMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryItem>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryItem>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteInventoryItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInventoryItem>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteInventoryItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInventoryItem>>>

    export type DeleteInventoryItemMutationError = ApiError

    /**
 * @summary Delete a supply
 */
export const useDeleteInventoryItem = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryItem>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteInventoryItem>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteInventoryItemMutationOptions(options), queryClient);
    }

export type getInventoryItemUsageResponse200 = {
  data: InventoryItemUsage
  status: 200
}

export type getInventoryItemUsageResponse400 = {
  data: ApiError
  status: 400
}

export type getInventoryItemUsageResponse401 = {
  data: ApiError
  status: 401
}

export type getInventoryItemUsageResponse403 = {
  data: ApiError
  status: 403
}

export type getInventoryItemUsageResponse404 = {
  data: ApiError
  status: 404
}

export type getInventoryItemUsageResponse500 = {
  data: ApiError
  status: 500
}

export type getInventoryItemUsageResponseSuccess = (getInventoryItemUsageResponse200) & {
  headers: Headers;
};
export type getInventoryItemUsageResponseError = (getInventoryItemUsageResponse400 | getInventoryItemUsageResponse401 | getInventoryItemUsageResponse403 | getInventoryItemUsageResponse404 | getInventoryItemUsageResponse500) & {
  headers: Headers;
};

export type getInventoryItemUsageResponse = (getInventoryItemUsageResponseSuccess | getInventoryItemUsageResponseError)

export const getGetInventoryItemUsageUrl = (id: string,) => {




  return `/inventory-items/${id}/usage`
}

/**
 * @summary What deleting this supply would leave behind
 */
export const getInventoryItemUsage = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getInventoryItemUsageResponse> => {

  return apiFetch<getInventoryItemUsageResponse>(getGetInventoryItemUsageUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInventoryItemUsageQueryKey = (id: string,) => {
    return [
    `/inventory-items/${id}/usage`
    ] as const;
    }


export const getGetInventoryItemUsageQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryItemUsage>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryItemUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryItemUsageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryItemUsage>>> = ({ signal }) => getInventoryItemUsage(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryItemUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInventoryItemUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryItemUsage>>>
export type GetInventoryItemUsageQueryError = ApiError


export function useGetInventoryItemUsage<TData = Awaited<ReturnType<typeof getInventoryItemUsage>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryItemUsage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryItemUsage>>,
          TError,
          Awaited<ReturnType<typeof getInventoryItemUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInventoryItemUsage<TData = Awaited<ReturnType<typeof getInventoryItemUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryItemUsage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryItemUsage>>,
          TError,
          Awaited<ReturnType<typeof getInventoryItemUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInventoryItemUsage<TData = Awaited<ReturnType<typeof getInventoryItemUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryItemUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What deleting this supply would leave behind
 */

export function useGetInventoryItemUsage<TData = Awaited<ReturnType<typeof getInventoryItemUsage>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryItemUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInventoryItemUsageQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type uploadInventoryItemPhotoResponse201 = {
  data: Media
  status: 201
}

export type uploadInventoryItemPhotoResponse400 = {
  data: ApiError
  status: 400
}

export type uploadInventoryItemPhotoResponse401 = {
  data: ApiError
  status: 401
}

export type uploadInventoryItemPhotoResponse403 = {
  data: ApiError
  status: 403
}

export type uploadInventoryItemPhotoResponse404 = {
  data: ApiError
  status: 404
}

export type uploadInventoryItemPhotoResponse413 = {
  data: ApiError
  status: 413
}

export type uploadInventoryItemPhotoResponse500 = {
  data: ApiError
  status: 500
}

export type uploadInventoryItemPhotoResponseSuccess = (uploadInventoryItemPhotoResponse201) & {
  headers: Headers;
};
export type uploadInventoryItemPhotoResponseError = (uploadInventoryItemPhotoResponse400 | uploadInventoryItemPhotoResponse401 | uploadInventoryItemPhotoResponse403 | uploadInventoryItemPhotoResponse404 | uploadInventoryItemPhotoResponse413 | uploadInventoryItemPhotoResponse500) & {
  headers: Headers;
};

export type uploadInventoryItemPhotoResponse = (uploadInventoryItemPhotoResponseSuccess | uploadInventoryItemPhotoResponseError)

export const getUploadInventoryItemPhotoUrl = (id: string,) => {




  return `/inventory-items/${id}/photos`
}

/**
 * The request body **is** the photo — raw bytes, not JSON or a multipart form — sent with a `Content-Type` of one of: image/jpeg, image/png, image/webp. At most 10 MiB. One request per photo.
 * @summary Attach a photo to a supply
 */
export const uploadInventoryItemPhoto = async (id: string,
    uploadInventoryItemPhotoBody: Blob, options?: Parameters<typeof apiFetch>[1]): Promise<uploadInventoryItemPhotoResponse> => {

  return apiFetch<uploadInventoryItemPhotoResponse>(getUploadInventoryItemPhotoUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'image/jpeg', ...options?.headers },
    body: uploadInventoryItemPhotoBody
  }
);}





export const getUploadInventoryItemPhotoMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadInventoryItemPhoto>>, TError,{id: string;data: Blob}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadInventoryItemPhoto>>, TError,{id: string;data: Blob}, TContext> => {

const mutationKey = ['uploadInventoryItemPhoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadInventoryItemPhoto>>, {id: string;data: Blob}> = (props) => {
          const {id,data} = props ?? {};

          return  uploadInventoryItemPhoto(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadInventoryItemPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof uploadInventoryItemPhoto>>>
    export type UploadInventoryItemPhotoMutationBody = Blob
    export type UploadInventoryItemPhotoMutationError = ApiError

    /**
 * @summary Attach a photo to a supply
 */
export const useUploadInventoryItemPhoto = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadInventoryItemPhoto>>, TError,{id: string;data: Blob}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadInventoryItemPhoto>>,
        TError,
        {id: string;data: Blob},
        TContext
      > => {
      return useMutation(getUploadInventoryItemPhotoMutationOptions(options), queryClient);
    }

export type deleteInventoryItemPhotoResponse204 = {
  data: void
  status: 204
}

export type deleteInventoryItemPhotoResponse400 = {
  data: ApiError
  status: 400
}

export type deleteInventoryItemPhotoResponse401 = {
  data: ApiError
  status: 401
}

export type deleteInventoryItemPhotoResponse403 = {
  data: ApiError
  status: 403
}

export type deleteInventoryItemPhotoResponse404 = {
  data: ApiError
  status: 404
}

export type deleteInventoryItemPhotoResponse500 = {
  data: ApiError
  status: 500
}

export type deleteInventoryItemPhotoResponseSuccess = (deleteInventoryItemPhotoResponse204) & {
  headers: Headers;
};
export type deleteInventoryItemPhotoResponseError = (deleteInventoryItemPhotoResponse400 | deleteInventoryItemPhotoResponse401 | deleteInventoryItemPhotoResponse403 | deleteInventoryItemPhotoResponse404 | deleteInventoryItemPhotoResponse500) & {
  headers: Headers;
};

export type deleteInventoryItemPhotoResponse = (deleteInventoryItemPhotoResponseSuccess | deleteInventoryItemPhotoResponseError)

export const getDeleteInventoryItemPhotoUrl = (id: string,
    mediaId: string,) => {




  return `/inventory-items/${id}/photos/${mediaId}`
}

/**
 * @summary Remove a photo from a supply
 */
export const deleteInventoryItemPhoto = async (id: string,
    mediaId: string, options?: Parameters<typeof apiFetch>[1]): Promise<deleteInventoryItemPhotoResponse> => {

  return apiFetch<deleteInventoryItemPhotoResponse>(getDeleteInventoryItemPhotoUrl(id,mediaId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteInventoryItemPhotoMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryItemPhoto>>, TError,{id: string;mediaId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryItemPhoto>>, TError,{id: string;mediaId: string}, TContext> => {

const mutationKey = ['deleteInventoryItemPhoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInventoryItemPhoto>>, {id: string;mediaId: string}> = (props) => {
          const {id,mediaId} = props ?? {};

          return  deleteInventoryItemPhoto(id,mediaId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteInventoryItemPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInventoryItemPhoto>>>

    export type DeleteInventoryItemPhotoMutationError = ApiError

    /**
 * @summary Remove a photo from a supply
 */
export const useDeleteInventoryItemPhoto = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryItemPhoto>>, TError,{id: string;mediaId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteInventoryItemPhoto>>,
        TError,
        {id: string;mediaId: string},
        TContext
      > => {
      return useMutation(getDeleteInventoryItemPhotoMutationOptions(options), queryClient);
    }

export type getMediaResponse200ImageJpeg = {
  data: Blob
  status: 200
}

export type getMediaResponse200ImagePng = {
  data: Blob
  status: 200
}

export type getMediaResponse200ImageWebp = {
  data: Blob
  status: 200
}

export type getMediaResponse400 = {
  data: ApiError
  status: 400
}

export type getMediaResponse401 = {
  data: ApiError
  status: 401
}

export type getMediaResponse404 = {
  data: ApiError
  status: 404
}

export type getMediaResponse500 = {
  data: ApiError
  status: 500
}

export type getMediaResponseSuccess = (getMediaResponse200ImageJpeg | getMediaResponse200ImagePng | getMediaResponse200ImageWebp) & {
  headers: Headers;
};
export type getMediaResponseError = (getMediaResponse400 | getMediaResponse401 | getMediaResponse404 | getMediaResponse500) & {
  headers: Headers;
};

export type getMediaResponse = (getMediaResponseSuccess | getMediaResponseError)

export const getGetMediaUrl = (id: string,) => {




  return `/media/${id}`
}

/**
 * Any authenticated member of the tenant that owns the photo may call this — an `admin` or an `employee` — because a worker views hint photos on their assignment and an admin reviews them from the catalogue. There is no role floor beyond authentication.
 * @summary Fetch a photo’s bytes
 */
export const getMedia = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getMediaResponse> => {

  return apiFetch<getMediaResponse>(getGetMediaUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMediaQueryKey = (id: string,) => {
    return [
    `/media/${id}`
    ] as const;
    }


export const getGetMediaQueryOptions = <TData = Awaited<ReturnType<typeof getMedia>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedia>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMediaQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedia>>> = ({ signal }) => getMedia(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMedia>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMediaQueryResult = NonNullable<Awaited<ReturnType<typeof getMedia>>>
export type GetMediaQueryError = ApiError


export function useGetMedia<TData = Awaited<ReturnType<typeof getMedia>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedia>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedia>>,
          TError,
          Awaited<ReturnType<typeof getMedia>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedia<TData = Awaited<ReturnType<typeof getMedia>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedia>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedia>>,
          TError,
          Awaited<ReturnType<typeof getMedia>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMedia<TData = Awaited<ReturnType<typeof getMedia>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedia>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch a photo’s bytes
 */

export function useGetMedia<TData = Awaited<ReturnType<typeof getMedia>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedia>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMediaQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getMyDayResponse200 = {
  data: WorkerDay
  status: 200
}

export type getMyDayResponse400 = {
  data: ApiError
  status: 400
}

export type getMyDayResponse401 = {
  data: ApiError
  status: 401
}

export type getMyDayResponse500 = {
  data: ApiError
  status: 500
}

export type getMyDayResponseSuccess = (getMyDayResponse200) & {
  headers: Headers;
};
export type getMyDayResponseError = (getMyDayResponse400 | getMyDayResponse401 | getMyDayResponse500) & {
  headers: Headers;
};

export type getMyDayResponse = (getMyDayResponseSuccess | getMyDayResponseError)

export const getGetMyDayUrl = (params: GetMyDayParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/assignments/mine/day?${stringifiedParams}` : `/assignments/mine/day`
}

/**
 * Every job this worker has on one calendar date — each with its location’s name and address, its rooms, the tasks materialised into them, each task’s hints, the job’s supplies, its staged photos and its report when one exists — plus today’s date in the tenant’s timezone and the job that is currently running, whatever its date.
 *
 * `date` is a plain `YYYY-MM-DD` label read in the **tenant’s** timezone; this operation neither takes nor returns an instant for a calendar question, so a client never converts a date to an instant to ask one.
 *
 * There is **no status parameter**: every status is in the answer.
 * @summary My whole day, in one request
 */
export const getMyDay = async (params: GetMyDayParams, options?: Parameters<typeof apiFetch>[1]): Promise<getMyDayResponse> => {

  return apiFetch<getMyDayResponse>(getGetMyDayUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyDayQueryKey = (params?: GetMyDayParams,) => {
    return [
    `/assignments/mine/day`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyDayQueryOptions = <TData = Awaited<ReturnType<typeof getMyDay>>, TError = ApiError>(params: GetMyDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyDay>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyDayQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyDay>>> = ({ signal }) => getMyDay(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyDay>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyDayQueryResult = NonNullable<Awaited<ReturnType<typeof getMyDay>>>
export type GetMyDayQueryError = ApiError


export function useGetMyDay<TData = Awaited<ReturnType<typeof getMyDay>>, TError = ApiError>(
 params: GetMyDayParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyDay>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyDay>>,
          TError,
          Awaited<ReturnType<typeof getMyDay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyDay<TData = Awaited<ReturnType<typeof getMyDay>>, TError = ApiError>(
 params: GetMyDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyDay>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyDay>>,
          TError,
          Awaited<ReturnType<typeof getMyDay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyDay<TData = Awaited<ReturnType<typeof getMyDay>>, TError = ApiError>(
 params: GetMyDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyDay>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary My whole day, in one request
 */

export function useGetMyDay<TData = Awaited<ReturnType<typeof getMyDay>>, TError = ApiError>(
 params: GetMyDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyDay>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyDayQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listMyWorkDatesResponse200 = {
  data: WorkerWorkDates
  status: 200
}

export type listMyWorkDatesResponse400 = {
  data: ApiError
  status: 400
}

export type listMyWorkDatesResponse401 = {
  data: ApiError
  status: 401
}

export type listMyWorkDatesResponse500 = {
  data: ApiError
  status: 500
}

export type listMyWorkDatesResponseSuccess = (listMyWorkDatesResponse200) & {
  headers: Headers;
};
export type listMyWorkDatesResponseError = (listMyWorkDatesResponse400 | listMyWorkDatesResponse401 | listMyWorkDatesResponse500) & {
  headers: Headers;
};

export type listMyWorkDatesResponse = (listMyWorkDatesResponseSuccess | listMyWorkDatesResponseError)

export const getListMyWorkDatesUrl = (params: ListMyWorkDatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/assignments/mine/days?${stringifiedParams}` : `/assignments/mine/days`
}

/**
 * The dates only, with a count each — what §8’s calendar marks are drawn from. The range is inclusive at both ends and at most 366 days long; a longer one, or one that runs backwards, is a `validation_failed` naming `to`.
 * @summary Which days in a range I have work on
 */
export const listMyWorkDates = async (params: ListMyWorkDatesParams, options?: Parameters<typeof apiFetch>[1]): Promise<listMyWorkDatesResponse> => {

  return apiFetch<listMyWorkDatesResponse>(getListMyWorkDatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyWorkDatesQueryKey = (params?: ListMyWorkDatesParams,) => {
    return [
    `/assignments/mine/days`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMyWorkDatesQueryOptions = <TData = Awaited<ReturnType<typeof listMyWorkDates>>, TError = ApiError>(params: ListMyWorkDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyWorkDates>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyWorkDatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyWorkDates>>> = ({ signal }) => listMyWorkDates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyWorkDates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMyWorkDatesQueryResult = NonNullable<Awaited<ReturnType<typeof listMyWorkDates>>>
export type ListMyWorkDatesQueryError = ApiError


export function useListMyWorkDates<TData = Awaited<ReturnType<typeof listMyWorkDates>>, TError = ApiError>(
 params: ListMyWorkDatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyWorkDates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyWorkDates>>,
          TError,
          Awaited<ReturnType<typeof listMyWorkDates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyWorkDates<TData = Awaited<ReturnType<typeof listMyWorkDates>>, TError = ApiError>(
 params: ListMyWorkDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyWorkDates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyWorkDates>>,
          TError,
          Awaited<ReturnType<typeof listMyWorkDates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyWorkDates<TData = Awaited<ReturnType<typeof listMyWorkDates>>, TError = ApiError>(
 params: ListMyWorkDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyWorkDates>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Which days in a range I have work on
 */

export function useListMyWorkDates<TData = Awaited<ReturnType<typeof listMyWorkDates>>, TError = ApiError>(
 params: ListMyWorkDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyWorkDates>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyWorkDatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getMyJobResponse200 = {
  data: WorkerJob
  status: 200
}

export type getMyJobResponse400 = {
  data: ApiError
  status: 400
}

export type getMyJobResponse401 = {
  data: ApiError
  status: 401
}

export type getMyJobResponse404 = {
  data: ApiError
  status: 404
}

export type getMyJobResponse500 = {
  data: ApiError
  status: 500
}

export type getMyJobResponseSuccess = (getMyJobResponse200) & {
  headers: Headers;
};
export type getMyJobResponseError = (getMyJobResponse400 | getMyJobResponse401 | getMyJobResponse404 | getMyJobResponse500) & {
  headers: Headers;
};

export type getMyJobResponse = (getMyJobResponseSuccess | getMyJobResponseError)

export const getGetMyJobUrl = (id: string,) => {




  return `/assignments/mine/${id}/job`
}

/**
 * The same document `GET /assignments/mine/day` carries for one job. Read it for a job the client holds no day document for — the one reached from §7.1’s running-job banner, which may be on any date — and to refetch a single job (§7.5, §9.4).
 * @summary One of my jobs, whole
 */
export const getMyJob = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getMyJobResponse> => {

  return apiFetch<getMyJobResponse>(getGetMyJobUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyJobQueryKey = (id: string,) => {
    return [
    `/assignments/mine/${id}/job`
    ] as const;
    }


export const getGetMyJobQueryOptions = <TData = Awaited<ReturnType<typeof getMyJob>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyJob>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyJobQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyJob>>> = ({ signal }) => getMyJob(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyJob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyJobQueryResult = NonNullable<Awaited<ReturnType<typeof getMyJob>>>
export type GetMyJobQueryError = ApiError


export function useGetMyJob<TData = Awaited<ReturnType<typeof getMyJob>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyJob>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyJob>>,
          TError,
          Awaited<ReturnType<typeof getMyJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyJob<TData = Awaited<ReturnType<typeof getMyJob>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyJob>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyJob>>,
          TError,
          Awaited<ReturnType<typeof getMyJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyJob<TData = Awaited<ReturnType<typeof getMyJob>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyJob>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One of my jobs, whole
 */

export function useGetMyJob<TData = Awaited<ReturnType<typeof getMyJob>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyJob>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyJobQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listAssignmentsResponse200 = {
  data: AssignmentWithNamesPage
  status: 200
}

export type listAssignmentsResponse400 = {
  data: ApiError
  status: 400
}

export type listAssignmentsResponse401 = {
  data: ApiError
  status: 401
}

export type listAssignmentsResponse403 = {
  data: ApiError
  status: 403
}

export type listAssignmentsResponse500 = {
  data: ApiError
  status: 500
}

export type listAssignmentsResponseSuccess = (listAssignmentsResponse200) & {
  headers: Headers;
};
export type listAssignmentsResponseError = (listAssignmentsResponse400 | listAssignmentsResponse401 | listAssignmentsResponse403 | listAssignmentsResponse500) & {
  headers: Headers;
};

export type listAssignmentsResponse = (listAssignmentsResponseSuccess | listAssignmentsResponseError)

export const getListAssignmentsUrl = (params?: ListAssignmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["status"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/assignments?${stringifiedParams}` : `/assignments`
}

/**
 * Every occurrence in this tenant, filtered and paginated, each carrying its location’s and its assignee’s name (`AssignmentWithNames` — **B13**). Soft-deleted assignments are absent; a soft-deleted location’s or assignee’s *name* is not — both are read past their own soft deletion (`docs/reference/ISSUES.md` HB10). `sort=name` requires a bounded `from`/`to` (at most 31 days) — see `AssignmentSort`.
 * @summary The tenant’s assignments for a day or a range
 */
export const listAssignments = async (params?: ListAssignmentsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listAssignmentsResponse> => {

  return apiFetch<listAssignmentsResponse>(getListAssignmentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAssignmentsQueryKey = (params?: ListAssignmentsParams,) => {
    return [
    `/assignments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof listAssignments>>, TError = ApiError>(params?: ListAssignmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssignments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssignmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssignments>>> = ({ signal }) => listAssignments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssignments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAssignments>>>
export type ListAssignmentsQueryError = ApiError


export function useListAssignments<TData = Awaited<ReturnType<typeof listAssignments>>, TError = ApiError>(
 params: undefined |  ListAssignmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssignments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssignments>>,
          TError,
          Awaited<ReturnType<typeof listAssignments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssignments<TData = Awaited<ReturnType<typeof listAssignments>>, TError = ApiError>(
 params?: ListAssignmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssignments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssignments>>,
          TError,
          Awaited<ReturnType<typeof listAssignments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssignments<TData = Awaited<ReturnType<typeof listAssignments>>, TError = ApiError>(
 params?: ListAssignmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssignments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The tenant’s assignments for a day or a range
 */

export function useListAssignments<TData = Awaited<ReturnType<typeof listAssignments>>, TError = ApiError>(
 params?: ListAssignmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssignments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAssignmentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createAssignmentResponse201 = {
  data: Assignment
  status: 201
}

export type createAssignmentResponse400 = {
  data: ApiError
  status: 400
}

export type createAssignmentResponse401 = {
  data: ApiError
  status: 401
}

export type createAssignmentResponse403 = {
  data: ApiError
  status: 403
}

export type createAssignmentResponse500 = {
  data: ApiError
  status: 500
}

export type createAssignmentResponseSuccess = (createAssignmentResponse201) & {
  headers: Headers;
};
export type createAssignmentResponseError = (createAssignmentResponse400 | createAssignmentResponse401 | createAssignmentResponse403 | createAssignmentResponse500) & {
  headers: Headers;
};

export type createAssignmentResponse = (createAssignmentResponseSuccess | createAssignmentResponseError)

export const getCreateAssignmentUrl = () => {




  return `/assignments`
}

/**
 * Runs the cadence engine exactly like a batch of one — there is no second creation path (`docs/reference/ISSUES.md` HB7).
 * @summary Create one assignment
 */
export const createAssignment = async (createAssignmentRequest: CreateAssignmentRequest, options?: Parameters<typeof apiFetch>[1]): Promise<createAssignmentResponse> => {

  return apiFetch<createAssignmentResponse>(getCreateAssignmentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAssignmentRequest)
  }
);}





export const getCreateAssignmentMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssignment>>, TError,{data: CreateAssignmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAssignment>>, TError,{data: CreateAssignmentRequest}, TContext> => {

const mutationKey = ['createAssignment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAssignment>>, {data: CreateAssignmentRequest}> = (props) => {
          const {data} = props ?? {};

          return  createAssignment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof createAssignment>>>
    export type CreateAssignmentMutationBody = CreateAssignmentRequest
    export type CreateAssignmentMutationError = ApiError

    /**
 * @summary Create one assignment
 */
export const useCreateAssignment = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssignment>>, TError,{data: CreateAssignmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAssignment>>,
        TError,
        {data: CreateAssignmentRequest},
        TContext
      > => {
      return useMutation(getCreateAssignmentMutationOptions(options), queryClient);
    }

export type createAssignmentBatchResponse201 = {
  data: AssignmentBatch
  status: 201
}

export type createAssignmentBatchResponse400 = {
  data: ApiError
  status: 400
}

export type createAssignmentBatchResponse401 = {
  data: ApiError
  status: 401
}

export type createAssignmentBatchResponse403 = {
  data: ApiError
  status: 403
}

export type createAssignmentBatchResponse409 = {
  data: ApiError
  status: 409
}

export type createAssignmentBatchResponse500 = {
  data: ApiError
  status: 500
}

export type createAssignmentBatchResponseSuccess = (createAssignmentBatchResponse201) & {
  headers: Headers;
};
export type createAssignmentBatchResponseError = (createAssignmentBatchResponse400 | createAssignmentBatchResponse401 | createAssignmentBatchResponse403 | createAssignmentBatchResponse409 | createAssignmentBatchResponse500) & {
  headers: Headers;
};

export type createAssignmentBatchResponse = (createAssignmentBatchResponseSuccess | createAssignmentBatchResponseError)

export const getCreateAssignmentBatchUrl = () => {




  return `/assignments/batch`
}

/**
 * One shared `group_id` for every date given, the cadence engine run once over the whole batch in date order. All-or-nothing: either every occurrence is created or none is.
 * @summary Create a recurring series
 */
export const createAssignmentBatch = async (createAssignmentBatchRequest: CreateAssignmentBatchRequest, options?: Parameters<typeof apiFetch>[1]): Promise<createAssignmentBatchResponse> => {

  return apiFetch<createAssignmentBatchResponse>(getCreateAssignmentBatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAssignmentBatchRequest)
  }
);}





export const getCreateAssignmentBatchMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssignmentBatch>>, TError,{data: CreateAssignmentBatchRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAssignmentBatch>>, TError,{data: CreateAssignmentBatchRequest}, TContext> => {

const mutationKey = ['createAssignmentBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAssignmentBatch>>, {data: CreateAssignmentBatchRequest}> = (props) => {
          const {data} = props ?? {};

          return  createAssignmentBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAssignmentBatchMutationResult = NonNullable<Awaited<ReturnType<typeof createAssignmentBatch>>>
    export type CreateAssignmentBatchMutationBody = CreateAssignmentBatchRequest
    export type CreateAssignmentBatchMutationError = ApiError

    /**
 * @summary Create a recurring series
 */
export const useCreateAssignmentBatch = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssignmentBatch>>, TError,{data: CreateAssignmentBatchRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAssignmentBatch>>,
        TError,
        {data: CreateAssignmentBatchRequest},
        TContext
      > => {
      return useMutation(getCreateAssignmentBatchMutationOptions(options), queryClient);
    }

export type listMyAssignmentsResponse200 = {
  data: AssignmentPage
  status: 200
}

export type listMyAssignmentsResponse400 = {
  data: ApiError
  status: 400
}

export type listMyAssignmentsResponse401 = {
  data: ApiError
  status: 401
}

export type listMyAssignmentsResponse500 = {
  data: ApiError
  status: 500
}

export type listMyAssignmentsResponseSuccess = (listMyAssignmentsResponse200) & {
  headers: Headers;
};
export type listMyAssignmentsResponseError = (listMyAssignmentsResponse400 | listMyAssignmentsResponse401 | listMyAssignmentsResponse500) & {
  headers: Headers;
};

export type listMyAssignmentsResponse = (listMyAssignmentsResponseSuccess | listMyAssignmentsResponseError)

export const getListMyAssignmentsUrl = (params?: ListMyAssignmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["status"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/assignments/mine?${stringifiedParams}` : `/assignments/mine`
}

/**
 * Scoped to the calling session — there is no field anywhere that names a different user (`docs/ux/WORKER-APP.md` §19).
 * @summary My own assignments for a day or a range
 */
export const listMyAssignments = async (params?: ListMyAssignmentsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listMyAssignmentsResponse> => {

  return apiFetch<listMyAssignmentsResponse>(getListMyAssignmentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyAssignmentsQueryKey = (params?: ListMyAssignmentsParams,) => {
    return [
    `/assignments/mine`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMyAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof listMyAssignments>>, TError = ApiError>(params?: ListMyAssignmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAssignments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyAssignmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyAssignments>>> = ({ signal }) => listMyAssignments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyAssignments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMyAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyAssignments>>>
export type ListMyAssignmentsQueryError = ApiError


export function useListMyAssignments<TData = Awaited<ReturnType<typeof listMyAssignments>>, TError = ApiError>(
 params: undefined |  ListMyAssignmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAssignments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyAssignments>>,
          TError,
          Awaited<ReturnType<typeof listMyAssignments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyAssignments<TData = Awaited<ReturnType<typeof listMyAssignments>>, TError = ApiError>(
 params?: ListMyAssignmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAssignments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyAssignments>>,
          TError,
          Awaited<ReturnType<typeof listMyAssignments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyAssignments<TData = Awaited<ReturnType<typeof listMyAssignments>>, TError = ApiError>(
 params?: ListMyAssignmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAssignments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary My own assignments for a day or a range
 */

export function useListMyAssignments<TData = Awaited<ReturnType<typeof listMyAssignments>>, TError = ApiError>(
 params?: ListMyAssignmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAssignments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyAssignmentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getCurrentAssignmentResponse200 = {
  data: CurrentAssignment
  status: 200
}

export type getCurrentAssignmentResponse400 = {
  data: ApiError
  status: 400
}

export type getCurrentAssignmentResponse401 = {
  data: ApiError
  status: 401
}

export type getCurrentAssignmentResponse500 = {
  data: ApiError
  status: 500
}

export type getCurrentAssignmentResponseSuccess = (getCurrentAssignmentResponse200) & {
  headers: Headers;
};
export type getCurrentAssignmentResponseError = (getCurrentAssignmentResponse400 | getCurrentAssignmentResponse401 | getCurrentAssignmentResponse500) & {
  headers: Headers;
};

export type getCurrentAssignmentResponse = (getCurrentAssignmentResponseSuccess | getCurrentAssignmentResponseError)

export const getGetCurrentAssignmentUrl = () => {




  return `/assignments/mine/current`
}

/**
 * Independent of date — a job started yesterday, on another device, or before a reinstall is still the current one. `null` is an ordinary answer, not a `not_found`.
 * @summary My currently in-progress assignment, if any
 */
export const getCurrentAssignment = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getCurrentAssignmentResponse> => {

  return apiFetch<getCurrentAssignmentResponse>(getGetCurrentAssignmentUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentAssignmentQueryKey = () => {
    return [
    `/assignments/mine/current`
    ] as const;
    }


export const getGetCurrentAssignmentQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentAssignment>>, TError = ApiError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentAssignment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentAssignmentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentAssignment>>> = ({ signal }) => getCurrentAssignment({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentAssignment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentAssignmentQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentAssignment>>>
export type GetCurrentAssignmentQueryError = ApiError


export function useGetCurrentAssignment<TData = Awaited<ReturnType<typeof getCurrentAssignment>>, TError = ApiError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentAssignment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentAssignment>>,
          TError,
          Awaited<ReturnType<typeof getCurrentAssignment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentAssignment<TData = Awaited<ReturnType<typeof getCurrentAssignment>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentAssignment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentAssignment>>,
          TError,
          Awaited<ReturnType<typeof getCurrentAssignment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentAssignment<TData = Awaited<ReturnType<typeof getCurrentAssignment>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentAssignment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary My currently in-progress assignment, if any
 */

export function useGetCurrentAssignment<TData = Awaited<ReturnType<typeof getCurrentAssignment>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentAssignment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentAssignmentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getMyAssignmentResponse200 = {
  data: Assignment
  status: 200
}

export type getMyAssignmentResponse400 = {
  data: ApiError
  status: 400
}

export type getMyAssignmentResponse401 = {
  data: ApiError
  status: 401
}

export type getMyAssignmentResponse404 = {
  data: ApiError
  status: 404
}

export type getMyAssignmentResponse500 = {
  data: ApiError
  status: 500
}

export type getMyAssignmentResponseSuccess = (getMyAssignmentResponse200) & {
  headers: Headers;
};
export type getMyAssignmentResponseError = (getMyAssignmentResponse400 | getMyAssignmentResponse401 | getMyAssignmentResponse404 | getMyAssignmentResponse500) & {
  headers: Headers;
};

export type getMyAssignmentResponse = (getMyAssignmentResponseSuccess | getMyAssignmentResponseError)

export const getGetMyAssignmentUrl = (id: string,) => {




  return `/assignments/mine/${id}`
}

/**
 * @summary One of my own assignments
 */
export const getMyAssignment = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getMyAssignmentResponse> => {

  return apiFetch<getMyAssignmentResponse>(getGetMyAssignmentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyAssignmentQueryKey = (id: string,) => {
    return [
    `/assignments/mine/${id}`
    ] as const;
    }


export const getGetMyAssignmentQueryOptions = <TData = Awaited<ReturnType<typeof getMyAssignment>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAssignment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyAssignmentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyAssignment>>> = ({ signal }) => getMyAssignment(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyAssignment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyAssignmentQueryResult = NonNullable<Awaited<ReturnType<typeof getMyAssignment>>>
export type GetMyAssignmentQueryError = ApiError


export function useGetMyAssignment<TData = Awaited<ReturnType<typeof getMyAssignment>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAssignment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyAssignment>>,
          TError,
          Awaited<ReturnType<typeof getMyAssignment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyAssignment<TData = Awaited<ReturnType<typeof getMyAssignment>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAssignment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyAssignment>>,
          TError,
          Awaited<ReturnType<typeof getMyAssignment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyAssignment<TData = Awaited<ReturnType<typeof getMyAssignment>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAssignment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One of my own assignments
 */

export function useGetMyAssignment<TData = Awaited<ReturnType<typeof getMyAssignment>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAssignment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyAssignmentQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type startMyAssignmentResponse200 = {
  data: Assignment
  status: 200
}

export type startMyAssignmentResponse400 = {
  data: ApiError
  status: 400
}

export type startMyAssignmentResponse401 = {
  data: ApiError
  status: 401
}

export type startMyAssignmentResponse404 = {
  data: ApiError
  status: 404
}

export type startMyAssignmentResponse409 = {
  data: ApiError
  status: 409
}

export type startMyAssignmentResponse500 = {
  data: ApiError
  status: 500
}

export type startMyAssignmentResponseSuccess = (startMyAssignmentResponse200) & {
  headers: Headers;
};
export type startMyAssignmentResponseError = (startMyAssignmentResponse400 | startMyAssignmentResponse401 | startMyAssignmentResponse404 | startMyAssignmentResponse409 | startMyAssignmentResponse500) & {
  headers: Headers;
};

export type startMyAssignmentResponse = (startMyAssignmentResponseSuccess | startMyAssignmentResponseError)

export const getStartMyAssignmentUrl = (id: string,) => {




  return `/assignments/mine/${id}/start`
}

/**
 * Refused server-side while another of the caller’s assignments is already `in_progress` (`docs/ux/WORKER-APP.md` §10.6 — a rule no client can enforce alone), for a day that has already rolled over, or for a `startedAt` outside the assignment’s own local day.
 * @summary Start one of my own assignments
 */
export const startMyAssignment = async (id: string,
    startAssignmentRequest: StartAssignmentRequest, options?: Parameters<typeof apiFetch>[1]): Promise<startMyAssignmentResponse> => {

  return apiFetch<startMyAssignmentResponse>(getStartMyAssignmentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(startAssignmentRequest)
  }
);}





export const getStartMyAssignmentMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startMyAssignment>>, TError,{id: string;data: StartAssignmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startMyAssignment>>, TError,{id: string;data: StartAssignmentRequest}, TContext> => {

const mutationKey = ['startMyAssignment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startMyAssignment>>, {id: string;data: StartAssignmentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  startMyAssignment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartMyAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof startMyAssignment>>>
    export type StartMyAssignmentMutationBody = StartAssignmentRequest
    export type StartMyAssignmentMutationError = ApiError

    /**
 * @summary Start one of my own assignments
 */
export const useStartMyAssignment = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startMyAssignment>>, TError,{id: string;data: StartAssignmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startMyAssignment>>,
        TError,
        {id: string;data: StartAssignmentRequest},
        TContext
      > => {
      return useMutation(getStartMyAssignmentMutationOptions(options), queryClient);
    }

export type getAssignmentResponse200 = {
  data: AssignmentWithNames
  status: 200
}

export type getAssignmentResponse400 = {
  data: ApiError
  status: 400
}

export type getAssignmentResponse401 = {
  data: ApiError
  status: 401
}

export type getAssignmentResponse403 = {
  data: ApiError
  status: 403
}

export type getAssignmentResponse404 = {
  data: ApiError
  status: 404
}

export type getAssignmentResponse500 = {
  data: ApiError
  status: 500
}

export type getAssignmentResponseSuccess = (getAssignmentResponse200) & {
  headers: Headers;
};
export type getAssignmentResponseError = (getAssignmentResponse400 | getAssignmentResponse401 | getAssignmentResponse403 | getAssignmentResponse404 | getAssignmentResponse500) & {
  headers: Headers;
};

export type getAssignmentResponse = (getAssignmentResponseSuccess | getAssignmentResponseError)

export const getGetAssignmentUrl = (id: string,) => {




  return `/assignments/${id}`
}

/**
 * Carries its location’s and its assignee’s name (`AssignmentWithNames` — **B13**), read past either parent’s own soft deletion (`docs/reference/ISSUES.md` HB10) — the same join `GET /assignments` uses.
 * @summary One assignment
 */
export const getAssignment = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getAssignmentResponse> => {

  return apiFetch<getAssignmentResponse>(getGetAssignmentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssignmentQueryKey = (id: string,) => {
    return [
    `/assignments/${id}`
    ] as const;
    }


export const getGetAssignmentQueryOptions = <TData = Awaited<ReturnType<typeof getAssignment>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssignment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssignmentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssignment>>> = ({ signal }) => getAssignment(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssignment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssignmentQueryResult = NonNullable<Awaited<ReturnType<typeof getAssignment>>>
export type GetAssignmentQueryError = ApiError


export function useGetAssignment<TData = Awaited<ReturnType<typeof getAssignment>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssignment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignment>>,
          TError,
          Awaited<ReturnType<typeof getAssignment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssignment<TData = Awaited<ReturnType<typeof getAssignment>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssignment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignment>>,
          TError,
          Awaited<ReturnType<typeof getAssignment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssignment<TData = Awaited<ReturnType<typeof getAssignment>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssignment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One assignment
 */

export function useGetAssignment<TData = Awaited<ReturnType<typeof getAssignment>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssignment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssignmentQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type updateAssignmentResponse200 = {
  data: Assignment
  status: 200
}

export type updateAssignmentResponse400 = {
  data: ApiError
  status: 400
}

export type updateAssignmentResponse401 = {
  data: ApiError
  status: 401
}

export type updateAssignmentResponse403 = {
  data: ApiError
  status: 403
}

export type updateAssignmentResponse404 = {
  data: ApiError
  status: 404
}

export type updateAssignmentResponse409 = {
  data: ApiError
  status: 409
}

export type updateAssignmentResponse500 = {
  data: ApiError
  status: 500
}

export type updateAssignmentResponseSuccess = (updateAssignmentResponse200) & {
  headers: Headers;
};
export type updateAssignmentResponseError = (updateAssignmentResponse400 | updateAssignmentResponse401 | updateAssignmentResponse403 | updateAssignmentResponse404 | updateAssignmentResponse409 | updateAssignmentResponse500) & {
  headers: Headers;
};

export type updateAssignmentResponse = (updateAssignmentResponseSuccess | updateAssignmentResponseError)

export const getUpdateAssignmentUrl = (id: string,) => {




  return `/assignments/${id}`
}

/**
 * @summary Reassign, reschedule or annotate an assignment
 */
export const updateAssignment = async (id: string,
    updateAssignmentRequest: UpdateAssignmentRequest, options?: Parameters<typeof apiFetch>[1]): Promise<updateAssignmentResponse> => {

  return apiFetch<updateAssignmentResponse>(getUpdateAssignmentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateAssignmentRequest)
  }
);}





export const getUpdateAssignmentMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssignment>>, TError,{id: string;data: UpdateAssignmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAssignment>>, TError,{id: string;data: UpdateAssignmentRequest}, TContext> => {

const mutationKey = ['updateAssignment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAssignment>>, {id: string;data: UpdateAssignmentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAssignment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateAssignment>>>
    export type UpdateAssignmentMutationBody = UpdateAssignmentRequest
    export type UpdateAssignmentMutationError = ApiError

    /**
 * @summary Reassign, reschedule or annotate an assignment
 */
export const useUpdateAssignment = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssignment>>, TError,{id: string;data: UpdateAssignmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAssignment>>,
        TError,
        {id: string;data: UpdateAssignmentRequest},
        TContext
      > => {
      return useMutation(getUpdateAssignmentMutationOptions(options), queryClient);
    }

export type deleteAssignmentResponse204 = {
  data: void
  status: 204
}

export type deleteAssignmentResponse400 = {
  data: ApiError
  status: 400
}

export type deleteAssignmentResponse401 = {
  data: ApiError
  status: 401
}

export type deleteAssignmentResponse403 = {
  data: ApiError
  status: 403
}

export type deleteAssignmentResponse404 = {
  data: ApiError
  status: 404
}

export type deleteAssignmentResponse409 = {
  data: ApiError
  status: 409
}

export type deleteAssignmentResponse500 = {
  data: ApiError
  status: 500
}

export type deleteAssignmentResponseSuccess = (deleteAssignmentResponse204) & {
  headers: Headers;
};
export type deleteAssignmentResponseError = (deleteAssignmentResponse400 | deleteAssignmentResponse401 | deleteAssignmentResponse403 | deleteAssignmentResponse404 | deleteAssignmentResponse409 | deleteAssignmentResponse500) & {
  headers: Headers;
};

export type deleteAssignmentResponse = (deleteAssignmentResponseSuccess | deleteAssignmentResponseError)

export const getDeleteAssignmentUrl = (id: string,) => {




  return `/assignments/${id}`
}

/**
 * A soft delete, at any date — past, today or future, `expired` included — refused only when it already has a report. Does not rewind the cadence counter it advanced.
 * @summary Delete one occurrence
 */
export const deleteAssignment = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<deleteAssignmentResponse> => {

  return apiFetch<deleteAssignmentResponse>(getDeleteAssignmentUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAssignmentMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAssignment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAssignment>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAssignment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAssignment>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAssignment(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAssignment>>>

    export type DeleteAssignmentMutationError = ApiError

    /**
 * @summary Delete one occurrence
 */
export const useDeleteAssignment = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAssignment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAssignment>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteAssignmentMutationOptions(options), queryClient);
    }

export type getAssignmentGroupResponse200 = {
  data: AssignmentGroupSummary
  status: 200
}

export type getAssignmentGroupResponse400 = {
  data: ApiError
  status: 400
}

export type getAssignmentGroupResponse401 = {
  data: ApiError
  status: 401
}

export type getAssignmentGroupResponse403 = {
  data: ApiError
  status: 403
}

export type getAssignmentGroupResponse404 = {
  data: ApiError
  status: 404
}

export type getAssignmentGroupResponse500 = {
  data: ApiError
  status: 500
}

export type getAssignmentGroupResponseSuccess = (getAssignmentGroupResponse200) & {
  headers: Headers;
};
export type getAssignmentGroupResponseError = (getAssignmentGroupResponse400 | getAssignmentGroupResponse401 | getAssignmentGroupResponse403 | getAssignmentGroupResponse404 | getAssignmentGroupResponse500) & {
  headers: Headers;
};

export type getAssignmentGroupResponse = (getAssignmentGroupResponseSuccess | getAssignmentGroupResponseError)

export const getGetAssignmentGroupUrl = (id: string,) => {




  return `/assignments/${id}/group`
}

/**
 * Read before the delete sheet offers anything. Always fresh — never cached — so a report added between two calls changes the reported count on the second.
 * @summary What "this and all future" would delete
 */
export const getAssignmentGroup = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getAssignmentGroupResponse> => {

  return apiFetch<getAssignmentGroupResponse>(getGetAssignmentGroupUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssignmentGroupQueryKey = (id: string,) => {
    return [
    `/assignments/${id}/group`
    ] as const;
    }


export const getGetAssignmentGroupQueryOptions = <TData = Awaited<ReturnType<typeof getAssignmentGroup>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssignmentGroup>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssignmentGroupQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssignmentGroup>>> = ({ signal }) => getAssignmentGroup(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssignmentGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssignmentGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getAssignmentGroup>>>
export type GetAssignmentGroupQueryError = ApiError


export function useGetAssignmentGroup<TData = Awaited<ReturnType<typeof getAssignmentGroup>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssignmentGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentGroup>>,
          TError,
          Awaited<ReturnType<typeof getAssignmentGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssignmentGroup<TData = Awaited<ReturnType<typeof getAssignmentGroup>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssignmentGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentGroup>>,
          TError,
          Awaited<ReturnType<typeof getAssignmentGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssignmentGroup<TData = Awaited<ReturnType<typeof getAssignmentGroup>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssignmentGroup>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What "this and all future" would delete
 */

export function useGetAssignmentGroup<TData = Awaited<ReturnType<typeof getAssignmentGroup>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssignmentGroup>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssignmentGroupQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type deleteAssignmentGroupResponse200 = {
  data: AssignmentGroupDeleteResult
  status: 200
}

export type deleteAssignmentGroupResponse400 = {
  data: ApiError
  status: 400
}

export type deleteAssignmentGroupResponse401 = {
  data: ApiError
  status: 401
}

export type deleteAssignmentGroupResponse403 = {
  data: ApiError
  status: 403
}

export type deleteAssignmentGroupResponse404 = {
  data: ApiError
  status: 404
}

export type deleteAssignmentGroupResponse500 = {
  data: ApiError
  status: 500
}

export type deleteAssignmentGroupResponseSuccess = (deleteAssignmentGroupResponse200) & {
  headers: Headers;
};
export type deleteAssignmentGroupResponseError = (deleteAssignmentGroupResponse400 | deleteAssignmentGroupResponse401 | deleteAssignmentGroupResponse403 | deleteAssignmentGroupResponse404 | deleteAssignmentGroupResponse500) & {
  headers: Headers;
};

export type deleteAssignmentGroupResponse = (deleteAssignmentGroupResponseSuccess | deleteAssignmentGroupResponseError)

export const getDeleteAssignmentGroupUrl = (id: string,) => {




  return `/assignments/${id}/group`
}

/**
 * Soft-deletes every live occurrence in this series dated on or after this one’s own date. Occurrences that already have a report are **excluded and counted**, not a reason to refuse the rest (`docs/DECISIONS.md`, "Group delete on a reported occurrence: skip it, not the batch").
 * @summary Delete this and all future occurrences
 */
export const deleteAssignmentGroup = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<deleteAssignmentGroupResponse> => {

  return apiFetch<deleteAssignmentGroupResponse>(getDeleteAssignmentGroupUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAssignmentGroupMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAssignmentGroup>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAssignmentGroup>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAssignmentGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAssignmentGroup>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAssignmentGroup(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAssignmentGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAssignmentGroup>>>

    export type DeleteAssignmentGroupMutationError = ApiError

    /**
 * @summary Delete this and all future occurrences
 */
export const useDeleteAssignmentGroup = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAssignmentGroup>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAssignmentGroup>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteAssignmentGroupMutationOptions(options), queryClient);
    }

export type getMyWorksheetResponse200 = {
  data: Worksheet
  status: 200
}

export type getMyWorksheetResponse400 = {
  data: ApiError
  status: 400
}

export type getMyWorksheetResponse401 = {
  data: ApiError
  status: 401
}

export type getMyWorksheetResponse404 = {
  data: ApiError
  status: 404
}

export type getMyWorksheetResponse500 = {
  data: ApiError
  status: 500
}

export type getMyWorksheetResponseSuccess = (getMyWorksheetResponse200) & {
  headers: Headers;
};
export type getMyWorksheetResponseError = (getMyWorksheetResponse400 | getMyWorksheetResponse401 | getMyWorksheetResponse404 | getMyWorksheetResponse500) & {
  headers: Headers;
};

export type getMyWorksheetResponse = (getMyWorksheetResponseSuccess | getMyWorksheetResponseError)

export const getGetMyWorksheetUrl = (id: string,) => {




  return `/assignments/mine/${id}/worksheet`
}

/**
 * Everything a hand-in is composed from, in one request. Any authenticated account may call it for **their own** job; another worker’s answers `404`.
 * @summary The rooms, tasks and supplies of one of my jobs
 */
export const getMyWorksheet = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getMyWorksheetResponse> => {

  return apiFetch<getMyWorksheetResponse>(getGetMyWorksheetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyWorksheetQueryKey = (id: string,) => {
    return [
    `/assignments/mine/${id}/worksheet`
    ] as const;
    }


export const getGetMyWorksheetQueryOptions = <TData = Awaited<ReturnType<typeof getMyWorksheet>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyWorksheet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyWorksheetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyWorksheet>>> = ({ signal }) => getMyWorksheet(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyWorksheet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyWorksheetQueryResult = NonNullable<Awaited<ReturnType<typeof getMyWorksheet>>>
export type GetMyWorksheetQueryError = ApiError


export function useGetMyWorksheet<TData = Awaited<ReturnType<typeof getMyWorksheet>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyWorksheet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyWorksheet>>,
          TError,
          Awaited<ReturnType<typeof getMyWorksheet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyWorksheet<TData = Awaited<ReturnType<typeof getMyWorksheet>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyWorksheet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyWorksheet>>,
          TError,
          Awaited<ReturnType<typeof getMyWorksheet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyWorksheet<TData = Awaited<ReturnType<typeof getMyWorksheet>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyWorksheet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The rooms, tasks and supplies of one of my jobs
 */

export function useGetMyWorksheet<TData = Awaited<ReturnType<typeof getMyWorksheet>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyWorksheet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyWorksheetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type stageMyReportPhotoResponse201 = {
  data: Media
  status: 201
}

export type stageMyReportPhotoResponse400 = {
  data: ApiError
  status: 400
}

export type stageMyReportPhotoResponse401 = {
  data: ApiError
  status: 401
}

export type stageMyReportPhotoResponse404 = {
  data: ApiError
  status: 404
}

export type stageMyReportPhotoResponse409 = {
  data: ApiError
  status: 409
}

export type stageMyReportPhotoResponse413 = {
  data: ApiError
  status: 413
}

export type stageMyReportPhotoResponse500 = {
  data: ApiError
  status: 500
}

export type stageMyReportPhotoResponseSuccess = (stageMyReportPhotoResponse201) & {
  headers: Headers;
};
export type stageMyReportPhotoResponseError = (stageMyReportPhotoResponse400 | stageMyReportPhotoResponse401 | stageMyReportPhotoResponse404 | stageMyReportPhotoResponse409 | stageMyReportPhotoResponse413 | stageMyReportPhotoResponse500) & {
  headers: Headers;
};

export type stageMyReportPhotoResponse = (stageMyReportPhotoResponseSuccess | stageMyReportPhotoResponseError)

export const getStageMyReportPhotoUrl = (id: string,) => {




  return `/assignments/mine/${id}/photos`
}

/**
 * The request body **is** the photo — raw bytes, not JSON or a multipart form — at most 10 MiB, one request per photo. Upload as the worker attaches each photo rather than at hand-in: a submission that has to carry eight photos is a submission that fails on a stairwell’s signal.
 *
 * The photo belongs to the **job** until the job is handed in, at which point the submission claims the ones it names. A photo the submission does not name stays unattached and is deleted 30 days after upload — the same window a draft can live on a device, so a draft that is still valid never names a photo that has been swept.
 * @summary Attach a photo to a job, before handing it in
 */
export const stageMyReportPhoto = async (id: string,
    stageMyReportPhotoBody: Blob, options?: Parameters<typeof apiFetch>[1]): Promise<stageMyReportPhotoResponse> => {

  return apiFetch<stageMyReportPhotoResponse>(getStageMyReportPhotoUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'image/jpeg', ...options?.headers },
    body: stageMyReportPhotoBody
  }
);}





export const getStageMyReportPhotoMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stageMyReportPhoto>>, TError,{id: string;data: Blob}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stageMyReportPhoto>>, TError,{id: string;data: Blob}, TContext> => {

const mutationKey = ['stageMyReportPhoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stageMyReportPhoto>>, {id: string;data: Blob}> = (props) => {
          const {id,data} = props ?? {};

          return  stageMyReportPhoto(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StageMyReportPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof stageMyReportPhoto>>>
    export type StageMyReportPhotoMutationBody = Blob
    export type StageMyReportPhotoMutationError = ApiError

    /**
 * @summary Attach a photo to a job, before handing it in
 */
export const useStageMyReportPhoto = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stageMyReportPhoto>>, TError,{id: string;data: Blob}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stageMyReportPhoto>>,
        TError,
        {id: string;data: Blob},
        TContext
      > => {
      return useMutation(getStageMyReportPhotoMutationOptions(options), queryClient);
    }

export type unstageMyReportPhotoResponse204 = {
  data: void
  status: 204
}

export type unstageMyReportPhotoResponse400 = {
  data: ApiError
  status: 400
}

export type unstageMyReportPhotoResponse401 = {
  data: ApiError
  status: 401
}

export type unstageMyReportPhotoResponse404 = {
  data: ApiError
  status: 404
}

export type unstageMyReportPhotoResponse500 = {
  data: ApiError
  status: 500
}

export type unstageMyReportPhotoResponseSuccess = (unstageMyReportPhotoResponse204) & {
  headers: Headers;
};
export type unstageMyReportPhotoResponseError = (unstageMyReportPhotoResponse400 | unstageMyReportPhotoResponse401 | unstageMyReportPhotoResponse404 | unstageMyReportPhotoResponse500) & {
  headers: Headers;
};

export type unstageMyReportPhotoResponse = (unstageMyReportPhotoResponseSuccess | unstageMyReportPhotoResponseError)

export const getUnstageMyReportPhotoUrl = (id: string,
    mediaId: string,) => {




  return `/assignments/mine/${id}/photos/${mediaId}`
}

/**
 * Only a photo still staged against this job, and only the caller’s own job. A photo a report has already claimed answers `404`: a handed-in report cannot be amended.
 * @summary Remove a photo staged against one of my jobs
 */
export const unstageMyReportPhoto = async (id: string,
    mediaId: string, options?: Parameters<typeof apiFetch>[1]): Promise<unstageMyReportPhotoResponse> => {

  return apiFetch<unstageMyReportPhotoResponse>(getUnstageMyReportPhotoUrl(id,mediaId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnstageMyReportPhotoMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unstageMyReportPhoto>>, TError,{id: string;mediaId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unstageMyReportPhoto>>, TError,{id: string;mediaId: string}, TContext> => {

const mutationKey = ['unstageMyReportPhoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unstageMyReportPhoto>>, {id: string;mediaId: string}> = (props) => {
          const {id,mediaId} = props ?? {};

          return  unstageMyReportPhoto(id,mediaId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnstageMyReportPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof unstageMyReportPhoto>>>

    export type UnstageMyReportPhotoMutationError = ApiError

    /**
 * @summary Remove a photo staged against one of my jobs
 */
export const useUnstageMyReportPhoto = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unstageMyReportPhoto>>, TError,{id: string;mediaId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unstageMyReportPhoto>>,
        TError,
        {id: string;mediaId: string},
        TContext
      > => {
      return useMutation(getUnstageMyReportPhotoMutationOptions(options), queryClient);
    }

export type submitMyReportResponse200 = {
  data: Report
  status: 200
}

export type submitMyReportResponse201 = {
  data: Report
  status: 201
}

export type submitMyReportResponse400 = {
  data: ApiError
  status: 400
}

export type submitMyReportResponse401 = {
  data: ApiError
  status: 401
}

export type submitMyReportResponse404 = {
  data: ApiError
  status: 404
}

export type submitMyReportResponse409 = {
  data: ApiError
  status: 409
}

export type submitMyReportResponse500 = {
  data: ApiError
  status: 500
}

export type submitMyReportResponseSuccess = (submitMyReportResponse200 | submitMyReportResponse201) & {
  headers: Headers;
};
export type submitMyReportResponseError = (submitMyReportResponse400 | submitMyReportResponse401 | submitMyReportResponse404 | submitMyReportResponse409 | submitMyReportResponse500) & {
  headers: Headers;
};

export type submitMyReportResponse = (submitMyReportResponseSuccess | submitMyReportResponseError)

export const getSubmitMyReportUrl = (id: string,) => {




  return `/assignments/mine/${id}/report`
}

/**
 * One call, one transaction, one outcome. The report, its per-room statuses, its per-task completion, its running-low marks, its photo references, its message and the job’s final status and end instant are written together or not at all — there is no state in which the job is closed and the report is missing.
 *
 * **Idempotent by `submissionKey`.** A retry after a lost answer carries the same key and is answered `200` with the report the first call made, including its original `endedAt`; only a first, accepted submission answers `201`. A client may treat both as success and does not need to branch on the status.
 *
 * Statuses are derived from the ticks by the same `packages/domain` code the client uses, so the badge the worker saw and the record the office reads cannot disagree.
 * @summary Hand in a job
 */
export const submitMyReport = async (id: string,
    submitReportRequest: SubmitReportRequest, options?: Parameters<typeof apiFetch>[1]): Promise<submitMyReportResponse> => {

  return apiFetch<submitMyReportResponse>(getSubmitMyReportUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submitReportRequest)
  }
);}





export const getSubmitMyReportMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitMyReport>>, TError,{id: string;data: SubmitReportRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitMyReport>>, TError,{id: string;data: SubmitReportRequest}, TContext> => {

const mutationKey = ['submitMyReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitMyReport>>, {id: string;data: SubmitReportRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  submitMyReport(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitMyReportMutationResult = NonNullable<Awaited<ReturnType<typeof submitMyReport>>>
    export type SubmitMyReportMutationBody = SubmitReportRequest
    export type SubmitMyReportMutationError = ApiError

    /**
 * @summary Hand in a job
 */
export const useSubmitMyReport = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitMyReport>>, TError,{id: string;data: SubmitReportRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitMyReport>>,
        TError,
        {id: string;data: SubmitReportRequest},
        TContext
      > => {
      return useMutation(getSubmitMyReportMutationOptions(options), queryClient);
    }

export type getMyReportResponse200 = {
  data: Report
  status: 200
}

export type getMyReportResponse400 = {
  data: ApiError
  status: 400
}

export type getMyReportResponse401 = {
  data: ApiError
  status: 401
}

export type getMyReportResponse404 = {
  data: ApiError
  status: 404
}

export type getMyReportResponse500 = {
  data: ApiError
  status: 500
}

export type getMyReportResponseSuccess = (getMyReportResponse200) & {
  headers: Headers;
};
export type getMyReportResponseError = (getMyReportResponse400 | getMyReportResponse401 | getMyReportResponse404 | getMyReportResponse500) & {
  headers: Headers;
};

export type getMyReportResponse = (getMyReportResponseSuccess | getMyReportResponseError)

export const getGetMyReportUrl = (id: string,) => {




  return `/assignments/mine/${id}/report`
}

/**
 * @summary The report I handed in for one of my jobs
 */
export const getMyReport = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getMyReportResponse> => {

  return apiFetch<getMyReportResponse>(getGetMyReportUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyReportQueryKey = (id: string,) => {
    return [
    `/assignments/mine/${id}/report`
    ] as const;
    }


export const getGetMyReportQueryOptions = <TData = Awaited<ReturnType<typeof getMyReport>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyReportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyReport>>> = ({ signal }) => getMyReport(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyReportQueryResult = NonNullable<Awaited<ReturnType<typeof getMyReport>>>
export type GetMyReportQueryError = ApiError


export function useGetMyReport<TData = Awaited<ReturnType<typeof getMyReport>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyReport>>,
          TError,
          Awaited<ReturnType<typeof getMyReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyReport<TData = Awaited<ReturnType<typeof getMyReport>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyReport>>,
          TError,
          Awaited<ReturnType<typeof getMyReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyReport<TData = Awaited<ReturnType<typeof getMyReport>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The report I handed in for one of my jobs
 */

export function useGetMyReport<TData = Awaited<ReturnType<typeof getMyReport>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyReportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listReportsResponse200 = {
  data: ReportPage
  status: 200
}

export type listReportsResponse400 = {
  data: ApiError
  status: 400
}

export type listReportsResponse401 = {
  data: ApiError
  status: 401
}

export type listReportsResponse403 = {
  data: ApiError
  status: 403
}

export type listReportsResponse500 = {
  data: ApiError
  status: 500
}

export type listReportsResponseSuccess = (listReportsResponse200) & {
  headers: Headers;
};
export type listReportsResponseError = (listReportsResponse400 | listReportsResponse401 | listReportsResponse403 | listReportsResponse500) & {
  headers: Headers;
};

export type listReportsResponse = (listReportsResponseSuccess | listReportsResponseError)

export const getListReportsUrl = (params?: ListReportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["status"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/reports?${stringifiedParams}` : `/reports`
}

/**
 * Every report in this tenant, filtered, sorted and paginated — ordered by the day the work was scheduled for unless `sort` says otherwise. Date bounds are the **job’s** calendar date in the tenant’s timezone, never a truncated instant. Each row carries its worker’s and its location’s name (`ReportSummary` — **B14**), read past either’s own soft deletion (`docs/reference/ISSUES.md` HB10), plus how many supplies were marked running low and how many photos are attached. `search` matches the message, the worker’s name, and the location’s name and address. `sort`/`direction` cover every column `docs/ux/TENANT-ADMIN.md` §9.1 marks sortable — Worker, Location, Date, Status, Started/Ended and Duration; Running low, Photos and Message are not, and stay plain labels (**chore-reports-sort-param**).
 * @summary The tenant’s reports
 */
export const listReports = async (params?: ListReportsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listReportsResponse> => {

  return apiFetch<listReportsResponse>(getListReportsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReportsQueryKey = (params?: ListReportsParams,) => {
    return [
    `/reports`, ...(params ? [params] : [])
    ] as const;
    }


export const getListReportsQueryOptions = <TData = Awaited<ReturnType<typeof listReports>>, TError = ApiError>(params?: ListReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReports>>> = ({ signal }) => listReports(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListReportsQueryResult = NonNullable<Awaited<ReturnType<typeof listReports>>>
export type ListReportsQueryError = ApiError


export function useListReports<TData = Awaited<ReturnType<typeof listReports>>, TError = ApiError>(
 params: undefined |  ListReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReports>>,
          TError,
          Awaited<ReturnType<typeof listReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReports<TData = Awaited<ReturnType<typeof listReports>>, TError = ApiError>(
 params?: ListReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReports>>,
          TError,
          Awaited<ReturnType<typeof listReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReports<TData = Awaited<ReturnType<typeof listReports>>, TError = ApiError>(
 params?: ListReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The tenant’s reports
 */

export function useListReports<TData = Awaited<ReturnType<typeof listReports>>, TError = ApiError>(
 params?: ListReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListReportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getReportResponse200 = {
  data: Report
  status: 200
}

export type getReportResponse400 = {
  data: ApiError
  status: 400
}

export type getReportResponse401 = {
  data: ApiError
  status: 401
}

export type getReportResponse403 = {
  data: ApiError
  status: 403
}

export type getReportResponse404 = {
  data: ApiError
  status: 404
}

export type getReportResponse500 = {
  data: ApiError
  status: 500
}

export type getReportResponseSuccess = (getReportResponse200) & {
  headers: Headers;
};
export type getReportResponseError = (getReportResponse400 | getReportResponse401 | getReportResponse403 | getReportResponse404 | getReportResponse500) & {
  headers: Headers;
};

export type getReportResponse = (getReportResponseSuccess | getReportResponseError)

export const getGetReportUrl = (id: string,) => {




  return `/assignments/${id}/report`
}

/**
 * The whole record: every room with its derived status, every task with whether it was ticked, every running-low mark (with the task it hangs from) and every photo — plus the worker’s and the location’s names, past either’s own soft deletion (`docs/reference/ISSUES.md` HB10), the same identity B14 gave `GET /reports`’s rows. **chore-report-detail-taskid**.
 * @summary One job’s report, in full
 */
export const getReport = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getReportResponse> => {

  return apiFetch<getReportResponse>(getGetReportUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReportQueryKey = (id: string,) => {
    return [
    `/assignments/${id}/report`
    ] as const;
    }


export const getGetReportQueryOptions = <TData = Awaited<ReturnType<typeof getReport>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReport>>> = ({ signal }) => getReport(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportQueryResult = NonNullable<Awaited<ReturnType<typeof getReport>>>
export type GetReportQueryError = ApiError


export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReport>>,
          TError,
          Awaited<ReturnType<typeof getReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReport>>,
          TError,
          Awaited<ReturnType<typeof getReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One job’s report, in full
 */

export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createExportResponse201 = {
  data: ExportJob
  status: 201
}

export type createExportResponse400 = {
  data: ApiError
  status: 400
}

export type createExportResponse401 = {
  data: ApiError
  status: 401
}

export type createExportResponse403 = {
  data: ApiError
  status: 403
}

export type createExportResponse404 = {
  data: ApiError
  status: 404
}

export type createExportResponse500 = {
  data: ApiError
  status: 500
}

export type createExportResponseSuccess = (createExportResponse201) & {
  headers: Headers;
};
export type createExportResponseError = (createExportResponse400 | createExportResponse401 | createExportResponse403 | createExportResponse404 | createExportResponse500) & {
  headers: Headers;
};

export type createExportResponse = (createExportResponseSuccess | createExportResponseError)

export const getCreateExportUrl = () => {




  return `/exports`
}

/**
 * Queues an XLSX export of this tenant’s reports for the given period. The row is created immediately, `waiting`; the file is generated in the background and the row moves through `in_progress` to `completed` or `failed` (`docs/ux/TENANT-ADMIN.md` §10.1, §10.3).
 * @summary Request an export
 */
export const createExport = async (newExport: NewExport, options?: Parameters<typeof apiFetch>[1]): Promise<createExportResponse> => {

  return apiFetch<createExportResponse>(getCreateExportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(newExport)
  }
);}





export const getCreateExportMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExport>>, TError,{data: NewExport}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createExport>>, TError,{data: NewExport}, TContext> => {

const mutationKey = ['createExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExport>>, {data: NewExport}> = (props) => {
          const {data} = props ?? {};

          return  createExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateExportMutationResult = NonNullable<Awaited<ReturnType<typeof createExport>>>
    export type CreateExportMutationBody = NewExport
    export type CreateExportMutationError = ApiError

    /**
 * @summary Request an export
 */
export const useCreateExport = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExport>>, TError,{data: NewExport}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createExport>>,
        TError,
        {data: NewExport},
        TContext
      > => {
      return useMutation(getCreateExportMutationOptions(options), queryClient);
    }

export type listExportsResponse200 = {
  data: ExportPage
  status: 200
}

export type listExportsResponse400 = {
  data: ApiError
  status: 400
}

export type listExportsResponse401 = {
  data: ApiError
  status: 401
}

export type listExportsResponse403 = {
  data: ApiError
  status: 403
}

export type listExportsResponse500 = {
  data: ApiError
  status: 500
}

export type listExportsResponseSuccess = (listExportsResponse200) & {
  headers: Headers;
};
export type listExportsResponseError = (listExportsResponse400 | listExportsResponse401 | listExportsResponse403 | listExportsResponse500) & {
  headers: Headers;
};

export type listExportsResponse = (listExportsResponseSuccess | listExportsResponseError)

export const getListExportsUrl = (params?: ListExportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/exports?${stringifiedParams}` : `/exports`
}

/**
 * Every export ever requested in this tenant, newest requested first, paged.
 * @summary The tenant’s export history
 */
export const listExports = async (params?: ListExportsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listExportsResponse> => {

  return apiFetch<listExportsResponse>(getListExportsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExportsQueryKey = (params?: ListExportsParams,) => {
    return [
    `/exports`, ...(params ? [params] : [])
    ] as const;
    }


export const getListExportsQueryOptions = <TData = Awaited<ReturnType<typeof listExports>>, TError = ApiError>(params?: ListExportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExports>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExports>>> = ({ signal }) => listExports(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExportsQueryResult = NonNullable<Awaited<ReturnType<typeof listExports>>>
export type ListExportsQueryError = ApiError


export function useListExports<TData = Awaited<ReturnType<typeof listExports>>, TError = ApiError>(
 params: undefined |  ListExportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExports>>,
          TError,
          Awaited<ReturnType<typeof listExports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExports<TData = Awaited<ReturnType<typeof listExports>>, TError = ApiError>(
 params?: ListExportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExports>>,
          TError,
          Awaited<ReturnType<typeof listExports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExports<TData = Awaited<ReturnType<typeof listExports>>, TError = ApiError>(
 params?: ListExportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExports>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The tenant’s export history
 */

export function useListExports<TData = Awaited<ReturnType<typeof listExports>>, TError = ApiError>(
 params?: ListExportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExports>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createExportProgressTicketResponse201 = {
  data: ExportProgressTicket
  status: 201
}

export type createExportProgressTicketResponse400 = {
  data: ApiError
  status: 400
}

export type createExportProgressTicketResponse401 = {
  data: ApiError
  status: 401
}

export type createExportProgressTicketResponse403 = {
  data: ApiError
  status: 403
}

export type createExportProgressTicketResponse500 = {
  data: ApiError
  status: 500
}

export type createExportProgressTicketResponseSuccess = (createExportProgressTicketResponse201) & {
  headers: Headers;
};
export type createExportProgressTicketResponseError = (createExportProgressTicketResponse400 | createExportProgressTicketResponse401 | createExportProgressTicketResponse403 | createExportProgressTicketResponse500) & {
  headers: Headers;
};

export type createExportProgressTicketResponse = (createExportProgressTicketResponseSuccess | createExportProgressTicketResponseError)

export const getCreateExportProgressTicketUrl = () => {




  return `/exports/progress-ticket`
}

/**
 * A short-lived, single-use credential for `GET /exports/live` — the only way a browser can authenticate that connection, since `WebSocket` has no header of its own (`docs/task-specs/B08.md`). Requires `admin`, exactly like every other export operation.
 * @summary Mint a ticket for the live-progress WebSocket
 */
export const createExportProgressTicket = async ( options?: Parameters<typeof apiFetch>[1]): Promise<createExportProgressTicketResponse> => {

  return apiFetch<createExportProgressTicketResponse>(getCreateExportProgressTicketUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateExportProgressTicketMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExportProgressTicket>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createExportProgressTicket>>, TError,void, TContext> => {

const mutationKey = ['createExportProgressTicket'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExportProgressTicket>>, void> = () => {


          return  createExportProgressTicket(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateExportProgressTicketMutationResult = NonNullable<Awaited<ReturnType<typeof createExportProgressTicket>>>

    export type CreateExportProgressTicketMutationError = ApiError

    /**
 * @summary Mint a ticket for the live-progress WebSocket
 */
export const useCreateExportProgressTicket = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExportProgressTicket>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createExportProgressTicket>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateExportProgressTicketMutationOptions(options), queryClient);
    }

export type exportsLiveResponse101 = {
  data: void
  status: 101
}

export type exportsLiveResponse400 = {
  data: ApiError
  status: 400
}

export type exportsLiveResponse401 = {
  data: ApiError
  status: 401
}

export type exportsLiveResponse426 = {
  data: ApiError
  status: 426
}

export type exportsLiveResponse429 = {
  data: ApiError
  status: 429
}

export type exportsLiveResponse500 = {
  data: ApiError
  status: 500
}

;
export type exportsLiveResponseError = (exportsLiveResponse101 | exportsLiveResponse400 | exportsLiveResponse401 | exportsLiveResponse426 | exportsLiveResponse429 | exportsLiveResponse500) & {
  headers: Headers;
};

export type exportsLiveResponse = (exportsLiveResponseError)

export const getExportsLiveUrl = (params: ExportsLiveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/exports/live?${stringifiedParams}` : `/exports/live`
}

/**
 * Not a JSON endpoint: a successful request is a protocol upgrade to `101 Switching Protocols`. Carries no `Authorization` header and no `security` scheme — the `ticket` query parameter, from `POST /exports/progress-ticket`, is the only credential, because a browser’s `WebSocket` constructor cannot attach a custom header (`docs/task-specs/B08.md`). The wire protocol — `snapshot`/`export`/`ping`/`pong` frames and their close codes — is documented in that task spec and in the QA notes for B08, not in this schema.
 * @summary Live export progress (WebSocket)
 */
export const exportsLive = async (params: ExportsLiveParams, options?: Parameters<typeof apiFetch>[1]): Promise<exportsLiveResponse> => {

  return apiFetch<exportsLiveResponse>(getExportsLiveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportsLiveQueryKey = (params?: ExportsLiveParams,) => {
    return [
    `/exports/live`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportsLiveQueryOptions = <TData = Awaited<ReturnType<typeof exportsLive>>, TError = void | ApiError>(params: ExportsLiveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportsLive>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportsLiveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportsLive>>> = ({ signal }) => exportsLive(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportsLive>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportsLiveQueryResult = NonNullable<Awaited<ReturnType<typeof exportsLive>>>
export type ExportsLiveQueryError = void | ApiError


export function useExportsLive<TData = Awaited<ReturnType<typeof exportsLive>>, TError = void | ApiError>(
 params: ExportsLiveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportsLive>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportsLive>>,
          TError,
          Awaited<ReturnType<typeof exportsLive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportsLive<TData = Awaited<ReturnType<typeof exportsLive>>, TError = void | ApiError>(
 params: ExportsLiveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportsLive>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportsLive>>,
          TError,
          Awaited<ReturnType<typeof exportsLive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportsLive<TData = Awaited<ReturnType<typeof exportsLive>>, TError = void | ApiError>(
 params: ExportsLiveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportsLive>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Live export progress (WebSocket)
 */

export function useExportsLive<TData = Awaited<ReturnType<typeof exportsLive>>, TError = void | ApiError>(
 params: ExportsLiveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportsLive>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportsLiveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getExportResponse200 = {
  data: ExportJob
  status: 200
}

export type getExportResponse400 = {
  data: ApiError
  status: 400
}

export type getExportResponse401 = {
  data: ApiError
  status: 401
}

export type getExportResponse403 = {
  data: ApiError
  status: 403
}

export type getExportResponse404 = {
  data: ApiError
  status: 404
}

export type getExportResponse500 = {
  data: ApiError
  status: 500
}

export type getExportResponseSuccess = (getExportResponse200) & {
  headers: Headers;
};
export type getExportResponseError = (getExportResponse400 | getExportResponse401 | getExportResponse403 | getExportResponse404 | getExportResponse500) & {
  headers: Headers;
};

export type getExportResponse = (getExportResponseSuccess | getExportResponseError)

export const getGetExportUrl = (id: string,) => {




  return `/exports/${id}`
}

/**
 * A single export’s current state, for polling one row without refetching the list.
 * @summary One export
 */
export const getExport = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getExportResponse> => {

  return apiFetch<getExportResponse>(getGetExportUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExportQueryKey = (id: string,) => {
    return [
    `/exports/${id}`
    ] as const;
    }


export const getGetExportQueryOptions = <TData = Awaited<ReturnType<typeof getExport>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExport>>> = ({ signal }) => getExport(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExportQueryResult = NonNullable<Awaited<ReturnType<typeof getExport>>>
export type GetExportQueryError = ApiError


export function useGetExport<TData = Awaited<ReturnType<typeof getExport>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExport>>,
          TError,
          Awaited<ReturnType<typeof getExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExport<TData = Awaited<ReturnType<typeof getExport>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExport>>,
          TError,
          Awaited<ReturnType<typeof getExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExport<TData = Awaited<ReturnType<typeof getExport>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One export
 */

export function useGetExport<TData = Awaited<ReturnType<typeof getExport>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type downloadExportResponse200 = {
  data: Blob
  status: 200
}

export type downloadExportResponse400 = {
  data: ApiError
  status: 400
}

export type downloadExportResponse401 = {
  data: ApiError
  status: 401
}

export type downloadExportResponse403 = {
  data: ApiError
  status: 403
}

export type downloadExportResponse404 = {
  data: ApiError
  status: 404
}

export type downloadExportResponse409 = {
  data: ApiError
  status: 409
}

export type downloadExportResponse500 = {
  data: ApiError
  status: 500
}

export type downloadExportResponseSuccess = (downloadExportResponse200) & {
  headers: Headers;
};
export type downloadExportResponseError = (downloadExportResponse400 | downloadExportResponse401 | downloadExportResponse403 | downloadExportResponse404 | downloadExportResponse409 | downloadExportResponse500) & {
  headers: Headers;
};

export type downloadExportResponse = (downloadExportResponseSuccess | downloadExportResponseError)

export const getDownloadExportUrl = (id: string,) => {




  return `/exports/${id}/download`
}

/**
 * The generated `.xlsx` file’s bytes. Only ever answers for a `completed` export — see the 409 responses for every other state.
 * @summary Download a completed export’s file
 */
export const downloadExport = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<downloadExportResponse> => {

  return apiFetch<downloadExportResponse>(getDownloadExportUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadExportQueryKey = (id: string,) => {
    return [
    `/exports/${id}/download`
    ] as const;
    }


export const getDownloadExportQueryOptions = <TData = Awaited<ReturnType<typeof downloadExport>>, TError = ApiError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadExportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadExport>>> = ({ signal }) => downloadExport(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadExportQueryResult = NonNullable<Awaited<ReturnType<typeof downloadExport>>>
export type DownloadExportQueryError = ApiError


export function useDownloadExport<TData = Awaited<ReturnType<typeof downloadExport>>, TError = ApiError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadExport>>,
          TError,
          Awaited<ReturnType<typeof downloadExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadExport<TData = Awaited<ReturnType<typeof downloadExport>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadExport>>,
          TError,
          Awaited<ReturnType<typeof downloadExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadExport<TData = Awaited<ReturnType<typeof downloadExport>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download a completed export’s file
 */

export function useDownloadExport<TData = Awaited<ReturnType<typeof downloadExport>>, TError = ApiError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadExportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type bootstrapPlatformAdminResponse201 = {
  data: PlatformAdmin
  status: 201
}

export type bootstrapPlatformAdminResponse400 = {
  data: ApiError
  status: 400
}

export type bootstrapPlatformAdminResponse401 = {
  data: ApiError
  status: 401
}

export type bootstrapPlatformAdminResponse409 = {
  data: ApiError
  status: 409
}

export type bootstrapPlatformAdminResponse500 = {
  data: ApiError
  status: 500
}

export type bootstrapPlatformAdminResponseSuccess = (bootstrapPlatformAdminResponse201) & {
  headers: Headers;
};
export type bootstrapPlatformAdminResponseError = (bootstrapPlatformAdminResponse400 | bootstrapPlatformAdminResponse401 | bootstrapPlatformAdminResponse409 | bootstrapPlatformAdminResponse500) & {
  headers: Headers;
};

export type bootstrapPlatformAdminResponse = (bootstrapPlatformAdminResponseSuccess | bootstrapPlatformAdminResponseError)

export const getBootstrapPlatformAdminUrl = () => {




  return `/platform/auth/bootstrap`
}

/**
 * Creates the platform’s **first** administrator, guarded by the deployment secret `PLATFORM_ADMIN_BOOTSTRAP_SECRET` in the `X-Platform-Bootstrap-Secret` header. There is no email and no self-service path, so a fresh deployment has no other way to acquire an administrator. It succeeds **at most once per deployment**: the moment any platform administrator row exists — including one that has since been retired — it answers 409 and creates nothing. It returns no tokens; sign in afterwards.
 * @summary Create the first platform administrator, once
 */
export const bootstrapPlatformAdmin = async (platformBootstrapRequest: PlatformBootstrapRequest, options?: Parameters<typeof apiFetch>[1]): Promise<bootstrapPlatformAdminResponse> => {

  return apiFetch<bootstrapPlatformAdminResponse>(getBootstrapPlatformAdminUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformBootstrapRequest)
  }
);}





export const getBootstrapPlatformAdminMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bootstrapPlatformAdmin>>, TError,{data: PlatformBootstrapRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bootstrapPlatformAdmin>>, TError,{data: PlatformBootstrapRequest}, TContext> => {

const mutationKey = ['bootstrapPlatformAdmin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bootstrapPlatformAdmin>>, {data: PlatformBootstrapRequest}> = (props) => {
          const {data} = props ?? {};

          return  bootstrapPlatformAdmin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BootstrapPlatformAdminMutationResult = NonNullable<Awaited<ReturnType<typeof bootstrapPlatformAdmin>>>
    export type BootstrapPlatformAdminMutationBody = PlatformBootstrapRequest
    export type BootstrapPlatformAdminMutationError = ApiError

    /**
 * @summary Create the first platform administrator, once
 */
export const useBootstrapPlatformAdmin = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bootstrapPlatformAdmin>>, TError,{data: PlatformBootstrapRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bootstrapPlatformAdmin>>,
        TError,
        {data: PlatformBootstrapRequest},
        TContext
      > => {
      return useMutation(getBootstrapPlatformAdminMutationOptions(options), queryClient);
    }

export type loginPlatformAdminResponse200 = {
  data: TokenPair
  status: 200
}

export type loginPlatformAdminResponse400 = {
  data: ApiError
  status: 400
}

export type loginPlatformAdminResponse401 = {
  data: ApiError
  status: 401
}

export type loginPlatformAdminResponse500 = {
  data: ApiError
  status: 500
}

export type loginPlatformAdminResponseSuccess = (loginPlatformAdminResponse200) & {
  headers: Headers;
};
export type loginPlatformAdminResponseError = (loginPlatformAdminResponse400 | loginPlatformAdminResponse401 | loginPlatformAdminResponse500) & {
  headers: Headers;
};

export type loginPlatformAdminResponse = (loginPlatformAdminResponseSuccess | loginPlatformAdminResponseError)

export const getLoginPlatformAdminUrl = () => {




  return `/platform/auth/login`
}

/**
 * Exchanges a nickname and password for a **platform-realm** token pair. The token this returns is not the one POST /auth/login returns: it carries a different audience and no tenant, it is accepted only by /platform operations, and it is rejected by every tenant operation. No build key is involved — the platform realm belongs to no tenant.
 * @summary Sign in as a platform administrator
 */
export const loginPlatformAdmin = async (platformLoginRequest: PlatformLoginRequest, options?: Parameters<typeof apiFetch>[1]): Promise<loginPlatformAdminResponse> => {

  return apiFetch<loginPlatformAdminResponse>(getLoginPlatformAdminUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformLoginRequest)
  }
);}





export const getLoginPlatformAdminMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginPlatformAdmin>>, TError,{data: PlatformLoginRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof loginPlatformAdmin>>, TError,{data: PlatformLoginRequest}, TContext> => {

const mutationKey = ['loginPlatformAdmin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginPlatformAdmin>>, {data: PlatformLoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  loginPlatformAdmin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginPlatformAdminMutationResult = NonNullable<Awaited<ReturnType<typeof loginPlatformAdmin>>>
    export type LoginPlatformAdminMutationBody = PlatformLoginRequest
    export type LoginPlatformAdminMutationError = ApiError

    /**
 * @summary Sign in as a platform administrator
 */
export const useLoginPlatformAdmin = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginPlatformAdmin>>, TError,{data: PlatformLoginRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof loginPlatformAdmin>>,
        TError,
        {data: PlatformLoginRequest},
        TContext
      > => {
      return useMutation(getLoginPlatformAdminMutationOptions(options), queryClient);
    }

export type refreshPlatformTokenPairResponse200 = {
  data: TokenPair
  status: 200
}

export type refreshPlatformTokenPairResponse400 = {
  data: ApiError
  status: 400
}

export type refreshPlatformTokenPairResponse401 = {
  data: ApiError
  status: 401
}

export type refreshPlatformTokenPairResponse500 = {
  data: ApiError
  status: 500
}

export type refreshPlatformTokenPairResponseSuccess = (refreshPlatformTokenPairResponse200) & {
  headers: Headers;
};
export type refreshPlatformTokenPairResponseError = (refreshPlatformTokenPairResponse400 | refreshPlatformTokenPairResponse401 | refreshPlatformTokenPairResponse500) & {
  headers: Headers;
};

export type refreshPlatformTokenPairResponse = (refreshPlatformTokenPairResponseSuccess | refreshPlatformTokenPairResponseError)

export const getRefreshPlatformTokenPairUrl = () => {




  return `/platform/auth/refresh`
}

/**
 * Exchanges a platform refresh token for a **new pair**, and retires the one presented. Single-use: presenting a token that has already been used is treated as a stolen token and ends the whole session. Requires no Authorization header — the refresh token is the credential. A tenant refresh token is rejected here.
 * @summary Rotate the platform token pair
 */
export const refreshPlatformTokenPair = async (platformRefreshRequest: PlatformRefreshRequest, options?: Parameters<typeof apiFetch>[1]): Promise<refreshPlatformTokenPairResponse> => {

  return apiFetch<refreshPlatformTokenPairResponse>(getRefreshPlatformTokenPairUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(platformRefreshRequest)
  }
);}





export const getRefreshPlatformTokenPairMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshPlatformTokenPair>>, TError,{data: PlatformRefreshRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshPlatformTokenPair>>, TError,{data: PlatformRefreshRequest}, TContext> => {

const mutationKey = ['refreshPlatformTokenPair'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshPlatformTokenPair>>, {data: PlatformRefreshRequest}> = (props) => {
          const {data} = props ?? {};

          return  refreshPlatformTokenPair(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshPlatformTokenPairMutationResult = NonNullable<Awaited<ReturnType<typeof refreshPlatformTokenPair>>>
    export type RefreshPlatformTokenPairMutationBody = PlatformRefreshRequest
    export type RefreshPlatformTokenPairMutationError = ApiError

    /**
 * @summary Rotate the platform token pair
 */
export const useRefreshPlatformTokenPair = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshPlatformTokenPair>>, TError,{data: PlatformRefreshRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshPlatformTokenPair>>,
        TError,
        {data: PlatformRefreshRequest},
        TContext
      > => {
      return useMutation(getRefreshPlatformTokenPairMutationOptions(options), queryClient);
    }

export type logoutPlatformAdminResponse204 = {
  data: void
  status: 204
}

export type logoutPlatformAdminResponse401 = {
  data: ApiError
  status: 401
}

export type logoutPlatformAdminResponse500 = {
  data: ApiError
  status: 500
}

export type logoutPlatformAdminResponseSuccess = (logoutPlatformAdminResponse204) & {
  headers: Headers;
};
export type logoutPlatformAdminResponseError = (logoutPlatformAdminResponse401 | logoutPlatformAdminResponse500) & {
  headers: Headers;
};

export type logoutPlatformAdminResponse = (logoutPlatformAdminResponseSuccess | logoutPlatformAdminResponseError)

export const getLogoutPlatformAdminUrl = () => {




  return `/platform/auth/logout`
}

/**
 * Revokes the session the access token belongs to, **server-side**. Both tokens stop working immediately. Other sign-ins of the same administrator are untouched. Calling it twice is not an error.
 * @summary End this platform session
 */
export const logoutPlatformAdmin = async ( options?: Parameters<typeof apiFetch>[1]): Promise<logoutPlatformAdminResponse> => {

  return apiFetch<logoutPlatformAdminResponse>(getLogoutPlatformAdminUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLogoutPlatformAdminMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutPlatformAdmin>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logoutPlatformAdmin>>, TError,void, TContext> => {

const mutationKey = ['logoutPlatformAdmin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutPlatformAdmin>>, void> = () => {


          return  logoutPlatformAdmin(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutPlatformAdminMutationResult = NonNullable<Awaited<ReturnType<typeof logoutPlatformAdmin>>>

    export type LogoutPlatformAdminMutationError = ApiError

    /**
 * @summary End this platform session
 */
export const useLogoutPlatformAdmin = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutPlatformAdmin>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logoutPlatformAdmin>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutPlatformAdminMutationOptions(options), queryClient);
    }

export type getPlatformSessionResponse200 = {
  data: PlatformSession
  status: 200
}

export type getPlatformSessionResponse401 = {
  data: ApiError
  status: 401
}

export type getPlatformSessionResponse500 = {
  data: ApiError
  status: 500
}

export type getPlatformSessionResponseSuccess = (getPlatformSessionResponse200) & {
  headers: Headers;
};
export type getPlatformSessionResponseError = (getPlatformSessionResponse401 | getPlatformSessionResponse500) & {
  headers: Headers;
};

export type getPlatformSessionResponse = (getPlatformSessionResponseSuccess | getPlatformSessionResponseError)

export const getGetPlatformSessionUrl = () => {




  return `/platform/auth/session`
}

/**
 * Who this platform access token authenticates, as the database sees it **right now**. There is no role: a platform administrator is one tier with one set of powers (`docs/DECISIONS.md`, "Platform-admin identity"), so there is nothing here to compare against a tenant user’s role.
 * @summary Describe the current platform session
 */
export const getPlatformSession = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getPlatformSessionResponse> => {

  return apiFetch<getPlatformSessionResponse>(getGetPlatformSessionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPlatformSessionQueryKey = () => {
    return [
    `/platform/auth/session`
    ] as const;
    }


export const getGetPlatformSessionQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformSession>>, TError = ApiError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSession>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformSessionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformSession>>> = ({ signal }) => getPlatformSession({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformSession>>>
export type GetPlatformSessionQueryError = ApiError


export function useGetPlatformSession<TData = Awaited<ReturnType<typeof getPlatformSession>>, TError = ApiError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformSession>>,
          TError,
          Awaited<ReturnType<typeof getPlatformSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformSession<TData = Awaited<ReturnType<typeof getPlatformSession>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformSession>>,
          TError,
          Awaited<ReturnType<typeof getPlatformSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformSession<TData = Awaited<ReturnType<typeof getPlatformSession>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSession>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Describe the current platform session
 */

export function useGetPlatformSession<TData = Awaited<ReturnType<typeof getPlatformSession>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSession>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformSessionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listTenantsResponse200 = {
  data: TenantPage
  status: 200
}

export type listTenantsResponse400 = {
  data: ApiError
  status: 400
}

export type listTenantsResponse401 = {
  data: ApiError
  status: 401
}

export type listTenantsResponse500 = {
  data: ApiError
  status: 500
}

export type listTenantsResponseSuccess = (listTenantsResponse200) & {
  headers: Headers;
};
export type listTenantsResponseError = (listTenantsResponse400 | listTenantsResponse401 | listTenantsResponse500) & {
  headers: Headers;
};

export type listTenantsResponse = (listTenantsResponseSuccess | listTenantsResponseError)

export const getListTenantsUrl = (params?: ListTenantsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/platform/tenants?${stringifiedParams}` : `/platform/tenants`
}

/**
 * The estate: every company on this platform, filtered, sorted and paged server-side, each with its account census. `canSignIn` is the condition worth acting on — a tenant with no account that can sign in cannot fix itself, and its superadmins are reachable at GET /platform/tenants/{tenantId}/superadmins.
 * @summary List the tenants on this platform
 */
export const listTenants = async (params?: ListTenantsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listTenantsResponse> => {

  return apiFetch<listTenantsResponse>(getListTenantsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTenantsQueryKey = (params?: ListTenantsParams,) => {
    return [
    `/platform/tenants`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTenantsQueryOptions = <TData = Awaited<ReturnType<typeof listTenants>>, TError = ApiError>(params?: ListTenantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTenantsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTenants>>> = ({ signal }) => listTenants(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof listTenants>>>
export type ListTenantsQueryError = ApiError


export function useListTenants<TData = Awaited<ReturnType<typeof listTenants>>, TError = ApiError>(
 params: undefined |  ListTenantsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTenants>>,
          TError,
          Awaited<ReturnType<typeof listTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTenants<TData = Awaited<ReturnType<typeof listTenants>>, TError = ApiError>(
 params?: ListTenantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTenants>>,
          TError,
          Awaited<ReturnType<typeof listTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTenants<TData = Awaited<ReturnType<typeof listTenants>>, TError = ApiError>(
 params?: ListTenantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the tenants on this platform
 */

export function useListTenants<TData = Awaited<ReturnType<typeof listTenants>>, TError = ApiError>(
 params?: ListTenantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTenantsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createTenantResponse201 = {
  data: CreateTenantResponse
  status: 201
}

export type createTenantResponse400 = {
  data: ApiError
  status: 400
}

export type createTenantResponse401 = {
  data: ApiError
  status: 401
}

export type createTenantResponse409 = {
  data: ApiError
  status: 409
}

export type createTenantResponse500 = {
  data: ApiError
  status: 500
}

export type createTenantResponseSuccess = (createTenantResponse201) & {
  headers: Headers;
};
export type createTenantResponseError = (createTenantResponse400 | createTenantResponse401 | createTenantResponse409 | createTenantResponse500) & {
  headers: Headers;
};

export type createTenantResponse = (createTenantResponseSuccess | createTenantResponseError)

export const getCreateTenantUrl = () => {




  return `/platform/tenants`
}

/**
 * Creates the tenant row, its configuration and its **first superadmin** in one call, and returns that superadmin’s activation link **once**. One call rather than three, because three calls from a browser have two partial failures and both of them produce a company that exists and nobody can enter.
 *
 * The link in the response is the only time its value exists outside this request: the server stores a hash. Read it once, hand it over, and mint a new one if it is lost.
 *
 * **Two failures need different recoveries and therefore have their own codes.** `slug_taken` means the slug is gone permanently — including to a retired tenant — so the answer is to look it up rather than to pick another; and `tenant_without_superadmin` means the tenant **was** created and its administrator was not, so the recovery is to open that tenant and create a superadmin there. Creating the tenant again would fail on the slug it just reserved.
 * @summary Create a tenant, its first superadmin and their activation link
 */
export const createTenant = async (createTenantRequest: CreateTenantRequest, options?: Parameters<typeof apiFetch>[1]): Promise<createTenantResponse> => {

  return apiFetch<createTenantResponse>(getCreateTenantUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTenantRequest)
  }
);}





export const getCreateTenantMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenant>>, TError,{data: CreateTenantRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTenant>>, TError,{data: CreateTenantRequest}, TContext> => {

const mutationKey = ['createTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTenant>>, {data: CreateTenantRequest}> = (props) => {
          const {data} = props ?? {};

          return  createTenant(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTenantMutationResult = NonNullable<Awaited<ReturnType<typeof createTenant>>>
    export type CreateTenantMutationBody = CreateTenantRequest
    export type CreateTenantMutationError = ApiError

    /**
 * @summary Create a tenant, its first superadmin and their activation link
 */
export const useCreateTenant = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenant>>, TError,{data: CreateTenantRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTenant>>,
        TError,
        {data: CreateTenantRequest},
        TContext
      > => {
      return useMutation(getCreateTenantMutationOptions(options), queryClient);
    }

export type getTenantResponse200 = {
  data: Tenant
  status: 200
}

export type getTenantResponse400 = {
  data: ApiError
  status: 400
}

export type getTenantResponse401 = {
  data: ApiError
  status: 401
}

export type getTenantResponse404 = {
  data: ApiError
  status: 404
}

export type getTenantResponse500 = {
  data: ApiError
  status: 500
}

export type getTenantResponseSuccess = (getTenantResponse200) & {
  headers: Headers;
};
export type getTenantResponseError = (getTenantResponse400 | getTenantResponse401 | getTenantResponse404 | getTenantResponse500) & {
  headers: Headers;
};

export type getTenantResponse = (getTenantResponseSuccess | getTenantResponseError)

export const getGetTenantUrl = (tenantId: string,) => {




  return `/platform/tenants/${tenantId}`
}

/**
 * Everything this tier knows about one tenancy: identity, configuration, its account census and how many sign-ins are live. **Nothing about the work inside it** — no assignment, no report, no client, no premises, no photograph. The platform owner administers tenancies, not the cleaning.
 * @summary Read one tenant
 */
export const getTenant = async (tenantId: string, options?: Parameters<typeof apiFetch>[1]): Promise<getTenantResponse> => {

  return apiFetch<getTenantResponse>(getGetTenantUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTenantQueryKey = (tenantId: string,) => {
    return [
    `/platform/tenants/${tenantId}`
    ] as const;
    }


export const getGetTenantQueryOptions = <TData = Awaited<ReturnType<typeof getTenant>>, TError = ApiError>(tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantQueryKey(tenantId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenant>>> = ({ signal }) => getTenant(tenantId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantQueryResult = NonNullable<Awaited<ReturnType<typeof getTenant>>>
export type GetTenantQueryError = ApiError


export function useGetTenant<TData = Awaited<ReturnType<typeof getTenant>>, TError = ApiError>(
 tenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenant>>,
          TError,
          Awaited<ReturnType<typeof getTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenant<TData = Awaited<ReturnType<typeof getTenant>>, TError = ApiError>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenant>>,
          TError,
          Awaited<ReturnType<typeof getTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenant<TData = Awaited<ReturnType<typeof getTenant>>, TError = ApiError>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read one tenant
 */

export function useGetTenant<TData = Awaited<ReturnType<typeof getTenant>>, TError = ApiError>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantQueryOptions(tenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type updateTenantResponse200 = {
  data: Tenant
  status: 200
}

export type updateTenantResponse400 = {
  data: ApiError
  status: 400
}

export type updateTenantResponse401 = {
  data: ApiError
  status: 401
}

export type updateTenantResponse404 = {
  data: ApiError
  status: 404
}

export type updateTenantResponse409 = {
  data: ApiError
  status: 409
}

export type updateTenantResponse500 = {
  data: ApiError
  status: 500
}

export type updateTenantResponseSuccess = (updateTenantResponse200) & {
  headers: Headers;
};
export type updateTenantResponseError = (updateTenantResponse400 | updateTenantResponse401 | updateTenantResponse404 | updateTenantResponse409 | updateTenantResponse500) & {
  headers: Headers;
};

export type updateTenantResponse = (updateTenantResponseSuccess | updateTenantResponseError)

export const getUpdateTenantUrl = (tenantId: string,) => {




  return `/platform/tenants/${tenantId}`
}

/**
 * The three things about a tenant that change after it exists. The timezone is validated as an IANA name before it is written, and stored in its canonical letter case (`europe/berlin` becomes `Europe/Berlin`); the default locale must be one of the enabled ones. **A retired tenant is not configured** and answers 409.
 * @summary Change a tenant’s name, timezone or locales
 */
export const updateTenant = async (tenantId: string,
    updateTenantRequest: UpdateTenantRequest, options?: Parameters<typeof apiFetch>[1]): Promise<updateTenantResponse> => {

  return apiFetch<updateTenantResponse>(getUpdateTenantUrl(tenantId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTenantRequest)
  }
);}





export const getUpdateTenantMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTenant>>, TError,{tenantId: string;data: UpdateTenantRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTenant>>, TError,{tenantId: string;data: UpdateTenantRequest}, TContext> => {

const mutationKey = ['updateTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTenant>>, {tenantId: string;data: UpdateTenantRequest}> = (props) => {
          const {tenantId,data} = props ?? {};

          return  updateTenant(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTenantMutationResult = NonNullable<Awaited<ReturnType<typeof updateTenant>>>
    export type UpdateTenantMutationBody = UpdateTenantRequest
    export type UpdateTenantMutationError = ApiError

    /**
 * @summary Change a tenant’s name, timezone or locales
 */
export const useUpdateTenant = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTenant>>, TError,{tenantId: string;data: UpdateTenantRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTenant>>,
        TError,
        {tenantId: string;data: UpdateTenantRequest},
        TContext
      > => {
      return useMutation(getUpdateTenantMutationOptions(options), queryClient);
    }

export type retireTenantResponse200 = {
  data: RetireTenantResponse
  status: 200
}

export type retireTenantResponse400 = {
  data: ApiError
  status: 400
}

export type retireTenantResponse401 = {
  data: ApiError
  status: 401
}

export type retireTenantResponse404 = {
  data: ApiError
  status: 404
}

export type retireTenantResponse409 = {
  data: ApiError
  status: 409
}

export type retireTenantResponse500 = {
  data: ApiError
  status: 500
}

export type retireTenantResponseSuccess = (retireTenantResponse200) & {
  headers: Headers;
};
export type retireTenantResponseError = (retireTenantResponse400 | retireTenantResponse401 | retireTenantResponse404 | retireTenantResponse409 | retireTenantResponse500) & {
  headers: Headers;
};

export type retireTenantResponse = (retireTenantResponseSuccess | retireTenantResponseError)

export const getRetireTenantUrl = (tenantId: string,) => {




  return `/platform/tenants/${tenantId}/retirement`
}

/**
 * Ends a tenancy without destroying its record: a soft delete on the tenant row. Nothing is deleted — reports, users, assignments and media stay, because a contract ends and its records outlive it.
 *
 * What it does: that tenant’s **builds stop working** (a build identifier naming a retired tenant is refused), and **every live session in the tenant is revoked in the same operation**, so nobody keeps working on a token they already hold. The response says how many sessions that was.
 *
 * What it does **not** do: free the slug, which stays reserved forever; tear down the tenant’s published hostnames, which is a separate deployment step; or delete anything. There is no un-retire.
 * @summary Retire a tenant, and sign everybody in it out
 */
export const retireTenant = async (tenantId: string, options?: Parameters<typeof apiFetch>[1]): Promise<retireTenantResponse> => {

  return apiFetch<retireTenantResponse>(getRetireTenantUrl(tenantId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetireTenantMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retireTenant>>, TError,{tenantId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retireTenant>>, TError,{tenantId: string}, TContext> => {

const mutationKey = ['retireTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retireTenant>>, {tenantId: string}> = (props) => {
          const {tenantId} = props ?? {};

          return  retireTenant(tenantId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetireTenantMutationResult = NonNullable<Awaited<ReturnType<typeof retireTenant>>>

    export type RetireTenantMutationError = ApiError

    /**
 * @summary Retire a tenant, and sign everybody in it out
 */
export const useRetireTenant = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retireTenant>>, TError,{tenantId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retireTenant>>,
        TError,
        {tenantId: string},
        TContext
      > => {
      return useMutation(getRetireTenantMutationOptions(options), queryClient);
    }

export type listTenantSuperadminsResponse200 = {
  data: TenantSuperadmin[]
  status: 200
}

export type listTenantSuperadminsResponse400 = {
  data: ApiError
  status: 400
}

export type listTenantSuperadminsResponse401 = {
  data: ApiError
  status: 401
}

export type listTenantSuperadminsResponse404 = {
  data: ApiError
  status: 404
}

export type listTenantSuperadminsResponse500 = {
  data: ApiError
  status: 500
}

export type listTenantSuperadminsResponseSuccess = (listTenantSuperadminsResponse200) & {
  headers: Headers;
};
export type listTenantSuperadminsResponseError = (listTenantSuperadminsResponse400 | listTenantSuperadminsResponse401 | listTenantSuperadminsResponse404 | listTenantSuperadminsResponse500) & {
  headers: Headers;
};

export type listTenantSuperadminsResponse = (listTenantSuperadminsResponseSuccess | listTenantSuperadminsResponseError)

export const getListTenantSuperadminsUrl = (tenantId: string,) => {




  return `/platform/tenants/${tenantId}/superadmins`
}

/**
 * **Superadmins only** — not every user, and the narrowness is the point. A tenant that cannot sign in has no way to fix itself, because minting an invite is an admin action inside the tenant and there is no admin; this endpoint plus the two below are the way back in. Everything else about that tenant’s users belongs to its own administrators.
 *
 * Each account carries the **state** of its most recent link — outstanding, used, expired or revoked — of either purpose, so a redeemed invite reads `used` rather than being left out, and **never a token.**
 * @summary List a tenant’s superadmin accounts
 */
export const listTenantSuperadmins = async (tenantId: string, options?: Parameters<typeof apiFetch>[1]): Promise<listTenantSuperadminsResponse> => {

  return apiFetch<listTenantSuperadminsResponse>(getListTenantSuperadminsUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTenantSuperadminsQueryKey = (tenantId: string,) => {
    return [
    `/platform/tenants/${tenantId}/superadmins`
    ] as const;
    }


export const getListTenantSuperadminsQueryOptions = <TData = Awaited<ReturnType<typeof listTenantSuperadmins>>, TError = ApiError>(tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenantSuperadmins>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTenantSuperadminsQueryKey(tenantId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTenantSuperadmins>>> = ({ signal }) => listTenantSuperadmins(tenantId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTenantSuperadmins>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTenantSuperadminsQueryResult = NonNullable<Awaited<ReturnType<typeof listTenantSuperadmins>>>
export type ListTenantSuperadminsQueryError = ApiError


export function useListTenantSuperadmins<TData = Awaited<ReturnType<typeof listTenantSuperadmins>>, TError = ApiError>(
 tenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenantSuperadmins>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTenantSuperadmins>>,
          TError,
          Awaited<ReturnType<typeof listTenantSuperadmins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTenantSuperadmins<TData = Awaited<ReturnType<typeof listTenantSuperadmins>>, TError = ApiError>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenantSuperadmins>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTenantSuperadmins>>,
          TError,
          Awaited<ReturnType<typeof listTenantSuperadmins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTenantSuperadmins<TData = Awaited<ReturnType<typeof listTenantSuperadmins>>, TError = ApiError>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenantSuperadmins>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a tenant’s superadmin accounts
 */

export function useListTenantSuperadmins<TData = Awaited<ReturnType<typeof listTenantSuperadmins>>, TError = ApiError>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenantSuperadmins>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTenantSuperadminsQueryOptions(tenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createTenantSuperadminResponse201 = {
  data: MintedAccountLinkResponse
  status: 201
}

export type createTenantSuperadminResponse400 = {
  data: ApiError
  status: 400
}

export type createTenantSuperadminResponse401 = {
  data: ApiError
  status: 401
}

export type createTenantSuperadminResponse404 = {
  data: ApiError
  status: 404
}

export type createTenantSuperadminResponse409 = {
  data: ApiError
  status: 409
}

export type createTenantSuperadminResponse500 = {
  data: ApiError
  status: 500
}

export type createTenantSuperadminResponseSuccess = (createTenantSuperadminResponse201) & {
  headers: Headers;
};
export type createTenantSuperadminResponseError = (createTenantSuperadminResponse400 | createTenantSuperadminResponse401 | createTenantSuperadminResponse404 | createTenantSuperadminResponse409 | createTenantSuperadminResponse500) & {
  headers: Headers;
};

export type createTenantSuperadminResponse = (createTenantSuperadminResponseSuccess | createTenantSuperadminResponseError)

export const getCreateTenantSuperadminUrl = (tenantId: string,) => {




  return `/platform/tenants/${tenantId}/superadmins`
}

/**
 * The recovery for a tenant nobody can get into — including one created by a call whose response never arrived. It creates a **pending** superadmin with the nickname this request names, and returns their activation link once; the person chooses their own **password** when they redeem it, and is not asked for a nickname. Absent on a retired tenant: a link minted there would be redeemable only at an address that refuses every request.
 * @summary Create a superadmin in an existing tenant
 */
export const createTenantSuperadmin = async (tenantId: string,
    createSuperadminRequest: CreateSuperadminRequest, options?: Parameters<typeof apiFetch>[1]): Promise<createTenantSuperadminResponse> => {

  return apiFetch<createTenantSuperadminResponse>(getCreateTenantSuperadminUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSuperadminRequest)
  }
);}





export const getCreateTenantSuperadminMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenantSuperadmin>>, TError,{tenantId: string;data: CreateSuperadminRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTenantSuperadmin>>, TError,{tenantId: string;data: CreateSuperadminRequest}, TContext> => {

const mutationKey = ['createTenantSuperadmin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTenantSuperadmin>>, {tenantId: string;data: CreateSuperadminRequest}> = (props) => {
          const {tenantId,data} = props ?? {};

          return  createTenantSuperadmin(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTenantSuperadminMutationResult = NonNullable<Awaited<ReturnType<typeof createTenantSuperadmin>>>
    export type CreateTenantSuperadminMutationBody = CreateSuperadminRequest
    export type CreateTenantSuperadminMutationError = ApiError

    /**
 * @summary Create a superadmin in an existing tenant
 */
export const useCreateTenantSuperadmin = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenantSuperadmin>>, TError,{tenantId: string;data: CreateSuperadminRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTenantSuperadmin>>,
        TError,
        {tenantId: string;data: CreateSuperadminRequest},
        TContext
      > => {
      return useMutation(getCreateTenantSuperadminMutationOptions(options), queryClient);
    }

export type mintTenantSuperadminLinkResponse201 = {
  data: MintedAccountLinkResponse
  status: 201
}

export type mintTenantSuperadminLinkResponse400 = {
  data: ApiError
  status: 400
}

export type mintTenantSuperadminLinkResponse401 = {
  data: ApiError
  status: 401
}

export type mintTenantSuperadminLinkResponse404 = {
  data: ApiError
  status: 404
}

export type mintTenantSuperadminLinkResponse409 = {
  data: ApiError
  status: 409
}

export type mintTenantSuperadminLinkResponse500 = {
  data: ApiError
  status: 500
}

export type mintTenantSuperadminLinkResponseSuccess = (mintTenantSuperadminLinkResponse201) & {
  headers: Headers;
};
export type mintTenantSuperadminLinkResponseError = (mintTenantSuperadminLinkResponse400 | mintTenantSuperadminLinkResponse401 | mintTenantSuperadminLinkResponse404 | mintTenantSuperadminLinkResponse409 | mintTenantSuperadminLinkResponse500) & {
  headers: Headers;
};

export type mintTenantSuperadminLinkResponse = (mintTenantSuperadminLinkResponseSuccess | mintTenantSuperadminLinkResponseError)

export const getMintTenantSuperadminLinkUrl = (tenantId: string,
    userId: string,) => {




  return `/platform/tenants/${tenantId}/superadmins/${userId}/links`
}

/**
 * Mints an **activation** link for a pending account or a **password-reset** link for an active one — the account’s state decides, because it decides which link is redeemable at all. It **revokes that person’s outstanding link of the same purpose first**, so two credentials for one account are never circulating.
 *
 * Say what this is: minting a reset link for a tenant’s superadmin lets the platform owner take over that account. It is the only operation on this tier that reaches inside a tenant, it exists because there is no email in this system, and the console confirms it in those words.
 *
 * A user who is not a superadmin of this tenant is a **404**, exactly as one in another tenant is: this endpoint cannot be used to probe for ids or roles.
 * @summary Mint a fresh link for a tenant’s superadmin
 */
export const mintTenantSuperadminLink = async (tenantId: string,
    userId: string, options?: Parameters<typeof apiFetch>[1]): Promise<mintTenantSuperadminLinkResponse> => {

  return apiFetch<mintTenantSuperadminLinkResponse>(getMintTenantSuperadminLinkUrl(tenantId,userId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMintTenantSuperadminLinkMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mintTenantSuperadminLink>>, TError,{tenantId: string;userId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof mintTenantSuperadminLink>>, TError,{tenantId: string;userId: string}, TContext> => {

const mutationKey = ['mintTenantSuperadminLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mintTenantSuperadminLink>>, {tenantId: string;userId: string}> = (props) => {
          const {tenantId,userId} = props ?? {};

          return  mintTenantSuperadminLink(tenantId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MintTenantSuperadminLinkMutationResult = NonNullable<Awaited<ReturnType<typeof mintTenantSuperadminLink>>>

    export type MintTenantSuperadminLinkMutationError = ApiError

    /**
 * @summary Mint a fresh link for a tenant’s superadmin
 */
export const useMintTenantSuperadminLink = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mintTenantSuperadminLink>>, TError,{tenantId: string;userId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mintTenantSuperadminLink>>,
        TError,
        {tenantId: string;userId: string},
        TContext
      > => {
      return useMutation(getMintTenantSuperadminLinkMutationOptions(options), queryClient);
    }

export type getTenantBrandingConfigResponse200 = {
  data: StoredWhiteLabelConfig
  status: 200
}

export type getTenantBrandingConfigResponse400 = {
  data: ApiError
  status: 400
}

export type getTenantBrandingConfigResponse401 = {
  data: ApiError
  status: 401
}

export type getTenantBrandingConfigResponse404 = {
  data: ApiError
  status: 404
}

export type getTenantBrandingConfigResponse500 = {
  data: ApiError
  status: 500
}

export type getTenantBrandingConfigResponseSuccess = (getTenantBrandingConfigResponse200) & {
  headers: Headers;
};
export type getTenantBrandingConfigResponseError = (getTenantBrandingConfigResponse400 | getTenantBrandingConfigResponse401 | getTenantBrandingConfigResponse404 | getTenantBrandingConfigResponse500) & {
  headers: Headers;
};

export type getTenantBrandingConfigResponse = (getTenantBrandingConfigResponseSuccess | getTenantBrandingConfigResponseError)

export const getGetTenantBrandingConfigUrl = (tenantId: string,) => {




  return `/platform/tenants/${tenantId}/branding-config`
}

/**
 * The same file the public `GET /branding/<slug>.json` route serves — generated through the identical `@t4s/white-label` generator (`docs/DECISIONS.md`, "The branding config file …", "One generator, two callers") — with the one difference that is the entire reason this operation exists rather than reusing the public one: **a retired tenant’s real branding, not the neutral default.** The public route deliberately cannot tell a retired tenant from one that never existed; this one is behind the platform realm, already knows which tenant it is asking about, and answers its real presentation regardless of state.
 *
 * **It is not a credential.** No masking, no reveal step, no once-only handling, no expiry (`docs/DECISIONS.md`, "The platform console’s config-file download is not a credential") — download it as many times as useful. `buildKey` is a plain field in the JSON body, copied verbatim from the tenant row: this endpoint mints nothing and needs no clock, so two downloads in a row return the identical value unless a rotation happened in between.
 *
 * **`colors.brand` and `logoUrl` are exactly what is stored** (`StoredWhiteLabelConfig`), even where the public route serves a fallback instead: a stored brand colour longer than the 64 characters a write accepts is returned in full, and a stored logo URL that is not https:// is returned as stored. This is the one read that shows such a value — the console’s Branding screen names its length (`docs/ux/PLATFORM-ADMIN.md` §13.4). Every other field matches the public file, fallbacks included.
 * @summary Download this tenant’s white-label branding config file
 */
export const getTenantBrandingConfig = async (tenantId: string, options?: Parameters<typeof apiFetch>[1]): Promise<getTenantBrandingConfigResponse> => {

  return apiFetch<getTenantBrandingConfigResponse>(getGetTenantBrandingConfigUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTenantBrandingConfigQueryKey = (tenantId: string,) => {
    return [
    `/platform/tenants/${tenantId}/branding-config`
    ] as const;
    }


export const getGetTenantBrandingConfigQueryOptions = <TData = Awaited<ReturnType<typeof getTenantBrandingConfig>>, TError = ApiError>(tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantBrandingConfig>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantBrandingConfigQueryKey(tenantId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantBrandingConfig>>> = ({ signal }) => getTenantBrandingConfig(tenantId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenantBrandingConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantBrandingConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantBrandingConfig>>>
export type GetTenantBrandingConfigQueryError = ApiError


export function useGetTenantBrandingConfig<TData = Awaited<ReturnType<typeof getTenantBrandingConfig>>, TError = ApiError>(
 tenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantBrandingConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantBrandingConfig>>,
          TError,
          Awaited<ReturnType<typeof getTenantBrandingConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantBrandingConfig<TData = Awaited<ReturnType<typeof getTenantBrandingConfig>>, TError = ApiError>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantBrandingConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantBrandingConfig>>,
          TError,
          Awaited<ReturnType<typeof getTenantBrandingConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantBrandingConfig<TData = Awaited<ReturnType<typeof getTenantBrandingConfig>>, TError = ApiError>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantBrandingConfig>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download this tenant’s white-label branding config file
 */

export function useGetTenantBrandingConfig<TData = Awaited<ReturnType<typeof getTenantBrandingConfig>>, TError = ApiError>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantBrandingConfig>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantBrandingConfigQueryOptions(tenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type rotateTenantBuildKeyResponse200 = {
  data: TenantBuildKey
  status: 200
}

export type rotateTenantBuildKeyResponse400 = {
  data: ApiError
  status: 400
}

export type rotateTenantBuildKeyResponse401 = {
  data: ApiError
  status: 401
}

export type rotateTenantBuildKeyResponse404 = {
  data: ApiError
  status: 404
}

export type rotateTenantBuildKeyResponse409 = {
  data: ApiError
  status: 409
}

export type rotateTenantBuildKeyResponse500 = {
  data: ApiError
  status: 500
}

export type rotateTenantBuildKeyResponseSuccess = (rotateTenantBuildKeyResponse200) & {
  headers: Headers;
};
export type rotateTenantBuildKeyResponseError = (rotateTenantBuildKeyResponse400 | rotateTenantBuildKeyResponse401 | rotateTenantBuildKeyResponse404 | rotateTenantBuildKeyResponse409 | rotateTenantBuildKeyResponse500) & {
  headers: Headers;
};

export type rotateTenantBuildKeyResponse = (rotateTenantBuildKeyResponseSuccess | rotateTenantBuildKeyResponseError)

export const getRotateTenantBuildKeyUrl = (tenantId: string,) => {




  return `/platform/tenants/${tenantId}/build-key/rotation`
}

/**
 * **Destructive.** Replaces the tenant’s build key with a fresh, unguessable value. Every build carrying the old value — every installed app, every cached web bundle — stops being able to reach `POST /auth/login` or `GET /tenant/config` for this tenant from its very next request, answering `build_identifier_invalid` (`docs/DECISIONS.md`, "The build identifier is a plain rotatable key on the tenant row, not a signed, kid-rotated token"). This is the entire kill switch — there is no grace period and no way to keep the old value working alongside the new one.
 *
 * What it does **not** reach: sessions a build already issued. A client holding a token that simply stops sending the header keeps working until its session expires, and `POST /auth/refresh` takes no build key at all.
 * @summary Rotate a tenant’s build key — the kill switch for its builds
 */
export const rotateTenantBuildKey = async (tenantId: string, options?: Parameters<typeof apiFetch>[1]): Promise<rotateTenantBuildKeyResponse> => {

  return apiFetch<rotateTenantBuildKeyResponse>(getRotateTenantBuildKeyUrl(tenantId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRotateTenantBuildKeyMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateTenantBuildKey>>, TError,{tenantId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rotateTenantBuildKey>>, TError,{tenantId: string}, TContext> => {

const mutationKey = ['rotateTenantBuildKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rotateTenantBuildKey>>, {tenantId: string}> = (props) => {
          const {tenantId} = props ?? {};

          return  rotateTenantBuildKey(tenantId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RotateTenantBuildKeyMutationResult = NonNullable<Awaited<ReturnType<typeof rotateTenantBuildKey>>>

    export type RotateTenantBuildKeyMutationError = ApiError

    /**
 * @summary Rotate a tenant’s build key — the kill switch for its builds
 */
export const useRotateTenantBuildKey = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateTenantBuildKey>>, TError,{tenantId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rotateTenantBuildKey>>,
        TError,
        {tenantId: string},
        TContext
      > => {
      return useMutation(getRotateTenantBuildKeyMutationOptions(options), queryClient);
    }

export type updateTenantBrandingResponse200 = {
  data: StoredWhiteLabelConfig
  status: 200
}

export type updateTenantBrandingResponse400 = {
  data: ApiError
  status: 400
}

export type updateTenantBrandingResponse401 = {
  data: ApiError
  status: 401
}

export type updateTenantBrandingResponse404 = {
  data: ApiError
  status: 404
}

export type updateTenantBrandingResponse409 = {
  data: ApiError
  status: 409
}

export type updateTenantBrandingResponse500 = {
  data: ApiError
  status: 500
}

export type updateTenantBrandingResponseSuccess = (updateTenantBrandingResponse200) & {
  headers: Headers;
};
export type updateTenantBrandingResponseError = (updateTenantBrandingResponse400 | updateTenantBrandingResponse401 | updateTenantBrandingResponse404 | updateTenantBrandingResponse409 | updateTenantBrandingResponse500) & {
  headers: Headers;
};

export type updateTenantBrandingResponse = (updateTenantBrandingResponseSuccess | updateTenantBrandingResponseError)

export const getUpdateTenantBrandingUrl = (tenantId: string,) => {




  return `/platform/tenants/${tenantId}/branding`
}

/**
 * Writes `brandColor` and/or `logoUrl`, **merging** into the stored branding document rather than replacing it — an unsent field is left exactly as it was, and a key this endpoint has no field for is preserved rather than dropped (`docs/ux/PLATFORM-ADMIN.md` §13.1). Response is the regenerated config file — the same shape `GET /platform/tenants/{tenantId}/branding-config` returns — so a save and its confirmation can never disagree about what was stored.
 *
 * **Never accepts, computes or stores `corrected` or `fallback`.** Those are derived in the browser, at render time, by `@t4s/ui/tokens`’ `buildColors` — this endpoint’s request and response schemas have no field for either (`docs/ux/PLATFORM-ADMIN.md` §13.2, §22). **A retired tenant is read-only** and answers 409.
 * @summary Change a tenant’s branding presentation — brand colour and logo
 */
export const updateTenantBranding = async (tenantId: string,
    updateBrandingRequest: UpdateBrandingRequest, options?: Parameters<typeof apiFetch>[1]): Promise<updateTenantBrandingResponse> => {

  return apiFetch<updateTenantBrandingResponse>(getUpdateTenantBrandingUrl(tenantId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateBrandingRequest)
  }
);}





export const getUpdateTenantBrandingMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTenantBranding>>, TError,{tenantId: string;data: UpdateBrandingRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTenantBranding>>, TError,{tenantId: string;data: UpdateBrandingRequest}, TContext> => {

const mutationKey = ['updateTenantBranding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTenantBranding>>, {tenantId: string;data: UpdateBrandingRequest}> = (props) => {
          const {tenantId,data} = props ?? {};

          return  updateTenantBranding(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTenantBrandingMutationResult = NonNullable<Awaited<ReturnType<typeof updateTenantBranding>>>
    export type UpdateTenantBrandingMutationBody = UpdateBrandingRequest
    export type UpdateTenantBrandingMutationError = ApiError

    /**
 * @summary Change a tenant’s branding presentation — brand colour and logo
 */
export const useUpdateTenantBranding = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTenantBranding>>, TError,{tenantId: string;data: UpdateBrandingRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTenantBranding>>,
        TError,
        {tenantId: string;data: UpdateBrandingRequest},
        TContext
      > => {
      return useMutation(getUpdateTenantBrandingMutationOptions(options), queryClient);
    }

export type listFeatureFlagCatalogueResponse200 = {
  data: FeatureFlagCatalogueEntry[]
  status: 200
}

export type listFeatureFlagCatalogueResponse401 = {
  data: ApiError
  status: 401
}

export type listFeatureFlagCatalogueResponse500 = {
  data: ApiError
  status: 500
}

export type listFeatureFlagCatalogueResponseSuccess = (listFeatureFlagCatalogueResponse200) & {
  headers: Headers;
};
export type listFeatureFlagCatalogueResponseError = (listFeatureFlagCatalogueResponse401 | listFeatureFlagCatalogueResponse500) & {
  headers: Headers;
};

export type listFeatureFlagCatalogueResponse = (listFeatureFlagCatalogueResponseSuccess | listFeatureFlagCatalogueResponseError)

export const getListFeatureFlagCatalogueUrl = () => {




  return `/platform/feature-flags`
}

/**
 * **The catalogue itself is the secret** (`docs/ux/PLATFORM-ADMIN.md` §14.3): every key the platform can switch on for a tenant, readable only behind this platform-realm route. A tenant’s own config and access endpoints answer with a **resolved** map — which of these apply to that tenant — and never with this list. `[]` today: this task ships the mechanism, not any entries, and an empty catalogue is the deliberate, honest state rather than an error (§14.4).
 * @summary The platform’s feature-flag catalogue
 */
export const listFeatureFlagCatalogue = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listFeatureFlagCatalogueResponse> => {

  return apiFetch<listFeatureFlagCatalogueResponse>(getListFeatureFlagCatalogueUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFeatureFlagCatalogueQueryKey = () => {
    return [
    `/platform/feature-flags`
    ] as const;
    }


export const getListFeatureFlagCatalogueQueryOptions = <TData = Awaited<ReturnType<typeof listFeatureFlagCatalogue>>, TError = ApiError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeatureFlagCatalogue>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFeatureFlagCatalogueQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeatureFlagCatalogue>>> = ({ signal }) => listFeatureFlagCatalogue({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFeatureFlagCatalogue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListFeatureFlagCatalogueQueryResult = NonNullable<Awaited<ReturnType<typeof listFeatureFlagCatalogue>>>
export type ListFeatureFlagCatalogueQueryError = ApiError


export function useListFeatureFlagCatalogue<TData = Awaited<ReturnType<typeof listFeatureFlagCatalogue>>, TError = ApiError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeatureFlagCatalogue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFeatureFlagCatalogue>>,
          TError,
          Awaited<ReturnType<typeof listFeatureFlagCatalogue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFeatureFlagCatalogue<TData = Awaited<ReturnType<typeof listFeatureFlagCatalogue>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeatureFlagCatalogue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFeatureFlagCatalogue>>,
          TError,
          Awaited<ReturnType<typeof listFeatureFlagCatalogue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFeatureFlagCatalogue<TData = Awaited<ReturnType<typeof listFeatureFlagCatalogue>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeatureFlagCatalogue>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The platform’s feature-flag catalogue
 */

export function useListFeatureFlagCatalogue<TData = Awaited<ReturnType<typeof listFeatureFlagCatalogue>>, TError = ApiError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeatureFlagCatalogue>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFeatureFlagCatalogueQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getTenantFeatureFlagsResponse200 = {
  data: TenantFeatureFlags
  status: 200
}

export type getTenantFeatureFlagsResponse400 = {
  data: ApiError
  status: 400
}

export type getTenantFeatureFlagsResponse401 = {
  data: ApiError
  status: 401
}

export type getTenantFeatureFlagsResponse404 = {
  data: ApiError
  status: 404
}

export type getTenantFeatureFlagsResponse500 = {
  data: ApiError
  status: 500
}

export type getTenantFeatureFlagsResponseSuccess = (getTenantFeatureFlagsResponse200) & {
  headers: Headers;
};
export type getTenantFeatureFlagsResponseError = (getTenantFeatureFlagsResponse400 | getTenantFeatureFlagsResponse401 | getTenantFeatureFlagsResponse404 | getTenantFeatureFlagsResponse500) & {
  headers: Headers;
};

export type getTenantFeatureFlagsResponse = (getTenantFeatureFlagsResponseSuccess | getTenantFeatureFlagsResponseError)

export const getGetTenantFeatureFlagsUrl = (tenantId: string,) => {




  return `/platform/tenants/${tenantId}/feature-flags`
}

/**
 * This tenant’s flags, resolved through the identical filter `GET /tenant/config` and `GET /access/features` use. Readable for a **retired** tenant — this screen is read-only (§14.4), not absent.
 * @summary Read one tenant’s resolved feature flags
 */
export const getTenantFeatureFlags = async (tenantId: string, options?: Parameters<typeof apiFetch>[1]): Promise<getTenantFeatureFlagsResponse> => {

  return apiFetch<getTenantFeatureFlagsResponse>(getGetTenantFeatureFlagsUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTenantFeatureFlagsQueryKey = (tenantId: string,) => {
    return [
    `/platform/tenants/${tenantId}/feature-flags`
    ] as const;
    }


export const getGetTenantFeatureFlagsQueryOptions = <TData = Awaited<ReturnType<typeof getTenantFeatureFlags>>, TError = ApiError>(tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantFeatureFlags>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantFeatureFlagsQueryKey(tenantId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantFeatureFlags>>> = ({ signal }) => getTenantFeatureFlags(tenantId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenantFeatureFlags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantFeatureFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantFeatureFlags>>>
export type GetTenantFeatureFlagsQueryError = ApiError


export function useGetTenantFeatureFlags<TData = Awaited<ReturnType<typeof getTenantFeatureFlags>>, TError = ApiError>(
 tenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantFeatureFlags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantFeatureFlags>>,
          TError,
          Awaited<ReturnType<typeof getTenantFeatureFlags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantFeatureFlags<TData = Awaited<ReturnType<typeof getTenantFeatureFlags>>, TError = ApiError>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantFeatureFlags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantFeatureFlags>>,
          TError,
          Awaited<ReturnType<typeof getTenantFeatureFlags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantFeatureFlags<TData = Awaited<ReturnType<typeof getTenantFeatureFlags>>, TError = ApiError>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantFeatureFlags>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read one tenant’s resolved feature flags
 */

export function useGetTenantFeatureFlags<TData = Awaited<ReturnType<typeof getTenantFeatureFlags>>, TError = ApiError>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantFeatureFlags>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantFeatureFlagsQueryOptions(tenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type setTenantFeatureFlagResponse200 = {
  data: TenantFeatureFlags
  status: 200
}

export type setTenantFeatureFlagResponse400 = {
  data: ApiError
  status: 400
}

export type setTenantFeatureFlagResponse401 = {
  data: ApiError
  status: 401
}

export type setTenantFeatureFlagResponse404 = {
  data: ApiError
  status: 404
}

export type setTenantFeatureFlagResponse409 = {
  data: ApiError
  status: 409
}

export type setTenantFeatureFlagResponse500 = {
  data: ApiError
  status: 500
}

export type setTenantFeatureFlagResponseSuccess = (setTenantFeatureFlagResponse200) & {
  headers: Headers;
};
export type setTenantFeatureFlagResponseError = (setTenantFeatureFlagResponse400 | setTenantFeatureFlagResponse401 | setTenantFeatureFlagResponse404 | setTenantFeatureFlagResponse409 | setTenantFeatureFlagResponse500) & {
  headers: Headers;
};

export type setTenantFeatureFlagResponse = (setTenantFeatureFlagResponseSuccess | setTenantFeatureFlagResponseError)

export const getSetTenantFeatureFlagUrl = (tenantId: string,
    key: string,) => {




  return `/platform/tenants/${tenantId}/feature-flags/${key}`
}

/**
 * Saves exactly this one key, leaving every other key in the tenant’s map untouched — `docs/ux/PLATFORM-ADMIN.md` §14.1’s per-row save, not a form holding a batch of pending edits. Idempotent: setting a key to the value it already holds is not an error. Takes effect on the tenant’s next request, because flags are resolved server-side (`docs/DECISIONS.md`, "Feature flags"). **A retired tenant is read-only** and answers 409. This endpoint does not check the key against the catalogue — see this pull request’s notes for why.
 * @summary Set one flag on one tenant
 */
export const setTenantFeatureFlag = async (tenantId: string,
    key: string,
    setFeatureFlagRequest: SetFeatureFlagRequest, options?: Parameters<typeof apiFetch>[1]): Promise<setTenantFeatureFlagResponse> => {

  return apiFetch<setTenantFeatureFlagResponse>(getSetTenantFeatureFlagUrl(tenantId,key),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setFeatureFlagRequest)
  }
);}





export const getSetTenantFeatureFlagMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTenantFeatureFlag>>, TError,{tenantId: string;key: string;data: SetFeatureFlagRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setTenantFeatureFlag>>, TError,{tenantId: string;key: string;data: SetFeatureFlagRequest}, TContext> => {

const mutationKey = ['setTenantFeatureFlag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setTenantFeatureFlag>>, {tenantId: string;key: string;data: SetFeatureFlagRequest}> = (props) => {
          const {tenantId,key,data} = props ?? {};

          return  setTenantFeatureFlag(tenantId,key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetTenantFeatureFlagMutationResult = NonNullable<Awaited<ReturnType<typeof setTenantFeatureFlag>>>
    export type SetTenantFeatureFlagMutationBody = SetFeatureFlagRequest
    export type SetTenantFeatureFlagMutationError = ApiError

    /**
 * @summary Set one flag on one tenant
 */
export const useSetTenantFeatureFlag = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTenantFeatureFlag>>, TError,{tenantId: string;key: string;data: SetFeatureFlagRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setTenantFeatureFlag>>,
        TError,
        {tenantId: string;key: string;data: SetFeatureFlagRequest},
        TContext
      > => {
      return useMutation(getSetTenantFeatureFlagMutationOptions(options), queryClient);
    }

export type removeTenantFeatureFlagResponse200 = {
  data: TenantFeatureFlags
  status: 200
}

export type removeTenantFeatureFlagResponse400 = {
  data: ApiError
  status: 400
}

export type removeTenantFeatureFlagResponse401 = {
  data: ApiError
  status: 401
}

export type removeTenantFeatureFlagResponse404 = {
  data: ApiError
  status: 404
}

export type removeTenantFeatureFlagResponse409 = {
  data: ApiError
  status: 409
}

export type removeTenantFeatureFlagResponse500 = {
  data: ApiError
  status: 500
}

export type removeTenantFeatureFlagResponseSuccess = (removeTenantFeatureFlagResponse200) & {
  headers: Headers;
};
export type removeTenantFeatureFlagResponseError = (removeTenantFeatureFlagResponse400 | removeTenantFeatureFlagResponse401 | removeTenantFeatureFlagResponse404 | removeTenantFeatureFlagResponse409 | removeTenantFeatureFlagResponse500) & {
  headers: Headers;
};

export type removeTenantFeatureFlagResponse = (removeTenantFeatureFlagResponseSuccess | removeTenantFeatureFlagResponseError)

export const getRemoveTenantFeatureFlagUrl = (tenantId: string,
    key: string,) => {




  return `/platform/tenants/${tenantId}/feature-flags/${key}`
}

/**
 * `docs/ux/PLATFORM-ADMIN.md` §14.2’s action for a key the catalogue no longer describes — a flag that was renamed, or one written by a seed. Removing a key that was never present is not an error: the map comes back unchanged. **A retired tenant is read-only** and answers 409.
 * @summary Remove one flag key from one tenant
 */
export const removeTenantFeatureFlag = async (tenantId: string,
    key: string, options?: Parameters<typeof apiFetch>[1]): Promise<removeTenantFeatureFlagResponse> => {

  return apiFetch<removeTenantFeatureFlagResponse>(getRemoveTenantFeatureFlagUrl(tenantId,key),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveTenantFeatureFlagMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTenantFeatureFlag>>, TError,{tenantId: string;key: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeTenantFeatureFlag>>, TError,{tenantId: string;key: string}, TContext> => {

const mutationKey = ['removeTenantFeatureFlag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeTenantFeatureFlag>>, {tenantId: string;key: string}> = (props) => {
          const {tenantId,key} = props ?? {};

          return  removeTenantFeatureFlag(tenantId,key,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveTenantFeatureFlagMutationResult = NonNullable<Awaited<ReturnType<typeof removeTenantFeatureFlag>>>

    export type RemoveTenantFeatureFlagMutationError = ApiError

    /**
 * @summary Remove one flag key from one tenant
 */
export const useRemoveTenantFeatureFlag = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTenantFeatureFlag>>, TError,{tenantId: string;key: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeTenantFeatureFlag>>,
        TError,
        {tenantId: string;key: string},
        TContext
      > => {
      return useMutation(getRemoveTenantFeatureFlagMutationOptions(options), queryClient);
    }
